/**
 * @license Copyright (c) 2017 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 *
 * This software contains code from third-party libraries, with their licenses listed below:
 */
 /**
  * @license cross-storage 1.0.0
  * See https://github.com/zendesk/cross-storage
  * Copyright 2016 Zendesk
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  * http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software distributed under the
  * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
  * either express or implied. See the License for the specific language governing permissions
  * and limitations under the License.
  */
/**
 * @license almond 0.2.5
 * Copyright (c) 2011-2012, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */
/**
 * @license Handlebars
 * Copyright (C) 2011 by Yehuda Katz
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
/**
 * @license font-checker.js
 * Copyright 2013 by Sam Clarke under the terms of the MIT license
 * See: https://www.samclarke.com/javascript-is-font-available
 */
/**
 * @license observable.js
 * Copyright (c) 2014 Florian Rueberg under the terms of the MIT license
 * See: https://github.com/fru/observable.js/raw/master/license.md
 */
/**
 * @license q.js
 * Copyright 2009-2012 Kris Kowal under the terms of the MIT license
 * See: http://github.com/kriskowal/q/raw/master/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
!function(){var requirejs, require, define;

(function(undef) {
    var main, req, makeMap, handlers, defined = {}, waiting = {}, config = {}, defining = {}, hasOwn = Object.prototype.hasOwnProperty, aps = [].slice;
    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, foundI, foundStarMap, starI, i, j, part, baseParts = baseName && baseName.split("/"), map = config.map, starMap = map && map["*"] || {};
        if (name && name.charAt(0) === ".") {
            if (baseName) {
                baseParts = baseParts.slice(0, baseParts.length - 1);
                name = baseParts.concat(name.split("/"));
                for (i = 0; i < name.length; i += 1) {
                    part = name[i];
                    if (part === ".") {
                        name.splice(i, 1);
                        i -= 1;
                    } else if (part === "..") {
                        if (i === 1 && (name[2] === ".." || name[0] === "..")) {
                            break;
                        } else if (i > 0) {
                            name.splice(i - 1, 2);
                            i -= 2;
                        }
                    }
                }
                name = name.join("/");
            } else if (name.indexOf("./") === 0) {
                name = name.substring(2);
            }
        }
        if ((baseParts || starMap) && map) {
            nameParts = name.split("/");
            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");
                if (baseParts) {
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join("/")];
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }
                if (foundMap) {
                    break;
                }
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }
            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }
            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join("/");
            }
        }
        return name;
    }
    function makeRequire(relName, forceSync) {
        return function() {
            return req.apply(undef, aps.call(arguments, 0).concat([ relName, forceSync ]));
        };
    }
    function makeNormalize(relName) {
        return function(name) {
            return normalize(name, relName);
        };
    }
    function makeLoad(depName) {
        return function(value) {
            defined[depName] = value;
        };
    }
    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }
        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error("No " + name);
        }
        return defined[name];
    }
    function splitPrefix(name) {
        var prefix, index = name ? name.indexOf("!") : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [ prefix, name ];
    }
    makeMap = function(name, relName) {
        var plugin, parts = splitPrefix(name), prefix = parts[0];
        name = parts[1];
        if (prefix) {
            prefix = normalize(prefix, relName);
            plugin = callDep(prefix);
        }
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relName));
            } else {
                name = normalize(name, relName);
            }
        } else {
            name = normalize(name, relName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }
        return {
            f: prefix ? prefix + "!" + name : name,
            n: name,
            pr: prefix,
            p: plugin
        };
    };
    function makeConfig(name) {
        return function() {
            return config && config.config && config.config[name] || {};
        };
    }
    handlers = {
        require: function(name) {
            return makeRequire(name);
        },
        exports: function(name) {
            var e = defined[name];
            if (typeof e !== "undefined") {
                return e;
            } else {
                return defined[name] = {};
            }
        },
        module: function(name) {
            return {
                id: name,
                uri: "",
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };
    main = function(name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i, args = [], usingExports;
        relName = relName || name;
        if (typeof callback === "function") {
            deps = !deps.length && callback.length ? [ "require", "exports", "module" ] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relName);
                depName = map.f;
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) || hasProp(waiting, depName) || hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + " missing " + depName);
                }
            }
            ret = callback.apply(defined[name], args);
            if (name) {
                if (cjsModule && cjsModule.exports !== undef && cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    defined[name] = ret;
                }
            }
        } else if (name) {
            defined[name] = callback;
        }
    };
    requirejs = require = req = function(deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                return handlers[deps](callback);
            }
            return callDep(makeMap(deps, callback).f);
        } else if (!deps.splice) {
            config = deps;
            if (callback.splice) {
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }
        callback = callback || function() {};
        if (typeof relName === "function") {
            relName = forceSync;
            forceSync = alt;
        }
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            setTimeout(function() {
                main(undef, deps, callback, relName);
            }, 4);
        }
        return req;
    };
    req.config = function(cfg) {
        config = cfg;
        if (config.deps) {
            req(config.deps, config.callback);
        }
        return req;
    };
    define = function(name, deps, callback) {
        if (!deps.splice) {
            callback = deps;
            deps = [];
        }
        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [ name, deps, callback ];
        }
    };
    define.amd = {
        jQuery: true
    };
})();
define("almond", function(){});

var safety, define;

(function(undef) {
    "use strict";
    var noop = function() {
        return;
    }, console = window.console || {
        log: noop,
        error: noop
    }, LOG_PREFIX = "launcher.js safety.js: ", launcherJsHost, launcherJsProtocol, baseUrl = null, scriptTags = document.getElementsByTagName("script"), el, candidateHost, candidateHostRegex = /^(https?:)?\/\/([\w\\.:_\-]+)\/.*\/launcher.js$/, launcherHostnameRegex = /^(localhost|(dev-)?launch[\w\\.:_\-]*\.(getgo|expertcity)\.com)(:\d+)?$/, augmentedData = {}, numberOfTelemetriesSent = 0, MAX_TELEMETRIES_TO_SEND = 5;
    function getLauncherBaseUrl() {
        var key;
        for (key = 0; key < scriptTags.length; key += 1) {
            el = scriptTags[key];
            candidateHost = candidateHostRegex.exec(el.getAttribute("src"));
            if (candidateHost && launcherHostnameRegex.test(candidateHost[2])) {
                launcherJsProtocol = candidateHost[1] || "https:";
                launcherJsHost = candidateHost[2];
                break;
            }
        }
        if (!(launcherJsHost && launcherJsProtocol) && launcherHostnameRegex.test(document.location.host)) {
            launcherJsProtocol = window.location.protocol;
            launcherJsHost = window.location.host;
        }
        if (launcherJsProtocol && launcherJsHost) {
            return launcherJsProtocol + "//" + launcherJsHost;
        }
        return null;
    }
    baseUrl = getLauncherBaseUrl();
    if (baseUrl) {
        console.log(LOG_PREFIX + "Assuming baseUrl ", baseUrl);
    } else {
        console.log(LOG_PREFIX + "No baseUrl found, will not send telemetry", baseUrl);
    }
    function setAugmentedData(data) {
        if (data) {
            augmentedData = data;
        }
    }
    function toString(o) {
        return o && typeof o.toString === "function" && o.toString() || "";
    }
    function augment(obj) {
        var key;
        obj = obj || {};
        for (key in augmentedData) {
            if (augmentedData.hasOwnProperty(key) && !obj.hasOwnProperty(key)) {
                obj[key] = augmentedData[key];
            }
        }
        return obj;
    }
    function sendTelemetry(o) {
        if (numberOfTelemetriesSent >= MAX_TELEMETRIES_TO_SEND) {
            console.log(LOG_PREFIX + "NOT sending telemetry, already send " + MAX_TELEMETRIES_TO_SEND + " telemetries", o);
            return;
        }
        numberOfTelemetriesSent += 1;
        try {
            var url = baseUrl + "/launcher2/telemetry/javascript?", params = [], key, scriptTag, headTag;
            if (!baseUrl) {
                console.log(LOG_PREFIX + "Not sending telemetry (no baseUrl): ", o);
                return;
            }
            for (key in o) {
                if (o.hasOwnProperty(key) && o[key] !== undef) {
                    params.push(encodeURIComponent(key) + "=" + encodeURIComponent(o[key]));
                }
            }
            url += params.join("&");
            scriptTag = document.createElement("script");
            scriptTag.setAttribute("src", url.substring(0, 2046));
            scriptTag.setAttribute("async", "");
            headTag = document.head || document.getElementsByTagName("head")[0];
            headTag.appendChild(scriptTag);
        } catch (e) {
            console.error(LOG_PREFIX + "ERROR: Sending telemetry: ", e);
        }
    }
    function removeStartOfString(s, start) {
        s = toString(s);
        if (s.indexOf(start) === 0) {
            return s.substring(start.length);
        }
        return s;
    }
    function getStackTrace(e) {
        if (!e) {
            return e;
        }
        if (!e.stack) {
            return e.stack;
        }
        var stack = e.stack;
        try {
            stack = removeStartOfString(stack, e.name);
            stack = removeStartOfString(stack, ": ");
            stack = removeStartOfString(stack, e.message);
            var split = stack.replace(/^\s+|\s+$/gm, "").split("\n");
            stack = split.join(" ");
        } catch (ex) {
            console.error(LOG_PREFIX + "ERROR: getStackTrace ", ex);
        }
        return toString(stack).substring(0, 1024);
    }
    function shorten(message) {
        if (!message || !message.length || message.length < 512) {
            return message;
        }
        message = toString(message);
        return message.substring(0, 254) + "..." + message.substring(message.length - 255, message.length);
    }
    function lastPart(path) {
        return path && toString(path).split("/").pop();
    }
    function sendError(e, type, data) {
        try {
            e = e || {};
            data = augment(data);
            data.type = type || "exception";
            data.name = e.name;
            data.line = e.lineNumber;
            data.column = e.columnNumber;
            data.message = shorten(e.message);
            data.fileName = lastPart(e.fileName);
            data.stack = getStackTrace(e);
        } catch (ex) {
            console.error(LOG_PREFIX + "ERROR: sendError ", ex);
        }
        sendTelemetry(data);
    }
    function onWindowError(message, fileName, line, column, e) {
        e = e || {};
        var data = {};
        try {
            console.error(LOG_PREFIX + "onWindowError: ", message, fileName, line, column, e);
            data = augment({});
            data.type = "onWindowError";
            data.name = e.name;
            data.line = line;
            data.column = column;
            data.message = shorten(message);
            data.fileName = lastPart(fileName);
            data.stack = getStackTrace(e);
        } catch (ex) {
            try {
                console.error(LOG_PREFIX + "ERROR: onWindowError ", ex);
            } catch (ignore) {}
        }
        sendTelemetry(data);
    }
    function onRequireJSError(e) {
        e = e || {};
        var data = {};
        try {
            console.error(LOG_PREFIX + "require.js ERROR: ", e);
            data = augment({});
            data.type = "requirejs";
            data.requireType = e.requireType;
            data.message = shorten(e.message);
            data.module = e.requireMap && e.requireMap.id;
            data.stack = getStackTrace(e);
        } catch (ex) {
            console.error(LOG_PREFIX + "ERROR: onRequireJSError ", ex);
        }
        sendTelemetry(data);
    }
    function collectFn(type, fn) {
        if (typeof fn === "function") {
            return function() {
                var args = Array.prototype.slice.call(arguments), result;
                try {
                    result = fn.apply(this, args);
                } catch (ex) {
                    console.error(LOG_PREFIX + "Caught ", ex);
                    sendError(ex, type);
                }
                return result;
            };
        }
        return fn;
    }
    function collect(type, o) {
        var result, i;
        if (type && !o) {
            o = type;
            type = null;
        }
        result = collectFn(type, o);
        if (typeof o !== "string") {
            for (i in o) {
                if (o.hasOwnProperty(i)) {
                    result[i] = collectFn(type, o[i]);
                }
            }
        }
        return result;
    }
    function isVariableDefined(name, object) {
        object = object || window;
        var split = name.split(".", 1)[0], hasProperty = Object.prototype.hasOwnProperty.call(object, split);
        if (!hasProperty || split.length === name.length) {
            return hasProperty;
        }
        name = removeStartOfString(name, split + ".");
        return isVariableDefined(name, object[split]);
    }
    function reportMissing(expectedDefines) {
        var available = [], missing = [];
        try {
            var i, n = expectedDefines.length, expectedDefine;
            for (i = 0; i < n; i += 1) {
                expectedDefine = expectedDefines[i];
                if (isVariableDefined(expectedDefine)) {
                    available.push(expectedDefine);
                } else {
                    missing.push(expectedDefine);
                }
            }
            if (missing.length) {
                console.error(LOG_PREFIX + "ERROR: Missing: ", missing);
                sendTelemetry({
                    type: "report-missing",
                    message: missing.join(","),
                    available: available.join(",")
                });
            }
        } catch (ex) {
            console.error(LOG_PREFIX + "ERROR: reportMissing ", ex);
            sendError(ex);
        }
        return missing;
    }
    if (safety) {
        console.error(LOG_PREFIX + "ERROR: safety is already defined");
    }
    safety = {
        send: sendTelemetry,
        sendError: sendError,
        onRequireJSError: onRequireJSError,
        onWindowError: onWindowError,
        collect: collect,
        setAugmentedData: setAugmentedData,
        reportMissing: reportMissing,
        launcherJsHost: launcherJsHost,
        launcherJsProtocol: launcherJsProtocol,
        qa: {
            candidateHostRegex: candidateHostRegex,
            launcherHostnameRegex: launcherHostnameRegex
        }
    };
    if (define && define.amd) {
        define("safety", safety);
    }
})();
define("umd-define", [ "almond" ], function() {
    "use strict";
    return function umdDefine(name, module) {
        if (typeof window.define === "function" && window.define.amd) {
            window.define(name, function() {
                return module;
            });
        } else {
            window[name] = module;
        }
    };
});
define("jquery", [], function() {
    "use strict";
    return jQuery;
});
(function(ko, global) {
    "use strict";
    if (!ko) return;
    function isObject(value) {
        return Object.prototype.toString.call(value) === "[object Object]";
    }
    function isFunction(value) {
        return typeof value === "function";
    }
    var recordingStack = [];
    function recordDependency(dependency) {
        var length = recordingStack.length;
        var last = length > 0 ? recordingStack[length - 1] : [];
        for (var i in last) if (last[i] === dependency) return;
        last.push(dependency);
    }
    function recordExecution(func, context, observable) {
        if (observable.recording || !func) return observable.value;
        var result = [];
        observable.recording = true;
        recordingStack.push(result);
        var previous = ko.computedContext;
        ko.computedContext = {
            isInitial: function() {
                return !observable.initialised;
            },
            getDependenciesCount: function() {
                return result.length;
            }
        };
        try {
            return func.apply(context);
        } finally {
            observable.initialised = true;
            ko.computedContext = previous;
            recordingStack.pop();
            observable.recording = false;
            var dependent = [];
            if (!observable._d) {
                for (var i = 0; i < result.length; i++) {
                    dependent.push(result[i].subscribe(function() {
                        observable.peek();
                    }));
                }
            }
            observable.setDependent(dependent);
        }
    }
    function recordIgnoring(func, context) {
        recordingStack.push([]);
        try {
            func.call(context);
        } finally {
            recordingStack.pop();
        }
    }
    function Subscribable() {
        if (!(this instanceof Subscribable)) return new Subscribable();
        this.subscribers = function(event) {
            var result = this._s || (this._s = {});
            if (event) result = result[event] || (result[event] = []);
            return result;
        };
        var defaultEvent = "change";
        this.notifySubscribers = function(value, event) {
            event = event || defaultEvent;
            var dependencies = this.subscribers(event);
            try {
                if (this.getter) value = this.getter();
            } finally {
                var length = dependencies.length;
                for (var i = 0; i < length; i++) {
                    if (!dependencies[i]._p) {
                        dependencies[i].cb.call(dependencies[i].context, value);
                    }
                }
                for (i = 0; i < length; i++) {
                    if (dependencies[i]._p) {
                        dependencies.splice(i, 1);
                        i--;
                        length--;
                    }
                }
            }
        };
        this.subscribe = function(cb, context, event) {
            if (this.deferEvaluation && this.peek) this.peek();
            event = event || defaultEvent;
            if (!isFunction(cb)) {
                throw new Error("Function expected.");
            }
            var dependency = {
                cb: cb,
                context: context
            };
            this.subscribers(event).push(dependency);
            return {
                dispose: function() {
                    dependency._p = true;
                }
            };
        };
        this.copyProperties = function(target) {
            for (var i in this) target[i] = this[i];
            target._clonedFrom = this;
            return target;
        };
        this.extend = function(properties) {
            for (var i in properties) this[i] = properties[i];
            return this;
        };
        this.getSubscriptionsCount = function() {
            var count = 0, dependencies = this.subscribers();
            for (var i in dependencies) {
                for (var j in dependencies[i]) {
                    if (!dependencies[i][j]._p) count++;
                }
            }
            return count;
        };
    }
    function Observable() {
        function self() {
            if (arguments.length > 0) {
                self.setter(arguments[0], true, arguments);
                return this;
            } else {
                return self.getter();
            }
        }
        self.valueHasMutated = function() {
            self.notifySubscribers(self.value);
        };
        self.valueWillMutate = function() {
            self.notifySubscribers(self.value, "beforeChange");
        };
        self.setter = function(value, write, args) {
            var compare = self.equalityComparer;
            if (self.notify === "always" || !compare || !compare(value, self.value)) {
                try {
                    recordIgnoring(self.valueWillMutate, self);
                    if (write && !self.write) {
                        throw new Error("Observable not settable.");
                    }
                    self.value = value;
                    if (write) {
                        self.write.apply(self.getContext(), args);
                    }
                } finally {
                    recordIgnoring(self.valueHasMutated, self);
                }
            }
        };
        self.equalityComparer = function(newvalue, oldvalue) {
            return !isObject(newvalue) && newvalue === oldvalue;
        };
        self.getter = function() {
            recordDependency(self);
            if (self.deferEvaluation) self.peek();
            return self.value;
        };
        self.peek = function() {
            self.deferEvaluation = false;
            if (self.disposeWhen && self.disposeWhen()) self.dispose();
            if (self._d) return;
            var value = recordExecution(self.read, self.getContext(), self);
            self.setter(value, false, []);
            return value;
        };
        self.getContext = function() {
            return self.owner === undefined ? global : self.owner;
        };
        self.setDependent = function(value) {
            var subs = self._subs;
            if (subs) {
                for (var i = 0; i < subs.length; i++) {
                    subs[i].dispose();
                }
            }
            self._subs = value;
        };
        self.getDependenciesCount = function() {
            return (self._subs || []).length;
        };
        self.isActive = function() {
            return self.getDependenciesCount() > 0;
        };
        self.dispose = function() {
            self._d = true;
            self.setDependent([]);
        };
        this.copyProperties(self);
        self.original = this;
        return self;
    }
    function Computed(evaluator, owner, options) {
        if (!(this instanceof Computed)) {
            return new Computed(evaluator, owner, options);
        }
        if (!isFunction(evaluator)) {
            options = evaluator || {};
            evaluator = options.read;
            if (!isFunction(evaluator)) throw new Error("Function expected.");
        }
        var self = Observable.call(this);
        self.owner = owner;
        self.read = evaluator;
        if (options) self.extend(options);
        if (!self.deferEvaluation) self.peek();
        return self;
    }
    ko["subscribable"] = Subscribable;
    ko["computed"] = ko["dependentObservable"] = Computed;
    ko["observable"] = function(initial) {
        var self = new Observable();
        self.value = initial;
        self.write = function() {};
        return self;
    };
    Subscribable.fn = Subscribable.prototype = {};
    ko.observable.fn = Observable.prototype = new Subscribable();
    Computed.fn = Computed.prototype = new Observable().original;
    function buildCheckType(type, check) {
        return function(checked) {
            if (!checked || check && !check(checked)) return false;
            return (checked._clonedFrom || checked) instanceof type;
        };
    }
    ko["isSubscribable"] = buildCheckType(Subscribable);
    ko["isComputed"] = buildCheckType(Computed);
    ko["isObservable"] = buildCheckType(Observable);
    ko["isWriteableObservable"] = buildCheckType(Observable, function(self) {
        return !!self.write;
    });
    ko["computedContext"] = {
        isInitial: function() {
            return undefined;
        },
        getDependenciesCount: function() {
            return undefined;
        }
    };
})(typeof exports !== "undefined" ? exports : window["ko"] ? null : window["ko"] = {}, typeof exports !== "undefined" ? process : window);

define("third-party/observable", ko);
define("console", [],function() {
    "use strict";
    function noop() {
        return;
    }
    return window.console || {
        trace: noop,
        log: noop,
        info: noop,
        warn: noop,
        error: noop
    };
});
define("user-agent-parser", [ "safety", "console" ], function(safety, console) {
    "use strict";
    var PLATFORM = {
        ANDROID: {
            name: "ANDROID",
            mobile: true,
            matchers: [ /Android/ ]
        },
        CHROME_OS: {
            name: "CHROME_OS",
            mobile: false,
            matchers: [ /^Mozilla\/\d\.0 \(X11; CrOS .*\).*Chrome\/\d/ ]
        },
        IOS: {
            name: "IOS",
            mobile: true,
            matchers: [ /like Mac OS X.*Mobile/, function(userAgent, userAgentInfo, logger) {
                var hasTouchEvents = function() {
                    if (window.hasOwnProperty("isTestIOS")) {
                        return window.isTestIOS;
                    }
                    return window.hasOwnProperty("ontouchstart") && window.ontouchstart !== undefined;
                };
                var matches = /Mac OS X/.exec(userAgent);
                if (matches && hasTouchEvents()) {
                    return matches;
                }
                return null;
            } ]
        },
        KINDLEFIRE: {
            name: "KINDLEFIRE",
            mobile: true,
            matchers: [ /Silk-Accelerated/, /Kindle Fire/ ]
        },
        BSD: {
            name: "BSD",
            mobile: false,
            matchers: [ /FreeBSD/ ]
        },
        LINUX: {
            name: "LINUX",
            mobile: false,
            matchers: [ /Linux/i ]
        },
        MACOS: {
            name: "MACOS",
            mobile: false,
            matchers: [ /Macintosh/, /Mac OS X/, /Mac_PowerPC/, /MacOSX/ ]
        },
        WINDOWS: {
            name: "WINDOWS",
            mobile: false,
            matchers: [ /Windows NT (\d+\.\d+)/, /Windows/, /WinNT/, /Win32/, /Win9x/, /^C:\\Progra/i ]
        },
        WINDOWSARM: {
            name: "WINDOWSARM",
            mobile: true,
            matchers: [ /Windows NT.*; ARM;/ ]
        },
        WINDOWSPHONE: {
            name: "WINDOWSPHONE",
            mobile: true,
            matchers: [ /Windows Phone/, /Windows NT.*; ARM;.* WPDesktop/ ]
        },
        WINMOBILE: {
            name: "WINMOBILE",
            mobile: true,
            matchers: [ /Windows CE/, /Windows Phone OS/ ]
        },
        KNOWN_OTHER_MOBILE: {
            name: "KNOWN_OTHER_MOBILE",
            mobile: true,
            matchers: [ /^Mozilla\/\d\.0 \((BlackBerry|PlayBook|BB10);/, /\(J2ME\/./, /^Mozilla\/\d\.0 \((Mobile|Tablet).*\) Gecko\/\d+\.\d+ Firefox\/\d+\.\d+$/ ]
        },
        UNKNOWN: {
            name: "UNKNOWN",
            mobile: null,
            matchers: []
        }
    }, BROWSER = {
        CHROME: {
            name: "CHROME",
            matchers: [ /Chrome\/(\d+)/, /CriOS\/(\d+)/ ]
        },
        FIREFOX: {
            name: "FIREFOX",
            matchers: [ /.*Gecko\/\d+.* Firefox\/(\d+)/ ]
        },
        MSEDGE: {
            name: "MSEDGE",
            matchers: [ /Edge\/(\d+)/ ]
        },
        MSIE: {
            name: "MSIE",
            matchers: [ function(userAgent) {
                var matches = /; Trident\/(\d+)/.exec(userAgent);
                return matches && [ matches[0], parseInt(matches[1], 10) + 4 ];
            }, /MSIE (\d+)/ ]
        },
        OPERA: {
            name: "OPERA",
            matchers: [ /Opera Mini\/(\d+)/, /Opera.* Version\/(\d+)/, /Opera[\/ ](\d+)/ ]
        },
        SAFARI: {
            name: "SAFARI",
            matchers: [ function(userAgent, info) {
                return info.platform !== PLATFORM.ANDROID.name && info.platform !== PLATFORM.KINDLEFIRE.name && /AppleWebKit.* [vV]ersion\/(\d+).* Safari\//.exec(userAgent);
            } ]
        },
        UNKNOWN: {
            name: "UNKNOWN"
        }
    };
    function parseUserAgentProperty(userAgent, userAgentInfo, property, order, logger, convertFn) {
        if (!userAgent) {
            return {
                value: property.UNKNOWN
            };
        }
        var i, j, currentProperty, matcher, matches, version;
        for (i = 0; i < order.length; i += 1) {
            currentProperty = order[i];
            for (j = 0; j < currentProperty.matchers.length; j += 1) {
                matcher = currentProperty.matchers[j];
                if (matcher instanceof RegExp) {
                    matches = matcher.exec(userAgent);
                } else if (typeof matcher === "function") {
                    matches = matcher(userAgent, userAgentInfo, logger);
                }
                if (matches) {
                    version = convertFn(matches[1], 10);
                    return {
                        value: currentProperty,
                        version: isNaN(version) ? null : version
                    };
                }
            }
        }
        return {
            value: property.UNKNOWN,
            version: null
        };
    }
    var platformOrder = [ PLATFORM.KINDLEFIRE, PLATFORM.WINMOBILE, PLATFORM.WINDOWSPHONE, PLATFORM.ANDROID, PLATFORM.BSD, PLATFORM.LINUX, PLATFORM.IOS, PLATFORM.MACOS, PLATFORM.WINDOWSARM, PLATFORM.WINDOWS, PLATFORM.CHROME_OS, PLATFORM.KNOWN_OTHER_MOBILE ], browserOrder = [ BROWSER.OPERA, BROWSER.MSEDGE, BROWSER.MSIE, BROWSER.CHROME, BROWSER.SAFARI, BROWSER.FIREFOX ];
    function isMobile(platformName) {
        return PLATFORM[platformName] && PLATFORM[platformName].mobile;
    }
    function augment(userAgentInfo) {
        userAgentInfo.is = {
            mobile: isMobile(userAgentInfo.platform)
        };
        userAgentInfo.is[userAgentInfo.platform] = true;
        userAgentInfo.is[userAgentInfo.browser] = true;
        return userAgentInfo;
    }
    function isBrowser64bit(userAgent) {
        if (!userAgent) {
            return false;
        }
        return userAgent.indexOf("WOW64") < 0 && (userAgent.indexOf("x64") >= 0 || userAgent.indexOf("Win64") >= 0 || userAgent.indexOf("amd64") >= 0 || userAgent.indexOf("x86_64") >= 0);
    }
    function parseUserAgent(userAgent, logger) {
        logger = logger || console;
        var userAgentInfo = {
            userAgent: userAgent,
            is: {}
        }, property;
        property = parseUserAgentProperty(userAgent, userAgentInfo, PLATFORM, platformOrder, logger, parseFloat);
        userAgentInfo.platform = property.value.name;
        userAgentInfo.platformVersion = property.version;
        property = parseUserAgentProperty(userAgent, userAgentInfo, BROWSER, browserOrder, logger, parseInt);
        userAgentInfo.browser = property.value.name;
        userAgentInfo.browserVersion = property.version;
        userAgentInfo.browser64bit = isBrowser64bit(userAgent);
        augment(userAgentInfo);
        return userAgentInfo;
    }
    function pseudoEnum(obj) {
        var i, ret = {};
        for (i in obj) {
            if (obj.hasOwnProperty(i)) {
                ret[i] = i;
            }
        }
        return ret;
    }
    parseUserAgent.augment = augment;
    parseUserAgent.isMobile = isMobile;
    parseUserAgent.BROWSER = pseudoEnum(BROWSER);
    parseUserAgent.PLATFORM = pseudoEnum(PLATFORM);
    return safety.collect(parseUserAgent);
});
define("assert", [], function() {
    "use strict";
    return function assert(message, expression) {
        if (arguments.length === 1) {
            expression = message;
            message = "";
        }
        if (!expression) {
            throw new Error("AssertionException: " + message);
        }
    };
});
define("locale", [ "jquery", "assert" ], function($, assert) {
    "use strict";
    function getLocaleCombinations(inputLocale) {
        if (!inputLocale) {
            return [];
        }
        var splitLocale = inputLocale.split(/-|_/);
        var language = splitLocale[0];
        var possibleLocales = [ inputLocale ];
        var index, len = splitLocale.length;
        for (index = 1; index < len; index += 1) {
            possibleLocales.push(language + "_" + splitLocale[index]);
        }
        possibleLocales.push(language);
        if (language === "no") {
            possibleLocales.push("nb");
        }
        return possibleLocales;
    }
    return {
        resolve: function resolveLocale(locale, msgs) {
            assert("Expected msgs", msgs);
            assert("Expected English locale to be present", msgs.en);
            var localesToSearchList = getLocaleCombinations(locale);
            var searchLocale;
            while (localesToSearchList.length > 0) {
                searchLocale = localesToSearchList.shift();
                if (msgs.hasOwnProperty(searchLocale)) {
                    return searchLocale;
                }
            }
            return "en";
        }
    };
});
define("strings", {
    de: {
        "download.installer.app.h": "__0__-Installation starten",
        "launch.error.ingress": "Leider ist beim Starten Ihrer Sitzung ein Fehler aufgetreten.",
        "launching.app.fallback.tryagain": "Wenn __0__ nicht gestartet wird, __3__versuchen Sie es noch einmal__4__ oder __1__laden Sie __0__ herunter und führen Sie die Anwendung aus__2__.",
        "download.instructions.open.firefoxmac": 'Klicken Sie auf die Schaltfläche "OK" in der unteren rechten Ecke des Dialogs, um die Datei zu öffnen.',
        "launch.instructions.checkBoxToSkipMessageHint": "Klicken Sie bei Anzeige dieser Meldung in Ihrem Browser auf das Kontrollkästchen, damit Sie diesen Schritt bei der nächsten Sitzungsteilnahme überspringen können.",
        "launch.error.header": "Ihre Sitzung konnte nicht gestartet werden",
        "installer.download.plugin.launch.app": "Befolgen Sie die Schritte im Installations-Assistenten.",
        "launch.button.text": "__0__ starten",
        "download.instructions.animated.alttext": "Downloads in der Werkzeugleiste anzeigen",
        "launch.instructions.h": "Schneller in Sitzungen gelangen!",
        "download.instructions.animated.ie": "Klicken Sie auf __1__Ausführen__2__, um __0__ zu starten .",
        "download.instructions.animated.safari1": "Klicken Sie oben auf __2__ und doppelklicken Sie anschließend auf __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Installation von __0__ nicht möglich",
        "download.plugin.launch.app": "Ihre Sitzung sollte in Kürze beginnen.",
        "trylaunching.app.h": "Es wird versucht, __0__ zu starten",
        "installer.launched.app.ingress": "Die Installation sollte in wenigen Sekunden starten.",
        "launching.app.ingress.chrome": "GoTo Opener öffnen",
        "launching.app.ingress.safari": "Zulassen",
        "download.plugin.connected.h": "Verbunden mit __0__",
        "installer.plugin.clickonce.h": "__0__ installieren",
        "launching.app.ingress": "Bei entsprechender Aufforderung durch den Browser auf __0____2____1__ klicken.",
        "download.win.open.generic": "Doppelklicken Sie auf die Datei, um sie zu öffnen.",
        "download.instructions.animated.chromemac1": "Klicken Sie auf die Datei, um sie zu öffnen.",
        "download.plugin.download.ingress.restart": "Der Ladevorgang sollte in wenigen Sekunden automatisch beginnen. Falls nicht, __0__starten Sie den Ladevorgang erneut__1__.",
        "download.instructions.run.dmg.mac": "Sobald sich das Fenster öffnet, doppelklicken Sie auf die __1____0____2__ Anwendung.",
        "download.win.ingress": "Eine kleine Datei mit dem Namen __0____2__.exe__1__ wird auf Ihren Computer heruntergeladen.",
        "download.instructions.animated.firefoxwin1": "Klicken Sie  in der Mitte des Dialogfeldes auf __0__Datei speichern__1__.",
        "download.instructions.animated.firefoxwin2": "Klicken Sie oben auf __3__ und anschließend auf __1____0____2__, um zu beginnen.",
        "installer.plugin.started.h": "Bereit zur Installation von __0__",
        "installer.error.ingress": "Leider ist bei der Installation ein Fehler aufgetreten.",
        "download.plugin.clickonce.ingress": "Klicken Sie auf __1____0__ starten__2__. Klicken Sie auf __3__Ausführen__4__, wenn Sie dazu aufgefordert werden; Ihre Sitzung sollte dann in Kürze starten.",
        "trylaunching.app.fallback": "Wird __0__ nicht automatisch gestartet, __1____0__ hier herunterladen__2__.",
        "download.plugin.download.open.product.h": "Öffnen Sie __0__",
        "download.instructions.animated.chromewin": "Klicken Sie auf __1____0____2__, um zu beginnen.",
        "launching.app.fallback": "Wenn __0__ nicht gestartet wird, __1__laden Sie __0__ herunter und führen Sie die Anwendung aus__2__.",
        "installer.app.fallback": "Wenn die Installation von __0__ nicht startet, __1__laden Sie das Installationsprogramm herunter__2__.",
        "download.plugin.download.run.product.h": "Führen Sie __0__ aus",
        "download.installer.app.silent.h": "Installation von __0__",
        "installer.plugin.started.silent.h": "__0__ wurde erfolgreich installiert",
        "launched.app.h": "__0__ starten",
        "download.win.open.chrome": "Klicken Sie auf die Datei, um sie zu öffnen.",
        "launching.app.ingress.firefox": "Link öffnen",
        "launched.app.ingress": "Die Verbindung zu Ihrer Sitzung sollte in wenigen Sekunden hergestellt werden.",
        "installer.plugin.clickonce.ingress": "Klicken Sie auf __1____0__ installieren__2__. Wenn sie dazu aufgefordert werden, klicken Sie auf __3__Ausführen__4__; die Installation sollte dann in Kürze beginnen.",
        "download.instructions.animated.edge": "__1____2__Speichern Sie den __3____4____0__ und führen Sie ihn dann aus.",
        "download.win.open.ff": 'Klicken Sie auf die Schaltfläche "Downloads" in der oberen rechten Ecke Ihres Browsers und klicken Sie anschließend auf die Datei, um sie zu öffnen.',
        "download.plugin.download.open.h": "Öffnen Sie die Datei",
        "download.win.header": "So installieren Sie __0__",
        "download.plugin.clickonce.h": "__0__ starten",
        "download.unsupported.h": "Dieses System wird nicht unterstützt",
        "download.plugin.launch.app.closewindow": "Sie können dieses Fenster jetzt schließen.",
        "installer.fallback.tryagain": "Wenn die __0__-Installation nicht startet, __3__versuchen Sie es noch einmal__4__ oder __1__laden Sie das Installationsprogramm herunter__2__.",
        "download.win.run": 'Klicken Sie auf "Ausführen", wenn Sie dazu aufgefordert werden und der __1__ wird __0__ automatisch installieren.',
        "launching.app.h": "Erlauben Sie __0__ zu starten",
        "download.plugin.download.h": "__0__ installieren",
        "launch.button.onerror.text": "Noch einmal versuchen",
        "launching.installer.h": "Erlauben Sie die Installation von __0__",
        "download.plugin.download.ingress.trylaunch": "Download nicht möglich? __0__Sehen Sie nach, ob es bereits installiert ist.__1__",
        "download.plugin.download.run.h": "Führen Sie den Launcher aus"
    },
    fi: {
        "download.installer.app.h": "Kohteen __0__ asennusta aloitetaan",
        "launch.error.ingress": "Valitettavasti istuntoa aloitettaessa ilmeni virhe.",
        "launching.app.fallback.tryagain": "Jos __0__ ei käynnisty, __3__yritä uudelleen__4__ tai __1__lataa ja suorita __0____2__.",
        "download.instructions.open.firefoxmac": "Avaa tiedosto napsauttamalla OK valintaikkunan oikeassa alakulmassa.",
        "launch.instructions.checkBoxToSkipMessageHint": "Kun näet tämän viestin selaimessa, valitse valintaruutu, kun haluat ohittaa tämän vaiheen seuraavalla kerralla liittyessäsi istuntoon.",
        "launch.error.header": "Istuntoasi ei voida käynnistää",
        "installer.download.plugin.launch.app": "Noudata ohjatun asennuksen vaiheita.",
        "launch.button.text": "Käynnistä __0__",
        "download.instructions.animated.alttext": "Näytä lataukset työkalurivillä",
        "launch.instructions.h": "Avaa istunto nopeammin!",
        "download.instructions.animated.ie": "Napsauta __1__Suorita__2__ aloittaaksesi __0__.",
        "download.instructions.animated.safari1": "Napsauta __2__ yläpuolella ja kaksoisnapsauta __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Kohdetta __0__ ei voi asentaa",
        "download.plugin.launch.app": "Istunnon pitäisi alkaa pian.",
        "trylaunching.app.h": "Yrittää käynnistää __0__",
        "installer.launched.app.ingress": "Asennuksen pitäisi alkaa parissa sekunnissa.",
        "launching.app.ingress.chrome": "Avaa GoTo Opener",
        "launching.app.ingress.safari": "Salli",
        "download.plugin.connected.h": "Yhdistetty kohteeseen __0__",
        "installer.plugin.clickonce.h": "Asenna __0__",
        "launching.app.ingress": "Napsauta __0____2____1__, jos selain kehottaa tekemään niin.",
        "download.win.open.generic": "Avaa tiedosto kaksoisnapsauttamalla sitä.",
        "download.instructions.animated.chromemac1": "Avaa tiedosto napsauttamalla sitä.",
        "download.plugin.download.ingress.restart": "Latauksen pitäisi alkaa automaattisesti muutamassa sekunnissa. Jos niin ei tapahdu, __0__aloita lataus uudelleen__1__.",
        "download.instructions.run.dmg.mac": "Kun ikkuna avautuu, kaksoisnapsauta __1____0____2__ -sovellusta.",
        "download.win.ingress": "Tietokoneelle ladataan pientä __0____2__.exe__1__ -tiedostoa.",
        "download.instructions.animated.firefoxwin1": "Napsauta __0__Tallenna tiedosto__1__ valintaikkunan keskellä.",
        "download.instructions.animated.firefoxwin2": "Napsauta __3__ yläpuolella, napsauta sitten __1____0____2__ aloittaaksesi.",
        "installer.plugin.started.h": "__0__ on valmis asennettavaksi",
        "installer.error.ingress": "Valitettavasti asennettaessa tapahtui virhe.",
        "download.plugin.clickonce.ingress": "Napsauta __1__Käynnistä __0____2__. Napsauta kehotettaessa __3__Suorita__4__, jolloin istunnon pitäisi alkaa pian.",
        "trylaunching.app.fallback": "Jos __0__ ei käynnisty automaattisesti, __1__lataa __0____2__.",
        "download.plugin.download.open.product.h": "Avaa __0__",
        "download.instructions.animated.chromewin": "Aloita napsauttamalla __1____0____2__.",
        "launching.app.fallback": "Jos __0__ ei käynnisty, __1__lataa ja suorita __0____2__.",
        "installer.app.fallback": "Jos __0__ -asennusta ei aloiteta, __1__lataa asennusohjelma__2__.",
        "download.plugin.download.run.product.h": "Suorita __0__",
        "download.installer.app.silent.h": "Asennetaan __0__",
        "installer.plugin.started.silent.h": "__0__ asennettu onnistuneesti",
        "launched.app.h": "Käynnistetään __0__",
        "download.win.open.chrome": "Avaa tiedosto napsauttamalla sitä.",
        "launching.app.ingress.firefox": "Avaa linkki",
        "launched.app.ingress": "Istunnon pitäisi kytkeytyä hetken kuluttua.",
        "installer.plugin.clickonce.ingress": "Valitse __1__Asenna __0____2__. Valitse pyydettäessä __3__Suorita__4__, jolloin asennuksen pitäisi alkaa pian.",
        "download.instructions.animated.edge": "__1__Tallenna__2__ ensin ja __3__Suorita__4__ sitten __0__.",
        "download.win.open.ff": "Napsauta Lataukset-painiketta selaimen oikeassa yläkulmassa ja avaa tiedosto napsauttamalla sitä.",
        "download.plugin.download.open.h": "Avaa tiedosto",
        "download.win.header": "Näin __0__ asennetaan",
        "download.plugin.clickonce.h": "Käynnistä __0__",
        "download.unsupported.h": "Tätä järjestelmää ei tueta.",
        "download.plugin.launch.app.closewindow": "Voit nyt sulkea tämän ikkunan.",
        "installer.fallback.tryagain": "Jos __0__ -asennusta ei aloiteta, __3__yritä uudelleen__4__ tai __1__lataa asennusohjelma__2__.",
        "download.win.run": "Valitse pyydettäessä Suorita, jolloin __1__ asentaa automaattisesti kohteen __0__.",
        "launching.app.h": "Salli kohteen __0__ käynnistäminen",
        "download.plugin.download.h": "Asenna __0__",
        "launch.button.onerror.text": "Yritä uudelleen",
        "launching.installer.h": "Salli kohteen __0__ asennus",
        "download.plugin.download.ingress.trylaunch": "Lataus ei onnistu? __0__Tarkasta onko se jo asennettu__1__",
        "download.plugin.download.run.h": "Suorita Launcher"
    },
    ru: {
        "download.installer.app.h": "Запуск установки __0__",
        "launch.error.ingress": "К сожалению, при запуске сеанса произошла ошибка.",
        "launching.app.fallback.tryagain": "Если приложение __0__ не запускается, __3__повторите попытку__4__ или __1__загрузите и запустите __0____2__.",
        "download.instructions.open.firefoxmac": 'В правом нижнем углу диалогового окна нажмите кнопку "ОК", чтобы открыть файл.',
        "launch.instructions.checkBoxToSkipMessageHint": "Если это сообщение появляется в браузере, установите флажок, чтобы пропустить этот шаг в следующий раз при подключении к сеансу.",
        "launch.error.header": "Не удалось запустить сеанс",
        "installer.download.plugin.launch.app": "Следуйте указаниям мастера установки.",
        "launch.button.text": "Запустить __0__",
        "download.instructions.animated.alttext": "Показать загрузки на панели инструментов",
        "launch.instructions.h": "Подключайтесь к сеансу быстрее!",
        "download.instructions.animated.ie": "Нажмите кнопку __1__Выполнить__2__, чтобы запустить __0__.",
        "download.instructions.animated.safari1": "Щелкните значок __2__ вверху, а затем дважды щелкните __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Не удается установить __0__",
        "download.plugin.launch.app": "Сеанс скоро начнется.",
        "trylaunching.app.h": "Попытка запуска __0__",
        "installer.launched.app.ingress": "Установка начнется через несколько секунд.",
        "launching.app.ingress.chrome": "Открыть приложение GoTo Opener",
        "launching.app.ingress.safari": "Разрешить",
        "download.plugin.connected.h": "Выполнено подключение к __0__",
        "installer.plugin.clickonce.h": "Установить __0__",
        "launching.app.ingress": "Щелкните __0____2____1__ при появлении запроса в браузере.",
        "download.win.open.generic": "Чтобы открыть файл, дважды щелкните его.",
        "download.instructions.animated.chromemac1": "Чтобы открыть файл, щелкните его.",
        "download.plugin.download.ingress.restart": "Загрузка должна начаться автоматически через несколько секунд. Если загрузка не началась, __0__перезапустите ее__1__.",
        "download.instructions.run.dmg.mac": "В открывшемся окне дважды щелкните приложение __1____0____2__.",
        "download.win.ingress": "На компьютер загружается небольшой файл с именем __0____2__.exe__1__.",
        "download.instructions.animated.firefoxwin1": "В диалоговом окне по центру нажмите кнопку __0__Сохранить файл__1__.",
        "download.instructions.animated.firefoxwin2": "Щелкните выше значок __3__. Затем щелкните __1____0____2__, чтобы начать.",
        "installer.plugin.started.h": "Все готово к установке __0__",
        "installer.error.ingress": "К сожалению, во время установки произошла ошибка.",
        "download.plugin.clickonce.ingress": "Нажмите кнопку __1__Запустить __0____2__. При появлении запроса нажмите кнопку __3__Выполнить__4__, и вскоре после этого начнется сеанс.",
        "trylaunching.app.fallback": "Если __0__ не запускается автоматически, __1__загрузите __0____2__.",
        "download.plugin.download.open.product.h": "Открытие __0__",
        "download.instructions.animated.chromewin": "Чтобы начать, щелкните __1____0____2__.",
        "launching.app.fallback": "Если __0__ не запускается, __1__загрузите и запустите __0____2__.",
        "installer.app.fallback": "Если установка __0__ не началась, __1__загрузите программу установки__2__.",
        "download.plugin.download.run.product.h": "Запуск __0__",
        "download.installer.app.silent.h": "Установка __0__",
        "installer.plugin.started.silent.h": "Установка __0__ завершена",
        "launched.app.h": "__0__ запускается",
        "download.win.open.chrome": "Чтобы открыть файл, щелкните его.",
        "launching.app.ingress.firefox": "Открыть ссылку",
        "launched.app.ingress": "Подключение сеанса произойдет через несколько секунд.",
        "installer.plugin.clickonce.ingress": "Нажмите кнопку __1__Установить__0____2__. При появлении запроса нажмите кнопку __3__Выполнить__4__, после чего начнется установка.",
        "download.instructions.animated.edge": "Сначала необходимо __1__Сохранить__2__, затем __3__Запустить__4__ __0__.",
        "download.win.open.ff": 'В верхнем правом углу браузера нажмите кнопку "Загрузки", а затем щелкните файл, чтобы открыть его.',
        "download.plugin.download.open.h": "Откройте файл",
        "download.win.header": "Как установить __0__",
        "download.plugin.clickonce.h": "Запустить __0__",
        "download.unsupported.h": "Данная система не поддерживается",
        "download.plugin.launch.app.closewindow": "Теперь это окно можно закрыть.",
        "installer.fallback.tryagain": "Если установка __0__ не началась, __3__повторите попытку__4__ или __1__загрузите программу установки__2__.",
        "download.win.run": 'При соответствующем запросе нажмите кнопку "Выполнить", после чего __1__ автоматически установит __0__.',
        "launching.app.h": "Позвольте запустить __0__",
        "download.plugin.download.h": "Установить __0__",
        "launch.button.onerror.text": "Повторите попытку",
        "launching.installer.h": "Позвольте установить __0__",
        "download.plugin.download.ingress.trylaunch": "Не удается загрузить? __0__Проверьте, возможно, загрузка уже выполнена__1__",
        "download.plugin.download.run.h": "Запустите средство запуска приложений Launcher"
    },
    sv: {
        "download.installer.app.h": "Installationen av __0__ startar",
        "launch.error.ingress": "Tyvärr inträffade ett fel då din session skulle startas.",
        "launching.app.fallback.tryagain": "Om __0__ inte startar kan du __3__försöka igen__4__ eller __1__hämta och köra __0____2__.",
        "download.instructions.open.firefoxmac": "Klicka på OK i dialogrutans nedre högra hörn för att öppna filen.",
        "launch.instructions.checkBoxToSkipMessageHint": "När det här meddelande visas i webbläsaren ska du markera kryssrutan om du vill hoppa över det här steget nästa gång du går med i en session.",
        "launch.error.header": "Det går inte att starta din session",
        "installer.download.plugin.launch.app": "Följ anvisningarna i installationsguiden.",
        "launch.button.text": "Starta __0__",
        "download.instructions.animated.alttext": "Visa hämtade filer i verktygsfältet",
        "launch.instructions.h": "Anslut snabbare till sessionen!",
        "download.instructions.animated.ie": "Klicka på __1__Kör__2__ för att starta __0__.",
        "download.instructions.animated.safari1": "Klicka på __2__ ovan och dubbelklicka sedan på __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Det gick inte att installera __0__",
        "download.plugin.launch.app": "Din session börjar inom kort.",
        "trylaunching.app.h": "Försöker starta __0__",
        "installer.launched.app.ingress": "Installationen börjar inom några sekunder.",
        "launching.app.ingress.chrome": "Öppna GoTo Opener",
        "launching.app.ingress.safari": "Tillåt",
        "download.plugin.connected.h": "Ansluten till __0__",
        "installer.plugin.clickonce.h": "Installera __0__",
        "launching.app.ingress": "Klicka på __0____2____1__ om du uppmanas göra det av webbläsaren.",
        "download.win.open.generic": "Dubbelklicka på filen för att öppna den.",
        "download.instructions.animated.chromemac1": "Klicka på filen för att öppna den.",
        "download.plugin.download.ingress.restart": "Hämtningen bör startas automatiskt om några sekunder, men i annat fall kan du __0__starta om hämtningen__1__.",
        "download.instructions.run.dmg.mac": "Dubbelklicka på __1____0____2__-programmet när ett fönster öppnas.",
        "download.win.ingress": "En liten fil som heter __0____2__.exe__1__ hämtas nu till din dator.",
        "download.instructions.animated.firefoxwin1": "Klicka på __0__Spara fil__1__ i dialogrutan i mitten.",
        "download.instructions.animated.firefoxwin2": "Klicka på __3__ ovan, och klicka sedan på __1____0____2__ för att börja.",
        "installer.plugin.started.h": "Klar för installation av __0__",
        "installer.error.ingress": "Tyvärr uppstod ett fel vid installationen.",
        "download.plugin.clickonce.ingress": "Klicka på __1__Starta __0____2__. Klicka på __3__Kör__4__ vid uppmaning så startar din session strax.",
        "trylaunching.app.fallback": "Om __0__ inte startar automatiskt, __1__hämta __0____2__.",
        "download.plugin.download.open.product.h": "Öppna __0__",
        "download.instructions.animated.chromewin": "Klicka på __1____0____2__ för att börja.",
        "launching.app.fallback": "Om __0__ inte startar kan du __1__hämta och köra __0____2__.",
        "installer.app.fallback": "Om installationen av __0__ inte startar __1__hämtar du installationsprogrammet i stället__2__.",
        "download.plugin.download.run.product.h": "Kör __0__",
        "download.installer.app.silent.h": "Installerar __0__",
        "installer.plugin.started.silent.h": "__0__ har installerats",
        "launched.app.h": "Startar __0__",
        "download.win.open.chrome": "Klicka på filen för att öppna den.",
        "launching.app.ingress.firefox": "Öppna länk",
        "launched.app.ingress": "Din session börjar inom några sekunder.",
        "installer.plugin.clickonce.ingress": "Klicka på __1__Installera __0____2__. Klicka på __3__Kör__4__ vid uppmaning så startar installationen strax.",
        "download.instructions.animated.edge": "__1__Spara__2__ först och __3__kör__4__ sedan __0__.",
        "download.win.open.ff": "Klicka på knappen Hämta i det övre högra hörnet i webbläsaren och klicka sedan på filen för att öppna den.",
        "download.plugin.download.open.h": "Öppna filen",
        "download.win.header": "Så här installerar du __0__",
        "download.plugin.clickonce.h": "Starta __0__",
        "download.unsupported.h": "Systemet stöds inte",
        "download.plugin.launch.app.closewindow": "Du kan stänga det här fönstret nu.",
        "installer.fallback.tryagain": "Om installationen av __0__ inte startar kan du __3__försöka igen__4__ eller __1__hämta installationsprogrammet__2__.",
        "download.win.run": "Klicka på Kör vid uppmaning så installerar __1__ automatiskt __0__.",
        "launching.app.h": "Tillåt __0__ att starta",
        "download.plugin.download.h": "Installera __0__",
        "launch.button.onerror.text": "Försök igen",
        "launching.installer.h": "Tillåt installation av __0__",
        "download.plugin.download.ingress.trylaunch": "Det går inte att hämta? __0__Se om det redan har installerats__1__",
        "download.plugin.download.run.h": "Kör Launcher"
    },
    ko: {
        "download.installer.app.h": "__0__ 설치를 시작하는 중",
        "launch.error.ingress": "죄송합니다. 세션을 시작하는 동안 오류가 발생했습니다.",
        "launching.app.fallback.tryagain": "__0__이(가) 시작되지 않는 경우 __3__다시 시도__4__하거나 __1____0__을(를) 다운로드한 후 실행__2__하십시오.",
        "download.instructions.open.firefoxmac": "대화 상자 오른쪽 아래에서 확인 단추를 클릭하여 파일을 여십시오.",
        "launch.instructions.checkBoxToSkipMessageHint": "브라우저에 이 메시지가 표시될 경우, 다음 번에 세션에 참여할 때 이 단계를 건너뛰려면 확인란을 클릭하십시오.",
        "launch.error.header": "세션을 시작할 수 없습니다.",
        "installer.download.plugin.launch.app": "설치 마법사의 단계를 따르십시오.",
        "launch.button.text": "__0__ 시작",
        "download.instructions.animated.alttext": "도구 모음에 다운로드 항목 표시",
        "launch.instructions.h": "더 빠르게 세션에 참여하세요!",
        "download.instructions.animated.ie": "__1__실행__2__을 클릭하여 __0__을(를) 시작하십시오.",
        "download.instructions.animated.safari1": "위의 __2__을(를) 클릭한 다음 __0__GoTo Opener.dmg__1__를 두 번 클릭하십시오.",
        "installer.error.header": "__0__을(를) 설치할 수 없음",
        "download.plugin.launch.app": "세션이 곧 시작됩니다.",
        "trylaunching.app.h": "__0__ 을(를) 시작하려는 중",
        "installer.launched.app.ingress": "몇 초 이내에 설치가 시작됩니다.",
        "launching.app.ingress.chrome": "GoTo Opener 열기",
        "launching.app.ingress.safari": "허용",
        "download.plugin.connected.h": "__0__에 연결됨",
        "installer.plugin.clickonce.h": "__0__ 설치",
        "launching.app.ingress": "브라우저에서 메시지가 표시되 면 __0____2____1__을 클릭하십시오.",
        "download.win.open.generic": "파일을 두 번 클릭하여 여십시오.",
        "download.instructions.animated.chromemac1": "파일을 클릭하여 여십시오.",
        "download.plugin.download.ingress.restart": "몇 초 내에 다운로드가 자동으로 시작됩니다. 그렇지 않을 경우 __0__다운로드를 다시 시작__1__하십시오.",
        "download.instructions.run.dmg.mac": "창이 열리면 __1____0____2__ 응용 프로그램을 두 번 클릭하십시오.",
        "download.win.ingress": "__0____2__.exe__1__라는 작은 파일이 컴퓨터에 다운로드됩니다.",
        "download.instructions.animated.firefoxwin1": "중앙의 대화 상자에서 __0__파일 저장__1__을 클릭하십시오.",
        "download.instructions.animated.firefoxwin2": "위의 __3__을(를) 클릭한 다음 __1____0____2__을(를) 클릭하여 시작하십시오.",
        "installer.plugin.started.h": "__0__ 설치 준비 완료",
        "installer.error.ingress": "죄송합니다. 설치 중에 오류가 발생했습니다.",
        "download.plugin.clickonce.ingress": "__1____0__ 시작__2__을 클릭합니다. 메시지가 나타나면 __3__실행__4__을 클릭하십시오. 그러면 세션이 곧 시작됩니다.",
        "trylaunching.app.fallback": "__0__이(가) 자동으로 시작되지 않으면 __1____0__을(를) 다운로드__2__하십시오.",
        "download.plugin.download.open.product.h": "__0__ 열기",
        "download.instructions.animated.chromewin": "__1____0____2__을(를) 클릭하여 시작하십시오.",
        "launching.app.fallback": "__0__이(가) 시작되지 않으면 __0__을(를) __1__다운로드한 후 실행__2__하십시오.",
        "installer.app.fallback": "__0__ 설치가 시작되지 않은 경우 __1__설치 관리자를 다운로드__2__하십시오.",
        "download.plugin.download.run.product.h": "__0__ 실행",
        "download.installer.app.silent.h": "__0__을(를) 설치하는 중",
        "installer.plugin.started.silent.h": "__0__이(가) 성공적으로 설치됨",
        "launched.app.h": "__0__ 시작하는 중",
        "download.win.open.chrome": "파일을 클릭하여 여십시오.",
        "launching.app.ingress.firefox": "링크 열기",
        "launched.app.ingress": "몇 초 후에 세션이 연결됩니다.",
        "installer.plugin.clickonce.ingress": "__1____0__ 설치__2__를 클릭합니다. 메시지가 나타나면 __3__실행__4__을 클릭하십시오. 그러면 설치가 곧 시작됩니다.",
        "download.instructions.animated.edge": "먼저 __1__저장__2__한 후 __0__을(를) __3__실행__4__하십시오.",
        "download.win.open.ff": "브라우저 오른쪽 위에 있는 다운로드 단추를 클릭한 다음 파일을 클릭하여 여십시오.",
        "download.plugin.download.open.h": "파일 열기",
        "download.win.header": "__0__ 설치 방법",
        "download.plugin.clickonce.h": "__0__ 시작",
        "download.unsupported.h": "이 시스템은 지원되지 않습니다.",
        "download.plugin.launch.app.closewindow": "이제 이 창을 닫을 수 있습니다.",
        "installer.fallback.tryagain": "__0__ 설치가 시작되지 않은 경우 __3__다시 시도__4__하거나 __1__설치 관리자를 다운로드__2__하십시오.",
        "download.win.run": "메시지가 표시될 때 실행을 클릭하면 __1__가 __0__을(를) 자동으로 설치합니다.",
        "launching.app.h": "__0__ 시작 허용",
        "download.plugin.download.h": "__0__ 설치",
        "launch.button.onerror.text": "다시 시도",
        "launching.installer.h": "__0__ 설치 허용",
        "download.plugin.download.ingress.trylaunch": "다운로드에 문제가 있습니까? __0__이미 설치되어 있는지 확인하십시오.__1__",
        "download.plugin.download.run.h": "Launcher 실행"
    },
    en: {
        "download.installer.app.h": "Starting __0__ installation",
        "launch.error.ingress": "We apologize, but an error has occurred while starting your session.",
        "launching.app.fallback.tryagain": "If __0__ does not launch, please __3__try again__4__ or __1__download & run __0____2__.",
        "download.instructions.open.firefoxmac": "Click the OK button in the bottom right corner of the dialog box to open the file.",
        "launch.instructions.checkBoxToSkipMessageHint": "When you see this message appear in your browser, click the checkbox to skip this step the next time you join a session.",
        "launch.error.header": "Unable to start your session",
        "installer.download.plugin.launch.app": "Please follow the steps in the installation wizard.",
        "launch.button.text": "Launch __0__",
        "download.instructions.animated.alttext": "Show downloads in the toolbar",
        "launch.instructions.h": "Get into session quicker!",
        "download.instructions.animated.ie": "Click __1__Run__2__ to start __0__.",
        "download.instructions.animated.safari1": "Click __2__ above, then double-click __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Unable to install __0__",
        "download.plugin.launch.app": "Your session should begin shortly.",
        "trylaunching.app.h": "Trying to launch __0__",
        "installer.launched.app.ingress": "The installation should start in a few seconds.",
        "launching.app.ingress.chrome": "Open GoTo Opener",
        "launching.app.ingress.safari": "Allow",
        "download.plugin.connected.h": "Connected to __0__",
        "installer.plugin.clickonce.h": "Install __0__",
        "launching.app.ingress": "Click __0____2____1__ if prompted by your browser.",
        "download.win.open.generic": "Double-click the file to open it.",
        "download.instructions.animated.chromemac1": "Click the file to open it.",
        "download.plugin.download.ingress.restart": "The download should automatically begin in a few seconds, but if not, please __0__restart the download__1__.",
        "download.instructions.run.dmg.mac": "Once a window opens, double-click the __1____0____2__ application.",
        "download.win.ingress": "A small file named __0____2__.exe__1__ is downloading on your computer.",
        "download.instructions.animated.firefoxwin1": "Click __0__Save File__1__ in the dialog box in the center.",
        "download.instructions.animated.firefoxwin2": "Click __3__ above, then click __1____0____2__ to begin.",
        "installer.plugin.started.h": "Ready to install __0__",
        "installer.error.ingress": "We apologize, but an error has occurred while installing.",
        "download.plugin.clickonce.ingress": "Click __1__Start __0____2__. If prompted, click __3__Run__4__, and your session should start shortly.",
        "trylaunching.app.fallback": "If __0__ does not automatically launch, __1__download __0____2__.",
        "download.plugin.download.open.product.h": "Open __0__",
        "download.instructions.animated.chromewin": "Click __1____0____2__ to begin.",
        "launching.app.fallback": "If __0__ does not launch, please __1__download & run __0____2__.",
        "installer.app.fallback": "If installation of __0__ does not start, please __1__download the installer__2__.",
        "download.plugin.download.run.product.h": "Run __0__",
        "download.installer.app.silent.h": "Installing __0__",
        "installer.plugin.started.silent.h": "__0__ installed successfully",
        "launched.app.h": "Starting __0__",
        "download.win.open.chrome": "Click the file to open it.",
        "launching.app.ingress.firefox": "Open link",
        "launched.app.ingress": "Your session should connect in a few seconds.",
        "installer.plugin.clickonce.ingress": "Click __1__Install __0____2__. If prompted, click __3__Run__4__, and your installation should start shortly.",
        "download.instructions.animated.edge": "First __1__Save__2__, then __3__Run__4__ the __0__.",
        "download.win.open.ff": "Click the Downloads button in the top right corner of your browser and then click the file to open it.",
        "download.plugin.download.open.h": "Open the File",
        "download.win.header": "How to Install __0__",
        "download.plugin.clickonce.h": "Start __0__",
        "download.unsupported.h": "This system isn't supported",
        "download.plugin.launch.app.closewindow": "You can close this window now.",
        "installer.fallback.tryagain": "If __0__ installation does not start, please __3__try again__4__ or __1__download the installer__2__.",
        "download.win.run": "Click Run if prompted and the __1__ will automatically install __0__.",
        "launching.app.h": "Allow __0__ to launch",
        "download.plugin.download.h": "Install __0__",
        "launch.button.onerror.text": "Try again",
        "launching.installer.h": "Allow __0__ to install",
        "download.plugin.download.ingress.trylaunch": "Unable to download? __0__See if it's already installed__1__",
        "download.plugin.download.run.h": "Run the Launcher"
    },
    it: {
        "download.installer.app.h": "Avvio dell'installazione di __0__",
        "launch.error.ingress": "Si è verificato un errore durante l'avvio della sessione.",
        "launching.app.fallback.tryagain": "Se __0__ non viene avviato, __3__riprovare__4__ o __1__scaricare ed eseguire __0____2__.",
        "download.instructions.open.firefoxmac": "Fare clic sul pulsante OK nell'angolo inferiore destro della finestra di dialogo per aprire il file.",
        "launch.instructions.checkBoxToSkipMessageHint": "Quando viene visualizzato questo messaggio nel browser, fare clic sulla casella di controllo per saltare questo passaggio la prossima volta che ci si collega alla sessione.",
        "launch.error.header": "Impossibile avviare la sessione",
        "installer.download.plugin.launch.app": "Segui i passaggi dell'installazione guidata.",
        "launch.button.text": "Avvia __0__",
        "download.instructions.animated.alttext": "Mostra i download nella barra degli strumenti",
        "launch.instructions.h": "È possibile avviare la sessione più rapidamente.",
        "download.instructions.animated.ie": "Fare clic su __1__Esegui__2__ per avviare __0__.",
        "download.instructions.animated.safari1": "Fare clic su __2__ in alto, quindi fare doppio clic su __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Impossibile installare __0__",
        "download.plugin.launch.app": "La sessione dovrebbe iniziare a breve.",
        "trylaunching.app.h": "Tentativo di avvio di __0__",
        "installer.launched.app.ingress": "L'installazione dovrebbe partire entro pochi secondi.",
        "launching.app.ingress.chrome": "Apri GoTo Opener",
        "launching.app.ingress.safari": "Consenti",
        "download.plugin.connected.h": "Collegato a __0__",
        "installer.plugin.clickonce.h": "Installa __0__",
        "launching.app.ingress": "Fai clic su __0____2____1__ se richiesto dal browser.",
        "download.win.open.generic": "Fare doppio clic su di esso per aprirlo.",
        "download.instructions.animated.chromemac1": "Fare clic sul file per aprirlo.",
        "download.plugin.download.ingress.restart": "Il download dovrebbe iniziare automaticamente entro pochi secondi; in caso contrario, __0__riavvialo__1__.",
        "download.instructions.run.dmg.mac": "Dopo che la finestra è stata aperta, fare doppio clic sull'applicazione __1____0____2__.",
        "download.win.ingress": "È in fase di download sul computer un file di dimensioni ridotte, denominato __0____2__.exe__1__.",
        "download.instructions.animated.firefoxwin1": "Fare clic su __0__Salva file__1__ nella finestra di dialogo al centro.",
        "download.instructions.animated.firefoxwin2": "Fare clic su __3__ sopra, poi fare clic su __1____0____2__ per iniziare.",
        "installer.plugin.started.h": "Pronto per installare __0__",
        "installer.error.ingress": "Si è verificato un errore durante l'installazione.",
        "download.plugin.clickonce.ingress": "Fare clic su __1__Avvia __0____2__. Se richiesto, fare clic su __3__Esegui__4__: la sessione dovrebbe avviarsi in breve tempo.",
        "trylaunching.app.fallback": "Se __0__ non viene avviato automaticamente, __1__scarica __0____2__.",
        "download.plugin.download.open.product.h": "Aprire __0__",
        "download.instructions.animated.chromewin": "Fare clic su __1____0____2__ per iniziare.",
        "launching.app.fallback": "Se __0__ non viene avviato, __1__scaricare ed eseguire __0____2__.",
        "installer.app.fallback": "Se l'installazione di __0__ non viene avviata, __1__scarica il programma di installazione__2__.",
        "download.plugin.download.run.product.h": "Eseguire __0__",
        "download.installer.app.silent.h": "Installazione di __0__",
        "installer.plugin.started.silent.h": "Installazione di __0__ completata",
        "launched.app.h": "Avvio di __0__ in corso",
        "download.win.open.chrome": "Fare clic sul file per aprirlo.",
        "launching.app.ingress.firefox": "Apri link",
        "launched.app.ingress": "La sessione dovrebbe iniziare tra pochi secondi.",
        "installer.plugin.clickonce.ingress": "Fare clic su __1__Installa __0____2__. Se richiesto, fare clic su __3__Esegui__4__: l'installazione dovrebbe iniziare a breve.",
        "download.instructions.animated.edge": "Prima __1__salva__2__, quindi __3__esegui__4__ __0__.",
        "download.win.open.ff": "Fare clic sul pulsante Download nell'angolo superiore destro del browser e quindi sul file per aprirlo.",
        "download.plugin.download.open.h": "Aprire il file",
        "download.win.header": "Come installare __0__",
        "download.plugin.clickonce.h": "Avvia __0__",
        "download.unsupported.h": "Il sistema non è supportato",
        "download.plugin.launch.app.closewindow": "Ora è possibile chiudere la finestra.",
        "installer.fallback.tryagain": "Se l'installazione di __0__ non viene avviata, __3__riprova__4__ o __1__scarica il programma di installazione__2__.",
        "download.win.run": "Fare clic su Esegui se richiesto e __1__ installerà automaticamente __0__.",
        "launching.app.h": "Consenti di avviare __0__",
        "download.plugin.download.h": "Installa __0__",
        "launch.button.onerror.text": "Riprova",
        "launching.installer.h": "Consenti di installare __0__",
        "download.plugin.download.ingress.trylaunch": "Impossibile scaricare? __0__Controlla se è già stato installato__1__",
        "download.plugin.download.run.h": "Eseguire Launcher"
    },
    pt_BR: {
        "download.installer.app.h": "Iniciando a instalação do __0__",
        "launch.error.ingress": "Desculpe, mas ocorreu um erro quando sua sessão foi iniciada.",
        "launching.app.fallback.tryagain": "Se o __0__ não for iniciado, __3__tente novamente__4__ ou __1__baixe e execute o __0____2__.",
        "download.instructions.open.firefoxmac": "Clique no botão OK no canto inferior direito da caixa de diálogo para abrir o arquivo.",
        "launch.instructions.checkBoxToSkipMessageHint": "Quando esta mensagem aparecer no seu navegador, clique na caixa de seleção para saltar esta etapa da próxima vez que você entrar em uma sessão.",
        "launch.error.header": "Não é possível iniciar sua sessão",
        "installer.download.plugin.launch.app": "Siga as etapas do assistente de instalação.",
        "launch.button.text": "Iniciar o __0__",
        "download.instructions.animated.alttext": "Mostrar download na barra de ferramentas",
        "launch.instructions.h": "Entre na sessão mais rápido!",
        "download.instructions.animated.ie": "Clique em __1__Executar__2__ para iniciar o __0__.",
        "download.instructions.animated.safari1": "Clique em __2__ acima e depois dê um clique duplo em __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Impossível instalar o __0__",
        "download.plugin.launch.app": "Sua sessão deve começar em breve.",
        "trylaunching.app.h": "Tentativa de iniciar o __0__",
        "installer.launched.app.ingress": "A instalação deve começar em poucos segundos.",
        "launching.app.ingress.chrome": "Abrir GoTo Opener",
        "launching.app.ingress.safari": "Permitir",
        "download.plugin.connected.h": "Conectado ao __0__",
        "installer.plugin.clickonce.h": "Instalar o __0__",
        "launching.app.ingress": "Clique __0____2____1__ se o navegador solicitar.",
        "download.win.open.generic": "Clique duas vezes no arquivo para abri-lo.",
        "download.instructions.animated.chromemac1": "Clique no arquivo para abri-lo.",
        "download.plugin.download.ingress.restart": "O download deverá começar automaticamente em alguns segundos. Caso isso não ocorra, __0__reinicie o download__1__.",
        "download.instructions.run.dmg.mac": "Assim que uma janela abrir, dê um clique duplo no aplicativo __1____0____2__.",
        "download.win.ingress": "Um pequeno arquivo chamado __0____2__.exe__1__ está sendo baixado em seu computador.",
        "download.instructions.animated.firefoxwin1": "Clique em __0__Salvar arquivo__1__ na caixa de diálogo no centro.",
        "download.instructions.animated.firefoxwin2": "Clique em __3__ acima e depois clique em __1____0____2__ para começar.",
        "installer.plugin.started.h": "Pronto para instalar o __0__",
        "installer.error.ingress": "Infelizmente ocorreu um erro durante a instalação.",
        "download.plugin.clickonce.ingress": "Clique em __1__Iniciar o __0____2__. Se solicitado, clique em __3__Executar__4__ e sua sessão deverá começar em breve.",
        "trylaunching.app.fallback": "Se o __0__ não iniciar automaticamente, __1__baixe o __0____2__.",
        "download.plugin.download.open.product.h": "Abrir o __0__",
        "download.instructions.animated.chromewin": "Clique em __1____0____2__ para começar.",
        "launching.app.fallback": "Se o __0__ não for iniciado, __1__baixe e execute o __0____2__.",
        "installer.app.fallback": "Se a instalação do __0__ não começar, __1__baixe o instalador__2__.",
        "download.plugin.download.run.product.h": "Executar o __0__",
        "download.installer.app.silent.h": "Instalando __0__",
        "installer.plugin.started.silent.h": "__0__ instalado com sucesso",
        "launched.app.h": "Iniciando o __0__",
        "download.win.open.chrome": "Clique no arquivo para abri-lo.",
        "launching.app.ingress.firefox": "Abrir link",
        "launched.app.ingress": "Sua sessão deve ser conectada em alguns segundos.",
        "installer.plugin.clickonce.ingress": "Clique em __1__Instalar o __0____2__. Se solicitado, clique em __3__Executar__4__ e a instalação deverá começar em breve.",
        "download.instructions.animated.edge": "Primeiro __1__Salvar__2__ e depois __3__Executar__4__ o __0__.",
        "download.win.open.ff": "Clique no botão Downloads no canto superior direito do seu navegador e clique no arquivo para abri-lo.",
        "download.plugin.download.open.h": "Abrir o arquivo",
        "download.win.header": "Como instalar o __0__",
        "download.plugin.clickonce.h": "Iniciar o __0__",
        "download.unsupported.h": "Não há suporte para este sistema",
        "download.plugin.launch.app.closewindow": "Você pode fechar esta janela agora.",
        "installer.fallback.tryagain": "Se a instalação do __0__ não começar, __3__tente novamente__4__ ou __1__baixe o instalador__2__.",
        "download.win.run": "Se for solicitado, clique em Executar e o __1__ instalará automaticamente o __0__.",
        "launching.app.h": "Permitir que __0__ seja iniciado",
        "download.plugin.download.h": "Instalar o __0__",
        "launch.button.onerror.text": "Tente novamente",
        "launching.installer.h": "Permitir que __0__ seja instalado",
        "download.plugin.download.ingress.trylaunch": "Não consegue baixar? __0__ Veja se já está instalado__1__",
        "download.plugin.download.run.h": "Executar o Launcher"
    },
    fr: {
        "download.installer.app.h": "Démarrage de l'installation de __0__",
        "launch.error.ingress": "Une erreur s’est produite lors du démarrage de votre session, veuillez nous en excuser.",
        "launching.app.fallback.tryagain": "Si __0__ ne démarre pas, veuillez __3__réessayer__4__ ou __1__télécharger et exécuter __0____2__.",
        "download.instructions.open.firefoxmac": "Cliquez sur le bouton OK dans le coin inférieur droit de la boîte de dialogue pour ouvrir le fichier.",
        "launch.instructions.checkBoxToSkipMessageHint": "Lorsque vous voyez ce message apparaître dans votre navigateur, cliquez sur la case à cocher pour ignorer cette étape la prochaine fois que vous rejoignez une session.",
        "launch.error.header": "Impossible de démarrer votre session",
        "installer.download.plugin.launch.app": "Veuillez suivre les étapes dans l'Assistant d'installation.",
        "launch.button.text": "Lancer __0__",
        "download.instructions.animated.alttext": "Afficher les téléchargements dans la barre d'outils",
        "launch.instructions.h": "Rejoignez les sessions plus rapidement !",
        "download.instructions.animated.ie": "Cliquez sur __1__Exécuter__2__ pour démarrer __0__.",
        "download.instructions.animated.safari1": "Cliquez sur __2__ ci-dessus, puis cliquez deux fois sur __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Impossible d'installer __0__",
        "download.plugin.launch.app": "Votre session devrait bientôt démarrer.",
        "trylaunching.app.h": "Tentative de démarrage de __0__",
        "installer.launched.app.ingress": "L'installation devrait commencer dans quelques secondes.",
        "launching.app.ingress.chrome": "Ouvrir GoTo Opener",
        "launching.app.ingress.safari": "Autoriser",
        "download.plugin.connected.h": "Connecté à __0__",
        "installer.plugin.clickonce.h": "Installer __0__",
        "launching.app.ingress": "Cliquez sur __0____2____1__ à l'invite de votre navigateur.",
        "download.win.open.generic": "Cliquez deux fois sur le fichier pour l'ouvrir.",
        "download.instructions.animated.chromemac1": "Cliquez sur le fichier pour l'ouvrir.",
        "download.plugin.download.ingress.restart": "Le téléchargement devrait démarrer automatiquement dans quelques secondes, si cela n'est pas le cas, veuillez __0__redémarrer le téléchargement__1__.",
        "download.instructions.run.dmg.mac": "Une fois qu’une fenêtre est ouverte, cliquez deux fois sur l’application __1____0____2__.",
        "download.win.ingress": "Le fichier __0____2__.zip__1__ est en cours de téléchargement.",
        "download.instructions.animated.firefoxwin1": "Cliquez sur __0__Enregistrer le fichier__1__ dans la boîte de dialogue au centre.",
        "download.instructions.animated.firefoxwin2": "Cliquez sur __3__ ci-dessus, puis cliquez sur __1____0____2__ pour démarrer.",
        "installer.plugin.started.h": "Prêt à installer __0__",
        "installer.error.ingress": "Nous sommes désolés, mais une erreur est survenue lors de l'installation.",
        "download.plugin.clickonce.ingress": "Cliquez sur __1__Démarrer __0____2__. Lorsque vous y êtes invité, cliquez sur __3__Exécuter__4__ et votre session devrait bientôt démarrer.",
        "trylaunching.app.fallback": "Si __0__ ne démarre pas automatiquement, __1__téléchargez __0____2__.",
        "download.plugin.download.open.product.h": "Ouvrez __0__",
        "download.instructions.animated.chromewin": "Cliquez sur __1____0____2__ pour démarrer.",
        "launching.app.fallback": "Si __0__ ne se lance pas, veuillez __1__télécharger et exécuter __0____2__.",
        "installer.app.fallback": "Si l'installation de __0__ ne démarre pas, veuillez __1__télécharger le programme d'installation__2__.",
        "download.plugin.download.run.product.h": "Exécutez __0__",
        "download.installer.app.silent.h": "Installation de __0__",
        "installer.plugin.started.silent.h": "__0__ installé avec succès",
        "launched.app.h": "Démarrage de __0__ en cours",
        "download.win.open.chrome": "Cliquez sur le fichier pour l'ouvrir.",
        "launching.app.ingress.firefox": "Ouvrir le lien",
        "launched.app.ingress": "Votre session devrait se connecter dans quelques secondes.",
        "installer.plugin.clickonce.ingress": "Cliquez sur __1__Installer __0____2__. Si vous y êtes invité, cliquez sur __3__Exécuter__4__ et votre installation devrait commencer sous peu.",
        "download.instructions.animated.edge": "D'abord __1__Enregistrer__2__, puis __3__Exécuter__4__ __0__.",
        "download.win.open.ff": "Cliquez sur le bouton Téléchargements dans l'angle supérieur droit de votre navigateur puis cliquez sur le fichier pour l'ouvrir.",
        "download.plugin.download.open.h": "Ouvrir le fichier",
        "download.win.header": "Comment installer __0__",
        "download.plugin.clickonce.h": "Démarrer __0__",
        "download.unsupported.h": "Ce système n'est pas pris en charge.",
        "download.plugin.launch.app.closewindow": "Vous pouvez maintenant fermer cette fenêtre.",
        "installer.fallback.tryagain": "Si l'installation de __0__ ne démarre pas, veuillez __3__réessayer__4__ ou __1__télécharger le programme d'installation__2__.",
        "download.win.run": "Cliquez sur Exécuter si vous y êtes invité et __1__ installera automatiquement __0__.",
        "launching.app.h": "Autoriser __0__ à démarrer",
        "download.plugin.download.h": "Installer __0__",
        "launch.button.onerror.text": "Réessayez",
        "launching.installer.h": "Autoriser __0__ à s'installer",
        "download.plugin.download.ingress.trylaunch": "Téléchargement impossible ? __0__Vérifiez si le service est déjà installé__1__",
        "download.plugin.download.run.h": "Exécuter le lanceur"
    },
    es: {
        "download.installer.app.h": "Iniciando la instalación de __0__",
        "launch.error.ingress": "Lo sentimos, pero se ha producido un error al iniciar la sesión.",
        "launching.app.fallback.tryagain": "Si __0__ no se inicia, __3__vuelva a intentarlo__4__ o __1__descárguese y ejecute __0____2__.",
        "download.instructions.open.firefoxmac": "Haga clic en el botón OK en la esquina inferior derecha del cuadro de diálogo para abrir el archivo.",
        "launch.instructions.checkBoxToSkipMessageHint": "Cuando vea este mensaje en su explorador web, marque la casilla para omitir este paso la próxima vez que se una a una sesión.",
        "launch.error.header": "No se pudo iniciar la sesión",
        "installer.download.plugin.launch.app": "Siga los pasos indicados en el asistente de la instalación.",
        "launch.button.text": "Inicie __0__",
        "download.instructions.animated.alttext": "Mostrar descargas en la barra de herramientas",
        "launch.instructions.h": "¡Conéctese más rápido a las sesiones!",
        "download.instructions.animated.ie": "Haga clic en __1__Ejecutar__2__ para iniciar __0__.",
        "download.instructions.animated.safari1": "Haga clic en __2__ arriba, y luego haga doble clic en __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "No se puede instalar __0__",
        "download.plugin.launch.app": "La sesión comenzará en unos instantes.",
        "trylaunching.app.h": "Intentando iniciar __0__",
        "installer.launched.app.ingress": "La instalación debería comenzar en unos segundos.",
        "launching.app.ingress.chrome": "Abrir GoTo Opener",
        "launching.app.ingress.safari": "Permitir",
        "download.plugin.connected.h": "Se ha conectado a __0__",
        "installer.plugin.clickonce.h": "Instalar __0__",
        "launching.app.ingress": "Haga clic en __0____2____1__ si se lo pide el explorador web.",
        "download.win.open.generic": "Haga doble clic en el archivo para abrirlo.",
        "download.instructions.animated.chromemac1": "Haga clic en el archivo para abrirlo.",
        "download.plugin.download.ingress.restart": "La descarga debería empezar automáticamente en unos segundos. Si no, __0__reinicie la descarga__1__.",
        "download.instructions.run.dmg.mac": "Cuando se abra una ventana, haga doble clic en la aplicación __1____0____2__.",
        "download.win.ingress": "Se está descargando un pequeño archivo llamado __0____2__.exe__1__ en su equipo.",
        "download.instructions.animated.firefoxwin1": "Haga clic en __0__Guardar archivo__1__, en el cuadro de diálogo del centro.",
        "download.instructions.animated.firefoxwin2": "Haga clic en __3__ y, a continuación, haga clic en __1____0____2__ para empezar.",
        "installer.plugin.started.h": "Todo listo para instalar __0__",
        "installer.error.ingress": "Lo sentimos, pero se ha producido un error durante la instalación.",
        "download.plugin.clickonce.ingress": "Haga clic en __1__Iniciar __0____2__. Si recibe un aviso, haga clic en __3__Ejecutar__4__. La sesión debería iniciarse en unos instantes.",
        "trylaunching.app.fallback": "Si __0__ no se inicia automáticamente, __1__descargue __0__ manualmente__2__.",
        "download.plugin.download.open.product.h": "Abra __0__",
        "download.instructions.animated.chromewin": "Haga clic en __1____0____2__ para empezar.",
        "launching.app.fallback": "Si __0__ no se inicia, __1__descárguese y ejecute __0____2__.",
        "installer.app.fallback": "Si no se inicia la instalación de __0__, __1__descárguese el instalador__2__.",
        "download.plugin.download.run.product.h": "Ejecute __0__",
        "download.installer.app.silent.h": "Instalando __0__",
        "installer.plugin.started.silent.h": "Se ha instalado __0__ correctamente",
        "launched.app.h": "Iniciando __0__",
        "download.win.open.chrome": "Haga clic en el archivo para abrirlo.",
        "launching.app.ingress.firefox": "Abrir enlace",
        "launched.app.ingress": "La sesión debería conectarse en unos segundos.",
        "installer.plugin.clickonce.ingress": "Haga clic en __1__Instalar __0____2__. Si recibe un aviso, haga clic en __3__Ejecutar__4__. La instalación debería iniciarse en unos instantes.",
        "download.instructions.animated.edge": "Primero __1__guarde__2__ y luego __3__ejecute__4__ __0__.",
        "download.win.open.ff": "Haga clic en el botón Descargas, en la esquina superior derecha del explorador, y a continuación haga clic en el archivo para abrirlo.",
        "download.plugin.download.open.h": "Abra el archivo",
        "download.win.header": "Cómo instalar __0__",
        "download.plugin.clickonce.h": "Iniciar __0__",
        "download.unsupported.h": "El sistema no es compatible",
        "download.plugin.launch.app.closewindow": "Ya puede cerrar esta ventana.",
        "installer.fallback.tryagain": "Si no se inicia la instalación de __0__, __3__vuelva a intentarlo__4__ o __1__descárguese el instalador__2__.",
        "download.win.run": "Haga clic en Ejecutar si se le solicita y __1__ instalará automáticamente __0__.",
        "launching.app.h": "Espere a que __0__ se inicie",
        "download.plugin.download.h": "Instalar __0__",
        "launch.button.onerror.text": "Reintentar",
        "launching.installer.h": "Espere a que __0__ se instale",
        "download.plugin.download.ingress.trylaunch": "¿No puede descargarlo? __0__Compruebe si ya está instalado__1__",
        "download.plugin.download.run.h": "Ejecute el Launcher"
    },
    zh: {
        "download.installer.app.h": "正在启动 __0__ 的安装",
        "launch.error.ingress": "很抱歉，启动会话时出错。",
        "launching.app.fallback.tryagain": "如果 __0__ 未启动，请__3__重试__4__或__1__下载并运行 __0____2__。",
        "download.instructions.open.firefoxmac": "单击对话框右下角的“确定”按钮可打开文件。",
        "launch.instructions.checkBoxToSkipMessageHint": "看到此消息在浏览器中显示时，请单击复选框以在您下次加入会话时跳过此步骤。",
        "launch.error.header": "无法启动您的会话",
        "installer.download.plugin.launch.app": "请按照安装向导中的步骤进行操作。",
        "launch.button.text": "启动 __0__",
        "download.instructions.animated.alttext": "在工具栏中显示下载内容。",
        "launch.instructions.h": "更快地进入会话!",
        "download.instructions.animated.ie": "单击__1__运行__2__以启动 __0__。",
        "download.instructions.animated.safari1": "单击上面的 __2__，然后双击 __0__GoTo Opener.dmg__1__",
        "installer.error.header": "无法安装 __0__",
        "download.plugin.launch.app": "您的会话即将开始。",
        "trylaunching.app.h": "正在尝试启动 __0__",
        "installer.launched.app.ingress": "安装应在几秒钟内开始。",
        "launching.app.ingress.chrome": "打开 GoTo Opener",
        "launching.app.ingress.safari": "允许",
        "download.plugin.connected.h": "已连接到 __0__",
        "installer.plugin.clickonce.h": "安装 __0__",
        "launching.app.ingress": "请在浏览器提示时单击__0____2____1__。",
        "download.win.open.generic": "双击该文件可打开它。",
        "download.instructions.animated.chromemac1": "单击该文件可打开它。",
        "download.plugin.download.ingress.restart": "下载在几秒钟之后将自动开始，如果未开始，请__0__重新开始下载__1__。",
        "download.instructions.run.dmg.mac": "打开某个窗口后，双击 __1____0____2__ 应用程序。",
        "download.win.ingress": "一个名为 __0____2__.exe__1__ 的小文件正在您的计算机上下载。",
        "download.instructions.animated.firefoxwin1": "在中央的对话框中单击__0__保存文件__1__。",
        "download.instructions.animated.firefoxwin2": "单击上面的 __3__，然后单击 __1____0____2__ 开始操作。",
        "installer.plugin.started.h": "准备安装 __0__",
        "installer.error.ingress": "很抱歉，安装过程中出错。",
        "download.plugin.clickonce.ingress": "单击__1__启动 __0____2__。如果系统提示，请单击__3__运行__4__，您的会话将立即启动。",
        "trylaunching.app.fallback": "如果 __0__ 未自动启动，请__1__下载 __0____2__。",
        "download.plugin.download.open.product.h": "打开 __0__",
        "download.instructions.animated.chromewin": "单击 __1____0____2__ 以开始。",
        "launching.app.fallback": "如果 __0__ 未启动，请__1__下载并运行 __0____2__。",
        "installer.app.fallback": "如果 __0__ 安装未启动，请__1__下载安装程序__2__。",
        "download.plugin.download.run.product.h": "运行 __0__",
        "download.installer.app.silent.h": "正在安装 __0__",
        "installer.plugin.started.silent.h": "__0__ 已成功安装",
        "launched.app.h": "正在启动 __0__",
        "download.win.open.chrome": "单击该文件将其打开。",
        "launching.app.ingress.firefox": "打开链接",
        "launched.app.ingress": "您的会话应该会在几秒钟之内建立连接。",
        "installer.plugin.clickonce.ingress": "单击__1__安装 __0____2__。如果系统提示，请单击__3__运行__4__，您的安装应立即开始。",
        "download.instructions.animated.edge": "请先__1__保存__2__，然后再__3__运行__4__ __0__。",
        "download.win.open.ff": "单击浏览器右上角的“下载”按钮，然后单击该文件即可打开。",
        "download.plugin.download.open.h": "打开文件",
        "download.win.header": "如何安装 __0__",
        "download.plugin.clickonce.h": "启动 __0__",
        "download.unsupported.h": "不支持此系统",
        "download.plugin.launch.app.closewindow": "现在可以关闭此窗口。",
        "installer.fallback.tryagain": "如果 __0__ 安装未启动，请__3__重试__4__或__1__下载安装程序__2__。",
        "download.win.run": "在收到提示时单击“运行”，__1__ 启动器将自动安装 __0__。",
        "launching.app.h": "允许启动 __0__",
        "download.plugin.download.h": "安装 __0__",
        "launch.button.onerror.text": "重试",
        "launching.installer.h": "允许安装 __0__",
        "download.plugin.download.ingress.trylaunch": "无法下载吗? __0__查看是否已安装__1__",
        "download.plugin.download.run.h": "运行 Launcher"
    },
    cs: {
        "download.installer.app.h": "Spouští se instalace aplikace __0__",
        "launch.error.ingress": "Je nám líto, ale při zahajování relace došlo k chybě.",
        "launching.app.fallback.tryagain": "Pokud se aplikace __0__ nespustí, __3__zkuste to znovu__4__ nebo __1__stáhněte a spusťte aplikaci __0____2__.",
        "download.instructions.open.firefoxmac": "Otevřete soubor kliknutím na tlačítko OK v pravém dolním rohu dialogového okna.",
        "launch.instructions.checkBoxToSkipMessageHint": "Pokud se vám v prohlížeči zobrazí tato zpráva, po zaškrtnutí pole bude tento krok při příštím připojení k relaci přeskočen.",
        "launch.error.header": "Relaci nelze spustit",
        "installer.download.plugin.launch.app": "Řiďte se pokyny průvodce instalací.",
        "launch.button.text": "Spusťte __0__",
        "download.instructions.animated.alttext": "Zobrazit stažené soubory v panelu nástrojů",
        "launch.instructions.h": "Připojte se k relaci rychleji!",
        "download.instructions.animated.ie": "Kliknutím na tlačítko __1__Spustit__2__ spusťte aplikaci __0__.",
        "download.instructions.animated.safari1": "Klikněte na __2__ výše, pak poklepejte na __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Nelze nainstalovat aplikaci __0__",
        "download.plugin.launch.app": "Relace by měla zanedlouho začít.",
        "trylaunching.app.h": "Pokus o spuštění aplikace __0__",
        "installer.launched.app.ingress": "Instalace by se měla zahájit během několika sekund.",
        "launching.app.ingress.chrome": "Spustit aplikaci GoTo Opener",
        "launching.app.ingress.safari": "Povolit",
        "download.plugin.connected.h": "Připojeno k __0__",
        "installer.plugin.clickonce.h": "Instalovat __0__",
        "launching.app.ingress": "Pokud se zobrazí výzva prohlížeče, klikněte na __0____2____1__.",
        "download.win.open.generic": "Spusťte jej poklepáním.",
        "download.instructions.animated.chromemac1": "Klepnutím sem soubor otevřete.",
        "download.plugin.download.ingress.restart": "Stahování by mělo začít automaticky za několik vteřin. Pokud nezačne, __0__spusťte stahování znovu__1__.",
        "download.instructions.run.dmg.mac": "Po otevření okna poklepejte na aplikaci __1____0____2__.",
        "download.win.ingress": "Do vašeho počítače se stahuje malý soubor s názvem __0____2__.exe__1__.",
        "download.instructions.animated.firefoxwin1": "Klikněte na tlačítko __0__Uložit soubor__1__ v dialogovém okně uprostřed.",
        "download.instructions.animated.firefoxwin2": "Klikněte na __3__ výše a začněte otevřením __1____0____2__.",
        "installer.plugin.started.h": "Připraveno k instalaci aplikace __0__",
        "installer.error.ingress": "Omlouváme se, ale při instalaci došlo k chybě.",
        "download.plugin.clickonce.ingress": "Klikněte na příkaz __1__Spustit __0____2__. Pokud se zobrazí výzva, klikněte na tlačítko __3__Spustit__4__, a poté by měla relace zakrátko začít.",
        "trylaunching.app.fallback": "Pokud aplikace __0__ automaticky nespustí, __1__stáhněte __0____2__.",
        "download.plugin.download.open.product.h": "Otevřít aplikaci __0__",
        "download.instructions.animated.chromewin": "Začněte kliknutím na nástroj __1____0____2__.",
        "launching.app.fallback": "Pokud se aplikace __0__ nespustí, __1__stáhněte si a spusťte aplikaci __0____2__.",
        "installer.app.fallback": "Pokud se instalace aplikace __0__ nespustí, __1__stáhněte instalační program__2__.",
        "download.plugin.download.run.product.h": "Spustit aplikaci __0__",
        "download.installer.app.silent.h": "Probíhá instalace softwaru __0__",
        "installer.plugin.started.silent.h": "Software __0__ byl úspěšně nainstalován",
        "launched.app.h": "Spouští se __0__",
        "download.win.open.chrome": "Klepnutím sem soubor otevřete.",
        "launching.app.ingress.firefox": "Otevřít odkaz",
        "launched.app.ingress": "Relace by se měla připojit do několika sekund.",
        "installer.plugin.clickonce.ingress": "Klikněte na možnost __1__Nainstalovat aplikaci __0____2__. Pokud se zobrazí výzva, klikněte na tlačítko __3__Spustit__4__. Instalace se brzy spustí.",
        "download.instructions.animated.edge": "Nejdříve __1__uložte__2__ a poté __3__spusťte__4__ __0__.",
        "download.win.open.ff": "Klepněte na tlačítko Stáhnout v pravém horním rohu prohlížeče a potom soubor otevřete kliknutím na jeho název.",
        "download.plugin.download.open.h": "Otevřete soubor",
        "download.win.header": "Postup instalace aplikace __0__",
        "download.plugin.clickonce.h": "Spustit __0__",
        "download.unsupported.h": "Tento systém není podporován",
        "download.plugin.launch.app.closewindow": "Toto okno můžete zavřít.",
        "installer.fallback.tryagain": "Pokud se instalace aplikace __0__ nespustí, __3__zkuste to znovu__4__ nebo __1__stáhněte instalační program__2__.",
        "download.win.run": "Pokud se zobrazí výzva, klikněte na tlačítko Spustit a nástroj __1__ aplikaci __0__ automaticky instaluje.",
        "launching.app.h": "Povolit spuštění __0__",
        "download.plugin.download.h": "Instalovat __0__",
        "launch.button.onerror.text": "Zkuste to znovu",
        "launching.installer.h": "Povolit instalaci __0__",
        "download.plugin.download.ingress.trylaunch": "Nelze stáhnout? __0__Podívejte se, není-li plugin už nainstalován__1__.",
        "download.plugin.download.run.h": "Spusťte instalační program"
    },
    zh_TW: {
        "download.installer.app.h": "正在啟動 __0__ 安裝",
        "launch.error.ingress": "很抱歉，啟動您的工作階段時發生錯誤。",
        "launching.app.fallback.tryagain": "若 __0__ 未啟動，請__3__重試__4__或__1__下載並執行 __0____2__。",
        "download.instructions.open.firefoxmac": "按一下對話方塊右下角的 [確定] 按鈕，開啟該檔案。",
        "launch.instructions.checkBoxToSkipMessageHint": "瀏覽器中出現此訊息時，按一下核取方塊以在下次您加入工作階段時跳過此步驟。",
        "launch.error.header": "無法啟動您的工作階段",
        "installer.download.plugin.launch.app": "請依照安裝精靈中的步驟執行。",
        "launch.button.text": "啟動 __0__",
        "download.instructions.animated.alttext": "在工具列中顯示下載內容",
        "launch.instructions.h": "更快進入工作階段!",
        "download.instructions.animated.ie": "按一下 __1__[執行]__2__ 以啟動 __0__。",
        "download.instructions.animated.safari1": "按一下上面的 __2__，然後連按兩下 __0__GoTo Opener.dmg__1__。",
        "installer.error.header": "無法安裝 __0__",
        "download.plugin.launch.app": "您的工作階段應該很快就會開始。",
        "trylaunching.app.h": "正在嘗試啟動 __0__",
        "installer.launched.app.ingress": "安裝應該會在幾秒內啟動。",
        "launching.app.ingress.chrome": "開啟「GoTo Opener」",
        "launching.app.ingress.safari": "[允許]",
        "download.plugin.connected.h": "已連線到 __0__",
        "installer.plugin.clickonce.h": "安裝 __0__",
        "launching.app.ingress": "如果瀏覽器提示，請按下 __0____2____1__。",
        "download.win.open.generic": "連按兩下檔案以將其開啟。",
        "download.instructions.animated.chromemac1": "按一下檔案以將其開啟.",
        "download.plugin.download.ingress.restart": "下載應該會在幾秒鐘之內自動開始。如果沒有，請__0__重新啟動下載__1__。",
        "download.instructions.run.dmg.mac": "視窗開啟後，連按兩下 __1____0____2__ 應用程式。",
        "download.win.ingress": "電腦上正在下載名為 __0____2__.exe__1__ 的小型檔案。",
        "download.instructions.animated.firefoxwin1": "按一下中心對話方塊的 __0__[儲存檔案]__1__。",
        "download.instructions.animated.firefoxwin2": "按一下上面的 __3__，然後按一下 __1____0____2__ 以開始。",
        "installer.plugin.started.h": "準備好安裝 __0__",
        "installer.error.ingress": "很抱歉，安裝時發生錯誤。",
        "download.plugin.clickonce.ingress": "按一下 __1__[啟動 __0__]__2__。系統提示時，請按一下 __3__[執行]__4__，您的工作階段應該很快就會啟動。",
        "trylaunching.app.fallback": "如果 __0__ 未自動啟動，請__1__下載 __0____2__。",
        "download.plugin.download.open.product.h": "開啟 __0__",
        "download.instructions.animated.chromewin": "按一下 __1____0____2__ 以開始。",
        "launching.app.fallback": "若 __0__ 未啟動，請__1__下載並執行 __0____2__。",
        "installer.app.fallback": "如果 __0__ 的安裝未啟動，請__1__下載安裝程式__2__。",
        "download.plugin.download.run.product.h": "執行 __0__",
        "download.installer.app.silent.h": "正在安裝 __0__",
        "installer.plugin.started.silent.h": "__0__ 已成功安裝",
        "launched.app.h": "正在啟動 __0__",
        "download.win.open.chrome": "按一下檔案以將其開啟。",
        "launching.app.ingress.firefox": "開啟鏈結",
        "launched.app.ingress": "您的工作階段應該會在幾秒鐘內連線。",
        "installer.plugin.clickonce.ingress": "按一下 __1__[安裝 __0__]__2__。系統提示時，請按一下 __3__[執行]__4__，您的安裝應該很快就會啟動。",
        "download.instructions.animated.edge": "請先__1__儲存__2__，然後再__3__執行__4__ __0__。",
        "download.win.open.ff": "按一下瀏覽器右上角的 [下載] 按鈕，然後按一下檔案以將其開啟。",
        "download.plugin.download.open.h": "開啟檔案",
        "download.win.header": "如何安裝 __0__",
        "download.plugin.clickonce.h": "啟動 __0__",
        "download.unsupported.h": "系統不受支援",
        "download.plugin.launch.app.closewindow": "您現在可以關閉此視窗。",
        "installer.fallback.tryagain": "若 __0__ 安裝未啟動，請__3__重試__4__或__1__下載安裝程式__2__。",
        "download.win.run": "系統提示時，請按一下 [執行]，__1__ 將會自動安裝 __0__。",
        "launching.app.h": "允許 __0__ 啟動",
        "download.plugin.download.h": "安裝 __0__",
        "launch.button.onerror.text": "請重試",
        "launching.installer.h": "允許 __0__ 安裝",
        "download.plugin.download.ingress.trylaunch": "無法下載? __0__查看是否已安裝__1__",
        "download.plugin.download.run.h": "執行 Launcher"
    },
    nb: {
        "download.installer.app.h": "Starter installasjonen av __0__",
        "launch.error.ingress": "Beklager, en feil oppsto ved oppstart av økten.",
        "launching.app.fallback.tryagain": "Hvis ikke __0__ starter, må du __3__prøve på nytt__4__ eller __1__laste ned og kjøre __0____2__.",
        "download.instructions.open.firefoxmac": "Klikk OK-knappen nederst i høyre hjørne av dialogboksen for å åpne filen.",
        "launch.instructions.checkBoxToSkipMessageHint": "Når du ser denne meldingen i nettleseren, klikker du i avmerkingsboksen for å hoppe over dette trinnet neste gang du blir med i en økt.",
        "launch.error.header": "Kan ikke starte økten",
        "installer.download.plugin.launch.app": "Følg trinnene i installasjonsveiviseren.",
        "launch.button.text": "Start __0__",
        "download.instructions.animated.alttext": "Vis nedlastinger i verktøylinjen",
        "launch.instructions.h": "Start økten raskere!",
        "download.instructions.animated.ie": "Klikk __1__Kjør__2__ for å starte __0__.",
        "download.instructions.animated.safari1": "Klikk __2__ ovenfor, og dobbelklikk deretter __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Kunne ikke installere __0__",
        "download.plugin.launch.app": "Økten din vil starte om litt.",
        "trylaunching.app.h": "Prøver å starte __0__",
        "installer.launched.app.ingress": "Installasjonen skal starte etter noen sekunder.",
        "launching.app.ingress.chrome": "Åpne GoTo Opener",
        "launching.app.ingress.safari": "Tillat",
        "download.plugin.connected.h": "Koblet til __0__",
        "installer.plugin.clickonce.h": "Installer __0__",
        "launching.app.ingress": "Klikk på __0____2____1__ hvis du blir bedt om det av nettleseren.",
        "download.win.open.generic": "Dobbeltklikk på filen for å åpne den.",
        "download.instructions.animated.chromemac1": "Klikk på filen for å åpne den.",
        "download.plugin.download.ingress.restart": "Denne nedlastingen skal starte automatisk etter noen få sekunder, men hvis den ikke gjør dette kan du __0__starte nedlastingen på nytt__1__.",
        "download.instructions.run.dmg.mac": "Når det åpnes et vindu, dobbeltklikk __1____0____2__-programmet.",
        "download.win.ingress": "En liten fil med navnet __0____2__.exe__1__ blir lastet ned på datamaskinen din.",
        "download.instructions.animated.firefoxwin1": "Klikk __0__Lagre fil__1__ i dialogboksen i midten.",
        "download.instructions.animated.firefoxwin2": "Klikk __3__ ovenfor, og klikk deretter __1____0____2__ for å begynne.",
        "installer.plugin.started.h": "Klar til å installere __0__",
        "installer.error.ingress": "Beklager, det oppsto en feil under installasjonen.",
        "download.plugin.clickonce.ingress": "Klikk __1__Start __0____2__. Hvis du blir bedt om det, klikk på __3__Kjør__4__, og økten din vil starte snart.",
        "trylaunching.app.fallback": "Hvis __0__ ikke starter automatisk, kan du __1__laste ned __0____2__.",
        "download.plugin.download.open.product.h": "Åpne __0__",
        "download.instructions.animated.chromewin": "Klikk __1____0____2__ for å begynne.",
        "launching.app.fallback": "Hvis __0__ ikke starter, må du __1__laste ned og kjøre __0____2__.",
        "installer.app.fallback": "Hvis installasjonen av __0__ ikke starter, må du laste ned __1__installasjonsprogrammet__2__.",
        "download.plugin.download.run.product.h": "Kjør __0__",
        "download.installer.app.silent.h": "Installerer __0__",
        "installer.plugin.started.silent.h": "__0__ installert",
        "launched.app.h": "Starter __0__",
        "download.win.open.chrome": "Klikk på filen for å åpne den.",
        "launching.app.ingress.firefox": "Åpne lenke",
        "launched.app.ingress": "Økten din blir koblet til om noen få sekunder.",
        "installer.plugin.clickonce.ingress": "Klikk på __1__Installer __0____2__. Hvis du blir bedt om dette, klikker du på __3__Kjør__4__, så skal installasjonen starte etter et øyeblikk.",
        "download.instructions.animated.edge": "__1__Lagre__2__ først, __3__Kjør__4__ deretter __0__.",
        "download.win.open.ff": "Klikk på knappen Nedlastinger øverst til høyre i nettleseren, og klikk så på filen for å åpne den.",
        "download.plugin.download.open.h": "Åpne filen",
        "download.win.header": "Slik installerer du __0__",
        "download.plugin.clickonce.h": "Start __0__",
        "download.unsupported.h": "Dette systemet støttes ikke.",
        "download.plugin.launch.app.closewindow": "Du kan lukke dette vinduet nå.",
        "installer.fallback.tryagain": "Hvis installasjonen av __0__ ikke starter, må du __3__prøve på nytt__4__ eller __1__laste ned installasjonsprogrammet__2__.",
        "download.win.run": "Klikk på Kjør hvis du blir bedt om dette, og __1__ vil automatisk installere __0__.",
        "launching.app.h": "Tillat at __0__ starter",
        "download.plugin.download.h": "Installer __0__",
        "launch.button.onerror.text": "Prøv igjen",
        "launching.installer.h": "Tillat at __0__ installeres",
        "download.plugin.download.ingress.trylaunch": "Kan du ikke laste ned? __0__Sjekk om det allerede er installert__1__",
        "download.plugin.download.run.h": "Kjør Launcher-filen"
    },
    ja: {
        "download.installer.app.h": "__0__ のインストールを開始しています",
        "launch.error.ingress": "申し訳ありませんが、セッションの起動中にエラーが発生しました。",
        "launching.app.fallback.tryagain": "__0__ が起動しない場合は、__3__もう一度試してみるか、__4__または__1____0__をダウンロードして実行してください__2__。",
        "download.instructions.open.firefoxmac": "ファイルを開くにはダイアログ ボックスの右下にある [OK] をクリックします。",
        "launch.instructions.checkBoxToSkipMessageHint": "ブラウザーにこのメッセージが表示された場合、チェック ボックスをオンにすると、、次にセッションに参加するときにこの手順が省略されます。",
        "launch.error.header": "セッションを起動できません",
        "installer.download.plugin.launch.app": "インストールウィザードの指示に従ってください。",
        "launch.button.text": "__0__ を起動",
        "download.instructions.animated.alttext": "ダウンロード項目をツールバーに表示する",
        "launch.instructions.h": "すばやくセッションに参加するには",
        "download.instructions.animated.ie": "__1__[実行]__2__ をクリックして __0__ を起動します。",
        "download.instructions.animated.safari1": "上の __2__ をクリックしてから __0__GoTo Opener.dmg__1__ をダブルクリックします。",
        "installer.error.header": "__0__ をインストールできません",
        "download.plugin.launch.app": "間もなく、セッションが開始されます。",
        "trylaunching.app.h": "__0__ の起動を試みる",
        "installer.launched.app.ingress": "インストールが数秒以内に開始されます。",
        "launching.app.ingress.chrome": "GoTo Opener を開く",
        "launching.app.ingress.safari": "［許可］",
        "download.plugin.connected.h": "__0__ に接続しました",
        "installer.plugin.clickonce.h": "__0__ のインストール",
        "launching.app.ingress": "ブラウザでメッセージが表示されたら、__0____2____1__をクリックします。",
        "download.win.open.generic": "ファイルをダブルクリックして開きます。",
        "download.instructions.animated.chromemac1": "ファイルをクリックして開きます。",
        "download.plugin.download.ingress.restart": "通常は数秒後にダウンロードが自動的に開始されますが、開始されない場合は__0__ダウンロードを再試行__1__してください。",
        "download.instructions.run.dmg.mac": "ウィンドウが開いたら、__1____0____2__ アプリケーションをダブルクリックします。",
        "download.win.ingress": "__0____2__.exe__1__ という小さなファイルをお使いのコンピューターにダウンロードしています。",
        "download.instructions.animated.firefoxwin1": "中央のダイアログボックスで __0__[ファイルを保存]__1__ をクリックします。",
        "download.instructions.animated.firefoxwin2": "上の __3__ をクリックしてから __1____0____2__ をクリックして開始します。",
        "installer.plugin.started.h": "__0__ をインストールする準備ができました",
        "installer.error.ingress": "申し訳ありません。インストール中にエラーが発生しました。",
        "download.plugin.clickonce.ingress": "__1__[__0__ の起動]__2__ をクリックします。ダイアログ ボックスが開く場合は __3__[実行]__4__ をクリックすると、セッションがすぐに開始されます。",
        "trylaunching.app.fallback": "__0__が自動的に起動しなかったら、__1____0__をダウンロード__2__します。",
        "download.plugin.download.open.product.h": "__0__ を開きます",
        "download.instructions.animated.chromewin": "__1____0____2__ をクリックして実行します。",
        "launching.app.fallback": "__0__ が起動しない場合は、__1____0__ をダウンロードして実行__2__してください。",
        "installer.app.fallback": "__0__ のインストールが開始しない場合は、__1__インストーラーをダウンロードしてください__2__。",
        "download.plugin.download.run.product.h": "__0__ を実行します",
        "download.installer.app.silent.h": "__0__のインストール",
        "installer.plugin.started.silent.h": "__0__のインストールに成功しました",
        "launched.app.h": "__0__ を起動しています",
        "download.win.open.chrome": "ファイルをクリックして開きます。",
        "launching.app.ingress.firefox": "リンクを開く",
        "launched.app.ingress": "セッションは数秒以内に接続を確立します。",
        "installer.plugin.clickonce.ingress": "__1__［__0__ のインストール］__2__をクリックします。ダイアログボックスが開く場合は、__3__［実行］__4__をクリックするとインストールがすぐに開始されます。",
        "download.instructions.animated.edge": "__0__ を__1__保存__2__してから、__3__実行__4__してください。",
        "download.win.open.ff": "ブラウザの右上隅にある［ダウンロード］ボタンをクリックし、次にファイルをクリックして開きます。",
        "download.plugin.download.open.h": "ファイルを開く",
        "download.win.header": "__0__ のインストール方法",
        "download.plugin.clickonce.h": "__0__ の起動",
        "download.unsupported.h": "このシステムはサポートされていません",
        "download.plugin.launch.app.closewindow": "このウィンドウをすぐに閉じることができます。",
        "installer.fallback.tryagain": "__0__ のインストールが開始しない場合は、__3__もう一度試すか、__4__または__1__インストーラーをダウンロードしてください__2__。",
        "download.win.run": "ダイアログ ボックスが開く場合は [実行] をクリックすると、__1__ により __0__ が自動的にインストールされます。",
        "launching.app.h": "__0__ の起動を許可します",
        "download.plugin.download.h": "__0__ のインストール",
        "launch.button.onerror.text": "もう一度試す",
        "launching.installer.h": "__0__ のインストールを許可します",
        "download.plugin.download.ingress.trylaunch": "ダウンロードできませんか? __0__すでにインストール済みでないか確認してください__1__",
        "download.plugin.download.run.h": "Launcher の実行"
    },
    pl: {
        "download.installer.app.h": "Rozpoczynanie instalacji produktu __0__",
        "launch.error.ingress": "Przepraszamy, podczas rozpoczynania sesji wystąpił błąd.",
        "launching.app.fallback.tryagain": "Jeśli program __0__ nie zostanie uruchomiony, __3__spróbuj ponownie__4__ lub __1__pobierz go i uruchom__0____2__.",
        "download.instructions.open.firefoxmac": "Kliknij przycisk OK w prawym, dolnym rogu okna dialogowego, aby otworzyć plik.",
        "launch.instructions.checkBoxToSkipMessageHint": "Gdy zobaczysz ten komunikat w przeglądarce, zaznacz pole wyboru, aby pominąć ten krok podczas następnego dołączania do sesji.",
        "launch.error.header": "Nie można rozpocząć sesji",
        "installer.download.plugin.launch.app": "Postępuj zgodnie z krokami w kreatorze instalacji.",
        "launch.button.text": "Uruchom program __0__",
        "download.instructions.animated.alttext": "Pokaż pobrane pliki na pasku narzędzi",
        "launch.instructions.h": "Dołącz do sesji szybciej!",
        "download.instructions.animated.ie": "Kliknij przycisk __1__Uruchom__2__, aby uruchomić program __0__.",
        "download.instructions.animated.safari1": "Kliknij __2__ powyżej, a następnie kliknij dwukrotnie __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Nie można zainstalować produktu __0__",
        "download.plugin.launch.app": "Sesja powinna zacząć się wkrótce.",
        "trylaunching.app.h": "Spróbuj uruchomić __0__",
        "installer.launched.app.ingress": "Instalacja powinna się rozpocząć w ciągu kilku sekund.",
        "launching.app.ingress.chrome": "Otwórz GoTo Opener",
        "launching.app.ingress.safari": "Zezwól",
        "download.plugin.connected.h": "Połączono z __0__",
        "installer.plugin.clickonce.h": "Zainstaluj program __0__",
        "launching.app.ingress": "Jeśli przeglądarka wyświetli odpowiedni monit, kliknij polecenie __0____2____1__.",
        "download.win.open.generic": "Kliknij plik dwukrotnie, aby go otworzyć.",
        "download.instructions.animated.chromemac1": "Kliknij plik, aby go otworzyć.",
        "download.plugin.download.ingress.restart": "Pobieranie rozpocznie się automatycznie za kilka sekund, ale jeżeli tak się nie stanie, __0__uruchom pobieranie ponownie__1__.",
        "download.instructions.run.dmg.mac": "Po wyświetleniu okna kliknij dwukrotnie aplikację __1____0____2__.",
        "download.win.ingress": "Niewielki plik o nazwie __0____2__.exe__1__ jest pobierany na komputer.",
        "download.instructions.animated.firefoxwin1": "Kliknij przycisk __0__Zapisz plik__1__ w oknie dialogowym na środku.",
        "download.instructions.animated.firefoxwin2": "Aby rozpocząć, kliknij przycisk __3__ powyżej, a następnie kliknij __1____0____2__.",
        "installer.plugin.started.h": "Wszystko gotowe do instalacji produktu __0__",
        "installer.error.ingress": "Przepraszamy, podczas instalacji wystąpił błąd.",
        "download.plugin.clickonce.ingress": "Kliknij przycisk __1__Uruchom __0____2__. Jeżeli zostanie wyświetlony monit, kliknij przycisk __3__Uruchom__4__, a sesja powinna się wkrótce rozpocząć.",
        "trylaunching.app.fallback": "Jeśli __0__ nie uruchomi się automatycznie, __1__pobierz __0____2__.",
        "download.plugin.download.open.product.h": "Otwórz program __0__",
        "download.instructions.animated.chromewin": "Kliknij przycisk __1____0____2__, aby rozpocząć.",
        "launching.app.fallback": "Jeżeli program __0__ nie zostanie uruchomiony, __1__pobierz i uruchom aplikację __0____2__.",
        "installer.app.fallback": "Jeśli nie można uruchomić instalacji produktu __0__, __1__pobierz instalator__2__.",
        "download.plugin.download.run.product.h": "Uruchom program __0__",
        "download.installer.app.silent.h": "Instalowanie programu __0__",
        "installer.plugin.started.silent.h": "Instalowanie programu __0__ zakończyło się powodzeniem",
        "launched.app.h": "Uruchamianie __0__",
        "download.win.open.chrome": "Kliknij plik, aby go otworzyć.",
        "launching.app.ingress.firefox": "Otwórz",
        "launched.app.ingress": "Sesja powinna zostać połączona za kilka sekund.",
        "installer.plugin.clickonce.ingress": "Kliknij przycisk __1__Instaluj__0____2__. Jeżeli zostanie wyświetlony monit, kliknij przycisk __3__Uruchom__4__. Instalacja powinna się wkrótce rozpocząć.",
        "download.instructions.animated.edge": "Najpierw __1__zapisz__2__, a potem __3__uruchom__4__ program __0__.",
        "download.win.open.ff": "Kliknij przycisk Pliki do pobrania w prawym górnym rogu przeglądarki, a następnie kliknij plik, aby go otworzyć.",
        "download.plugin.download.open.h": "Otwórz plik",
        "download.win.header": "Jak zainstalować program __0__",
        "download.plugin.clickonce.h": "Uruchom __0__",
        "download.unsupported.h": "Ten system nie jest obsługiwany",
        "download.plugin.launch.app.closewindow": "Teraz można zamknąć to okno.",
        "installer.fallback.tryagain": "Jeśli nie można uruchomić instalacji produktu __0__, __3__spróbuj ponownie__4__ lub __1__pobierz instalator__2__.",
        "download.win.run": "Jeżeli zostanie wyświetlony monit, kliknij przycisk Uruchom, a oprogramowanie __1__ automatycznie zainstaluje program __0__.",
        "launching.app.h": "Pozwól uruchomić __0__",
        "download.plugin.download.h": "Zainstaluj program __0__",
        "launch.button.onerror.text": "Spróbuj ponownie",
        "launching.installer.h": "Pozwól na instalację produktu __0__",
        "download.plugin.download.ingress.trylaunch": "Nie można pobrać? __0__Sprawdź, czy już zainstalowano__1__",
        "download.plugin.download.run.h": "Uruchom aplikację uruchamiającą"
    },
    da: {
        "download.installer.app.h": "Starter installation af __0__",
        "launch.error.ingress": "Vi beklager, men der opstod en fejl under opstarten af din session.",
        "launching.app.fallback.tryagain": "Hvis __0__ ikke starter, skal du __3__prøve igen__4__ eller __1__hente og køre __0____2__.",
        "download.instructions.open.firefoxmac": "Klik på knappen OK i nederste højre hjørne af dialogboksen for at åbne filen.",
        "launch.instructions.checkBoxToSkipMessageHint": "Når du ser denne besked i browseren, skal du markere afkrydsningsfeltet for at springe dette trin over, næste gang du deltager i en session.",
        "launch.error.header": "Kan ikke starte din session",
        "installer.download.plugin.launch.app": "Følg vejledningen i installationsguiden.",
        "launch.button.text": "Start __0__",
        "download.instructions.animated.alttext": "Vis overførsler i værktøjslinjen",
        "launch.instructions.h": "Kom hurtigere i gang med en session!",
        "download.instructions.animated.ie": "Klik på __1__Kør__2__ for at starte __0__.",
        "download.instructions.animated.safari1": "Klik på __2__ ovenfor, og dobbeltklik derefter på __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Kunne ikke installere __0__",
        "download.plugin.launch.app": "Din session bør starte om lidt.",
        "trylaunching.app.h": "Prøver at starte __0__",
        "installer.launched.app.ingress": "Installationen bør starte om nogle få sekunder.",
        "launching.app.ingress.chrome": "Åbn GoTo Opener",
        "launching.app.ingress.safari": "Tillad",
        "download.plugin.connected.h": "Tilsluttet til __0__",
        "installer.plugin.clickonce.h": "Installer __0__",
        "launching.app.ingress": "Klik på __0____2____1__, hvis din browser anmoder om det.",
        "download.win.open.generic": "Dobbeltklik på filen for at åbne den.",
        "download.instructions.animated.chromemac1": "Klik på filen for at åbne den.",
        "download.plugin.download.ingress.restart": "Overførslen bør starte om et par sekunder, og ellers skal du __0__starte overførslen igen__1__.",
        "download.instructions.run.dmg.mac": "Når der åbnes et vindue, skal du dobbeltklikke på __1____0____2__-programmet.",
        "download.win.ingress": "En lille fil, der kaldes __0____2__.exe__1__, er ved at blive downloadet på din computer.",
        "download.instructions.animated.firefoxwin1": "Klik på __0__Gem fil__1__ i dialogboksen i midten.",
        "download.instructions.animated.firefoxwin2": "Klik på __3__ ovenfor, og klik derefter på __1____0____2__ for at starte.",
        "installer.plugin.started.h": "Klar til at installere __0__",
        "installer.error.ingress": "Vi beklager, men der opstod en fejl under installationen.",
        "download.plugin.clickonce.ingress": "Klik på __1__Start __0____2__. Hvis du bliver bedt om det, skal du klikke på __3__Kør__4__, hvorefter din session bør starte om lidt.",
        "trylaunching.app.fallback": "Hvis __0__ ikke starter automatisk, skal du downloade __1__ __0____2__.",
        "download.plugin.download.open.product.h": "Åbn __0__",
        "download.instructions.animated.chromewin": "Klik på __1____0____2__ for at starte.",
        "launching.app.fallback": "Hvis __0__ ikke starter, skal du __1__downloade og køre __0____2__.",
        "installer.app.fallback": "Hvis installationen af __0__ ikke starter, skal du __1__hente installationsprogrammet__2__.",
        "download.plugin.download.run.product.h": "Kør __0__",
        "download.installer.app.silent.h": "Installerer __0__",
        "installer.plugin.started.silent.h": "__0__ blev installeret",
        "launched.app.h": "Starter __0__",
        "download.win.open.chrome": "Klik på filen for at åbne den.",
        "launching.app.ingress.firefox": "Åbn link",
        "launched.app.ingress": "Din session bør starte om få sekunder.",
        "installer.plugin.clickonce.ingress": "Klik på __1__Installer __0____2__. Klik på __3__Kør__4__, hvis du bliver bedt om det. Installationen bør starte om et kort øjeblik.",
        "download.instructions.animated.edge": "__1__Gem__2__ først, __3__Kør__4__ derefter __0__.",
        "download.win.open.ff": "Klik på downloadknappen i øverste højre hjørne i browseren, og klik derefter på filen for at åbne den.",
        "download.plugin.download.open.h": "Åbn filen",
        "download.win.header": "Sådan installerer du __0__",
        "download.plugin.clickonce.h": "Start __0__",
        "download.unsupported.h": "Dette system understøttes ikke",
        "download.plugin.launch.app.closewindow": "Du kan lukke dette vindue nu.",
        "installer.fallback.tryagain": "Hvis installationen af __0__ ikke starter, skal du __3__prøve igen__4__ eller __1__hente installationsprogrammet__2__.",
        "download.win.run": "Klik på Kør, hvis du bliver bedt om det, så installerer __1__ automatisk __0__.",
        "launching.app.h": "Tillad start af __0__",
        "download.plugin.download.h": "Installer __0__",
        "launch.button.onerror.text": "Prøv igen",
        "launching.installer.h": "Tillad installation af __0__",
        "download.plugin.download.ingress.trylaunch": "Kan ikke downloade? __0__Se, om det allerede er installeret__1__",
        "download.plugin.download.run.h": "Kør Launcher"
    },
    nl: {
        "download.installer.app.h": "Beginnen met installatie van __0__",
        "launch.error.ingress": "Het spijt ons, maar er is een fout opgetreden tijdens het starten van uw sessie.",
        "launching.app.fallback.tryagain": "Als __0__ niet wordt gestart, __3__probeert u het opnieuw__4__ of kunt u __1____0__ downloaden en uitvoeren__2__.",
        "download.instructions.open.firefoxmac": "Klik op de knop OK in de rechterbenedenhoek van het dialoogvenster om het bestand te openen.",
        "launch.instructions.checkBoxToSkipMessageHint": "Wanneer dit bericht wordt weergegeven in uw browser, klikt u op het selectievakje om deze stap over te slaan als u de volgende keer een sessie start.",
        "launch.error.header": "Kan uw sessie niet starten",
        "installer.download.plugin.launch.app": "Volg de stappen in de installatiewizard.",
        "launch.button.text": "__0__ starten",
        "download.instructions.animated.alttext": "Downloads in de werkbalk weergeven",
        "launch.instructions.h": "Ga sneller naar de sessie!",
        "download.instructions.animated.ie": "Klik op __1__Uitvoeren__2__ om __0__ te starten.",
        "download.instructions.animated.safari1": "Klik op __2__ hierboven en dubbelklik vervolgens op __0__GoTo Opener.dmg__1__.",
        "installer.error.header": "Kan __0__ niet installeren",
        "download.plugin.launch.app": "Uw sessie start over enkele ogenblikken.",
        "trylaunching.app.h": "__0__ wordt geopend",
        "installer.launched.app.ingress": "De installatie moet binnen enkele seconden beginnen.",
        "launching.app.ingress.chrome": "GoTo Opener openen",
        "launching.app.ingress.safari": "Toestaan",
        "download.plugin.connected.h": "Verbonden met __0__",
        "installer.plugin.clickonce.h": "__0__ installeren",
        "launching.app.ingress": "Kies __0____2____1__ als uw browser daarom vraagt.",
        "download.win.open.generic": "Dubbelklik op dit bestand om het te openen.",
        "download.instructions.animated.chromemac1": "Klik op het bestand om het te openen.",
        "download.plugin.download.ingress.restart": "Het downloaden moet automatisch starten binnen een paar seconden. Als dit niet het geval is, __0__start u het downloaden opnieuw__1__.",
        "download.instructions.run.dmg.mac": "Dubbelklik zodra het venster is geopend op de toepassing __1____0____2__.",
        "download.win.ingress": "Er wordt een klein bestand genaamd __0____2__.exe__1__ naar uw computer gedownload.",
        "download.instructions.animated.firefoxwin1": "Klik op __0__Bestand opslaan__1__ in het dialoogvenster in het midden.",
        "download.instructions.animated.firefoxwin2": "Klik op __3__ hierboven en klik vervolgens op __1____0____2__ om te beginnen.",
        "installer.plugin.started.h": "Gereed om __0__ te installeren",
        "installer.error.ingress": "Het spijt ons, maar er is een fout opgetreden tijdens de installatie.",
        "download.plugin.clickonce.ingress": "Klik op __1____0__ starten__2__. Klik op __3__Uitvoeren__4__ als u daarom wordt gevraagd en uw sessie moet zo beginnen.",
        "trylaunching.app.fallback": "__1__Download __0____2__ als __0__ niet automatisch geopend wordt.",
        "download.plugin.download.open.product.h": "__0__ openen",
        "download.instructions.animated.chromewin": "Klik op __1____0____2__ om te beginnen.",
        "launching.app.fallback": "Als __0__ niet wordt gestart, moet u __1____0__ downloaden en installeren__2__.",
        "installer.app.fallback": "Als de installatie van __0__ niet begint, kunt u __1__het installatieprogramma downloaden__2__.",
        "download.plugin.download.run.product.h": "__0__ uitvoeren",
        "download.installer.app.silent.h": "__0__ wordt geïnstalleerd",
        "installer.plugin.started.silent.h": "__0__ is geïnstalleerd",
        "launched.app.h": "__0__ wordt gestart",
        "download.win.open.chrome": "Klik op het bestand om het te openen.",
        "launching.app.ingress.firefox": "Koppeling openen",
        "launched.app.ingress": "Uw sessie moet binnen een paar seconden verbinding maken.",
        "installer.plugin.clickonce.ingress": "Klik op __1____0__ installeren__2__. Klik op __3__Uitvoeren__4__ als u daarom wordt gevraagd en de installatie moet zo beginnen.",
        "download.instructions.animated.edge": "Eerst __1__Opslaan__2__, dan de __0__ __3__Uitvoeren__4__. ",
        "download.win.open.ff": "Klik op de knop Downloads in de rechterbovenhoek van uw browser en klik vervolgens op het bestand om het te openen.",
        "download.plugin.download.open.h": "Het bestand openen",
        "download.win.header": "Installatiehandleiding voor __0__",
        "download.plugin.clickonce.h": "__0__ starten",
        "download.unsupported.h": "Kan niet deelnemen aan de sessie",
        "download.plugin.launch.app.closewindow": "U kunt dit venster nu sluiten.",
        "installer.fallback.tryagain": "Als de installatie van __0__ niet begint, __3__probeert u het opnieuw__4__ of moet u __1__het installatieprogramma downloaden__2__.",
        "download.win.run": "Klik op Uitvoeren als u daarom wordt gevraagd. __1__ zal __0__ automatisch installeren.",
        "launching.app.h": "Sta toe dat __0__ wordt gestart",
        "download.plugin.download.h": "__0__ installeren",
        "launch.button.onerror.text": "Opnieuw proberen",
        "launching.installer.h": "Sta toe dat __0__ wordt geïnstalleerd",
        "download.plugin.download.ingress.trylaunch": "Downloaden niet mogelijk? __0__Controleer of het al is geïnstaleerd__1__.",
        "download.plugin.download.run.h": "De Launcher uitvoeren"
    },
    tr: {
        "download.installer.app.h": "__0__ yüklemesine başlanıyor",
        "launch.error.ingress": "Üzgünüz, oturumunuz başlatılırken bir hata oluştu.",
        "launching.app.fallback.tryagain": "__0__ uygulaması başlatılmazsa, lütfen __3__yeniden deneyin__4__ veya __0____2__ uygulamasını __1__karşıdan yükleyip çalıştırın.",
        "download.instructions.open.firefoxmac": "Dosyayı açmak için iletişim kutusunun sağ alt köşesindeki Tamam düğmesine tıklayın.",
        "launch.instructions.checkBoxToSkipMessageHint": "Bu mesajın tarayıcınızda görüntülendiğini gördüğünüzde bu adımı, bir oturuma katıldığınız sonraki seferde atlamak için onay kutusunu tıklayın.",
        "launch.error.header": "Oturumunuz başlatılamadı",
        "installer.download.plugin.launch.app": "Lütfen yükleme sihirbazı'ndaki adımları izleyin.",
        "launch.button.text": "__0__ uygulamasını başlat",
        "download.instructions.animated.alttext": "Karşıdan yüklemeleri araç çubuğunda göster",
        "launch.instructions.h": "Oturuma daha hızlı katılın!",
        "download.instructions.animated.ie": "__0__ uygulamasını başlatmak için __1__ Çalıştır __2__ öğesine tıklayın.",
        "download.instructions.animated.safari1": "Yukarıdaki __2__ öğesine ve ardından __0__GoTo Opener.dmg__1__ öğesine çift tıklayın.",
        "installer.error.header": "__0__ uygulaması yüklenemiyor",
        "download.plugin.launch.app": "Oturum kısa bir süre içinde başlayacaktır.",
        "trylaunching.app.h": "__0__ başlatılmaya çalışıyor",
        "installer.launched.app.ingress": "Kurulum birkaç saniye içinde başlayacaktır.",
        "launching.app.ingress.chrome": "GoTo Opener adlı uygulamayı aç",
        "launching.app.ingress.safari": "İzin Ver",
        "download.plugin.connected.h": "__0__ ile bağlantı kuruldu",
        "installer.plugin.clickonce.h": "__0__ uygulamasını yükle",
        "launching.app.ingress": "Tarayıcınız tarafından istenirse __0____2____1__ e tıklayın.",
        "download.win.open.generic": "Dosyayı açmak için çift üzerine tıklayın.",
        "download.instructions.animated.chromemac1": "Dosyayı açmak için üzerine tıklayın.",
        "download.plugin.download.ingress.restart": "Karşıdan yüklemenin birkaç saniye içinde otomatik olarak başlatılması gerekir, başlatılmazsa __0__ karşıdan yüklemeyi yeniden başlatın __1__.",
        "download.instructions.run.dmg.mac": "Pencere açıldığında, __1____0____2__ uygulamasına çift tıklayın.",
        "download.win.ingress": "__0____2__.exe __1__ adlı küçük bir dosya bilgisayarınıza yükleniyor.",
        "download.instructions.animated.firefoxwin1": "Ortadaki iletişim kutusunda yer alan __0__ Dosyayı Kaydet __1__ öğesine tıklayın.",
        "download.instructions.animated.firefoxwin2": "Yukarıdaki __3__ öğesine tıklatın ve ardından başlamak için __1____0____2__ öğesine tıklayın.",
        "installer.plugin.started.h": "__0__ uygulaması yüklenmeye hazır",
        "installer.error.ingress": "Üzgünüz ancak yükleme sırasında bir hata oluştu.",
        "download.plugin.clickonce.ingress": "__1____0__ uygulamasını başlat__2__ öğesine tıklayın. İstenirse __3__Çalıştır__4__ öğesine tıklayın, oturumunuz kısa bir süre içinde başlatılacaktır.",
        "trylaunching.app.fallback": "__0__ otomatik olarak başlamazsa, __1____0__ ürününü karşıdan yükleyin__2__.",
        "download.plugin.download.open.product.h": "__0__ uygulamasını açın",
        "download.instructions.animated.chromewin": "Başlamak için __1____0____2__ öğesine tıklayın.",
        "launching.app.fallback": "__0__ başlatılmazsa lütfen __0__ uygulamasını __1__karşıdan yükleyin ve çalıştırın__2__.",
        "installer.app.fallback": "__0__ yüklemesi başlamazsa, lütfen __1__yükleyiciyi indirin__2__.",
        "download.plugin.download.run.product.h": "__0__ uygulamasını çalıştırın",
        "download.installer.app.silent.h": "__0__ yükleniyor",
        "installer.plugin.started.silent.h": "__0__ başarıyla yüklendi",
        "launched.app.h": "__0__ başlatılıyor",
        "download.win.open.chrome": "Dosyayı açmak için üzerine tıklayın.",
        "launching.app.ingress.firefox": "Bağlantıyı aç",
        "launched.app.ingress": "Oturum birkaç saniye içinde bağlanacaktır.",
        "installer.plugin.clickonce.ingress": "__1____0__ Yükle__2__ seçeneğine tıklayın. Sorulması halinde __3__Çalıştır__4__ ögesine tıklayın. Yüklemeniz kısa süre içinde başlayacaktır.",
        "download.instructions.animated.edge": "İlk olarak __1__Kaydedin__2__, ardından __0__ öğesini __3__Çalıştırın__4__.",
        "download.win.open.ff": "Önce tarayıcınızın sağ üst bölümünde yer alan Karşıdan Yüklemeler düğmesine tıklayın ardından da dosyayı açmak için üzerine tıklayın.Önce tarayıcınızın sağ üst bölümünde yer alan Karşıdan Yüklemeler düğmesine tıklayın ardından da dosyayı açmak için üzerine tıklayın.",
        "download.plugin.download.open.h": "Dosyayı Aç",
        "download.win.header": "__0__ Uygulamasını Yükleme",
        "download.plugin.clickonce.h": "__0__ uygulamasını başlat",
        "download.unsupported.h": "Bu sistem desteklenmiyor",
        "download.plugin.launch.app.closewindow": "Artık bu pencereyi kapatabilirsiniz.",
        "installer.fallback.tryagain": "__0__ uygulaması yüklemesi başlamazsa, lütfen __3__yeniden deneyin__4__ veya __1__yükleyiciyi indirin__2__.",
        "download.win.run": "İstenirse Çalıştır'a tıklayın; __1__, otomatik olarak __0__ uygulamasını yükler.",
        "launching.app.h": "__0__ uygulamasının başlatılmasına izin verin",
        "download.plugin.download.h": "__0__ Uygulamasını Yükle",
        "launch.button.onerror.text": "Yeniden deneyin",
        "launching.installer.h": "__0__ uygulamasının yüklenmesine izin verin",
        "download.plugin.download.ingress.trylaunch": "İndirilemedi mi? __0__Zaten yüklü olup olmadığına bakın__1__",
        "download.plugin.download.run.h": "Launcher'ı çalıştır"
    }
});
define("launch-model", [ "jquery", "third-party/observable", "console", "user-agent-parser", "locale", "strings" ], function($, obs, console, userAgentParser, locale, msgs) {
    "use strict";
    var model = {
        INSTRUCTION: {
            DOWNLOADING: "DOWNLOADING",
            CLICKONCE: "CLICKONCE",
            LAUNCH_BY_CLICK: "LAUNCH_BY_CLICK",
            LAUNCHING_EP: "LAUNCHING_EP",
            LAUNCHING_APP: "LAUNCHING_APP",
            TRY_LAUNCHING_APP: "TRY_LAUNCHING_APP",
            LAUNCHED_APP: "LAUNCHED_APP"
        },
        STATE: {
            SUCCESS: "SUCCESS",
            ERROR: "ERROR",
            HOST_NOT_SUPPORTED: "HOST_NOT_SUPPORTED"
        },
        launchStarted: obs.observable(false),
        settingDocumentLocationCount: obs.observable(0),
        joinInstruction: obs.observable(null),
        joinState: obs.observable(null),
        detector: obs.observable(null),
        fallbackLinkDelay: obs.observable(5e3),
        userAgent: obs.observable(userAgentParser(navigator.userAgent)),
        token: obs.observable(null),
        host: obs.observable(null),
        product: obs.observable(null),
        apiVersion: obs.observable(null),
        flags: obs.observable({
            disableRedirects: false,
            renameFile: false,
            dontSetDocumentLocation: false,
            assumeClickToPlay: false,
            forceLauncherAppUpdate: false
        }),
        endpoint: obs.observable({
            builds: null,
            scheme: null,
            launchUrl: null,
            dontFallbackToBuildsBelow: 0
        }),
        abTest: obs.observable({}),
        appId: obs.observable(null),
        allowDownload: null
    };
    var validatedLocale = obs.observable(null).extend({
        notify: "always"
    });
    model.locale = obs.computed({
        read: function() {
            return validatedLocale();
        },
        write: function(value) {
            validatedLocale(locale.resolve(value, msgs));
        },
        owner: model
    });
    model.locale(null);
    model.launching = obs.computed(function() {
        var launchStarted = model.launchStarted(), state = model.joinState();
        return launchStarted && !state;
    });
    model.settingDocumentLocationCount.subscribe(function(newValue) {
        console.log("launcher.js: setting document.location count: ", newValue);
    });
    model.incrementSettingDocumentLocationCount = function() {
        model.settingDocumentLocationCount(model.settingDocumentLocationCount() + 1);
    };
    model.decrementSettingDocumentLocationCount = function() {
        model.settingDocumentLocationCount(model.settingDocumentLocationCount() - 1);
    };
    model.shouldIgnorePageUnloadEvents = obs.computed(function() {
        return !!model.settingDocumentLocationCount();
    });
    model.options = obs.computed(function() {
        var options = {
            token: model.token(),
            apiVersion: model.apiVersion(),
            host: model.host(),
            locale: model.locale(),
            userAgent: model.userAgent(),
            product: model.product(),
            abTest: model.abTest(),
            disableRedirects: model.flags().disableRedirects,
            dontSetDocumentLocation: model.flags().dontSetDocumentLocation,
            assumeClickToPlay: model.flags().assumeClickToPlay,
            forceLauncherAppUpdate: model.flags().forceLauncherAppUpdate,
            builds: model.endpoint().builds,
            scheme: model.endpoint().scheme,
            endpointLaunchUrl: model.endpoint().launchUrl,
            dontFallbackToBuildsBelow: model.endpoint().dontFallbackToBuildsBelow
        };
        return options;
    });
    model.currentState = obs.computed(function() {
        return {
            joinState: model.joinState(),
            joinInstruction: model.joinInstruction(),
            locale: model.locale()
        };
    });
    model.abbreviatedToken = obs.computed(function() {
        var token = model.token();
        if (!token) {
            return null;
        }
        return token.substring(0, 32);
    });
    model.protocol = obs.computed(function() {
        var host = model.host();
        if (!host) {
            return null;
        }
        if (host === window.location.host) {
            return window.location.protocol;
        }
        return "https:";
    });
    function createObservableState(state, stateName) {
        return obs.computed({
            read: function() {
                return state() === stateName;
            },
            write: function(newState) {
                if (newState === true) {
                    state(stateName);
                } else {
                    console.log("Can only set state to true, not " + stateName);
                }
            },
            owner: model
        });
    }
    var stateName;
    for (stateName in model.STATE) {
        if (model.STATE.hasOwnProperty(stateName)) {
            model["STATE_" + stateName] = createObservableState(model.joinState, stateName);
        }
    }
    for (stateName in model.INSTRUCTION) {
        if (model.INSTRUCTION.hasOwnProperty(stateName)) {
            model["IS_" + stateName] = createObservableState(model.joinInstruction, stateName);
        }
    }
    return model;
});
define("urls", [ "assert", "launch-model", "console" ], function(assert, launchModel, console) {
    "use strict";
    function escape(s) {
        return window.encodeURIComponent(s);
    }
    function formatUrl(localPath) {
        var formattedPath = localPath.replace(/\{(\w+)\}/g, function(match, key) {
            assert("launch model does not contain an entry for param '" + key + "' in string: " + localPath, launchModel.hasOwnProperty(key));
            assert("expected launch model to be a function for  '" + key + "' in string: " + localPath, typeof launchModel[key] === "function");
            return escape(launchModel[key]());
        });
        return launchModel.protocol() + "//" + launchModel.host() + "/launcher2/" + formattedPath;
    }
    function shouldRenameFile() {
        var userAgent = launchModel.userAgent();
        return launchModel.apiVersion() >= 2 && userAgent.is.WINDOWS;
    }
    function isMacDMG() {
        var userAgent = launchModel.userAgent();
        return userAgent.is.MACOS;
    }
    function isInstaller() {
        return launchModel.product() === "g2m_install";
    }
    return {
        connected: function(app) {
            var url = formatUrl("connected.html?token={token}");
            if (launchModel.locale()) {
                url = url + "&locale=" + escape(launchModel.locale());
            }
            if (app) {
                url = url + "&app=" + app;
            }
            return url;
        },
        jsStartingTelemetry: function() {
            return formatUrl("telemetry/javascript-starting");
        },
        launchTelemetry: function() {
            return formatUrl("telemetry/launch?token={token}");
        },
        appDownload: function(trigger) {
            assert("Expected appDownload() trigger to be set");
            var url, appId = launchModel.appId();
            if (isMacDMG()) {
                url = formatUrl("app/GoTo%20Opener.dmg?token={token}") + "&downloadTrigger=" + escape(trigger);
            } else {
                url = formatUrl("helper?token={token}") + "&downloadTrigger=" + escape(trigger);
                if (shouldRenameFile()) {
                    url += "&renameFile=1";
                }
                if (isInstaller()) {
                    url += "&isInstaller=1";
                }
            }
            if (appId) {
                url += "&appId=" + escape(appId);
            }
            return url;
        },
        launchStatus: function(lastReceivedStatus, lastReceivedTimestamp) {
            var url = formatUrl("launch-status?token={abbreviatedToken}");
            if (lastReceivedStatus) {
                url = url + "&lastReceivedStatus=" + escape(lastReceivedStatus);
            }
            if (lastReceivedTimestamp) {
                url = url + "&lastReceivedTimestamp=" + escape(lastReceivedTimestamp);
            }
            return url;
        },
        appLaunch: function(launchTrigger) {
            var url = "launch/{token}", appId = launchModel.appId(), nextSeparator = "?";
            if (launchModel.flags().forceLauncherAppUpdate) {
                url = "update/{token}";
            }
            url = formatUrl(url);
            if (launchTrigger) {
                url += nextSeparator + "launchTrigger=" + escape(launchTrigger);
                nextSeparator = "&";
            }
            if (appId) {
                url += nextSeparator + "appId=" + escape(appId);
                nextSeparator = "&";
            }
            url = url.replace("http://", "gotoopener://").replace("https://", "gotoopener://");
            return url;
        },
        endpointLaunchUrlForScheme: function(scheme, url) {
            return url.replace("http://", scheme + "://").replace("https://", scheme + "://");
        },
        unsupported: function() {
            return formatUrl("unsupported.html");
        },
        staticResource: function(path) {
            return formatUrl("static") + path;
        },
        clickOnce: function() {
            return formatUrl("latestClickOnce/StarterDotNet20.application?token={token}&product={product}");
        },
        restart: function() {
            return formatUrl("rest/restart/{token}");
        },
        isMacDMG: isMacDMG,
        shouldRenameFile: shouldRenameFile
    };
});
define("launch-telemetry-data", ['require','jquery'],function(require) {
    "use strict";
    var $ = require("jquery");
    var augmented = {};
    return {
        augment: function(newAugmentedData) {
            $.extend(augmented, newAugmentedData);
        },
        get: function() {
            return augmented;
        }
    };
});
define("util", ['require','safety','jquery','urls','console','launch-model','launch-telemetry-data'],function(require) {
    "use strict";
    var safety = require("safety"), $ = require("jquery"), urls = require("urls"), console = require("console"), launchModel = require("launch-model"), telemetryData = require("launch-telemetry-data");
    var searchQuery = window.location.search, zero = 0;
    return {
        keys: function(o) {
            var keys = [], i;
            for (i in o) {
                if (o.hasOwnProperty(i)) {
                    keys.push(i);
                }
            }
            return keys;
        },
        isInteger: function(x) {
            return typeof x === "number" && x % 1 === 0;
        },
        isArray: Array.isArray || function(arr) {
            return Object.prototype.toString.call(arr) === "[object Array]";
        },
        map: function(o, fn, initialObject) {
            var result = initialObject || (this.isArray(o) ? [] : {}), key;
            for (key in o) {
                if (o.hasOwnProperty(key)) {
                    result[key] = fn(o[key], key);
                }
            }
            return result;
        },
        now: function() {
            return new Date() - zero;
        },
        days_to_ms: function(n) {
            return n * 24 * 60 * 60 * 1e3;
        },
        download: function download(trigger) {
            var automaticDownloadUrl = urls.appDownload(trigger || "javascript");
            if (launchModel.flags().disableRedirects) {
                console.log("If you hadn't asked me not to, I would have downloaded " + automaticDownloadUrl);
            } else {
                var iframe = $("<iframe/>").attr("id", "autoDownloadFrame").attr("src", automaticDownloadUrl).hide();
                iframe.appendTo($("body"));
            }
        },
        queryParam: function queryParam(name, searchPart) {
            searchPart = searchPart || searchQuery;
            var re = new RegExp("[?&]" + encodeURIComponent(name) + "=([^&]*)"), match = re.exec(searchPart);
            return match && decodeURIComponent(match[1]) || null;
        },
        hasBanner: function hasBanner() {
            var userAgent = launchModel.userAgent(), apiVersion = launchModel.apiVersion();
            return apiVersion === 2 && (userAgent.is.MSIE && userAgent.browserVersion >= 9 || userAgent.is.MSEDGE || userAgent.is.CHROME && userAgent.is.WINDOWS || userAgent.is.CHROME && userAgent.is.MACOS || userAgent.is.FIREFOX && userAgent.is.WINDOWS || userAgent.is.SAFARI && userAgent.is.MACOS && userAgent.browserVersion >= 6);
        },
        isLaunchByIframeBroken: function() {
            var userAgent = launchModel.userAgent();
            return userAgent.is.CHROME && userAgent.browserVersion >= 30 && userAgent.browserVersion < 40 || userAgent.is.OPERA;
        },
        insideIframe: function() {
            return window !== window.parent;
        },
        isLaunchingBroken: function() {
            var userAgent = launchModel.userAgent(), userAgentString = userAgent.userAgent || "";
            return !!userAgent.is.WINDOWS && userAgent.platformVersion > 6.15 && userAgent.is.CHROME && userAgentString.indexOf("Chrome/35.0.1916.114") > 0;
        },
        runWhenReady: safety.collect(function(fn, requireReadyStateComplete) {
            var fnTriggered = false, doc = window.document;
            function docIsReady() {
                if (requireReadyStateComplete) {
                    return doc.readyState === "complete";
                }
                return doc.readyState === "complete" || doc.readyState === "interactive";
            }
            function ifNotYetDoneTriggerFn() {
                if (!fnTriggered) {
                    fnTriggered = true;
                    window.setTimeout(function() {
                        fn();
                    }, 0);
                }
            }
            function onEvent(event) {
                if (docIsReady()) {
                    ifNotYetDoneTriggerFn();
                    if (doc.addEventListener) {
                        doc.removeEventListener("DOMContentLoaded", onEvent, false);
                        doc.removeEventListener("readystatechange", onEvent, false);
                        window.removeEventListener("load", onEvent, false);
                    } else {
                        doc.detachEvent("onDOMContentLoaded", onEvent, false);
                        doc.detachEvent("onreadystatechange", onEvent, false);
                        window.detachEvent("onload", onEvent, false);
                    }
                }
            }
            if (docIsReady()) {
                console.log("launcher: function triggered directly, current readyState of page: ", doc.readyState);
                ifNotYetDoneTriggerFn();
            } else {
                console.log("launcher: function will be triggered when document is ready, current readyState of page: ", doc.readyState, " ready state 'complete' required: ", requireReadyStateComplete);
                if (doc.addEventListener) {
                    doc.addEventListener("DOMContentLoaded", onEvent, false);
                    doc.addEventListener("readystatechange", onEvent, false);
                    window.addEventListener("load", onEvent, false);
                } else {
                    doc.attachEvent("onDOMContentLoaded", onEvent, false);
                    doc.attachEvent("onreadystatechange", onEvent, false);
                    window.attachEvent("onload", onEvent, false);
                }
            }
        }),
        getMimeType: function() {
            var mimeTypes = {};
            return function(scheme) {
                var detectionAnchor;
                if (!mimeTypes.hasOwnProperty(scheme)) {
                    try {
                        detectionAnchor = document.createElement("a");
                        detectionAnchor.setAttribute("style", "visibility: hidden; display: none");
                        detectionAnchor.setAttribute("href", "https://foo." + scheme);
                        detectionAnchor = document.body.appendChild(detectionAnchor);
                        mimeTypes[scheme] = detectionAnchor.mimeType;
                    } catch (e) {
                        telemetryData.augment({
                            mimeTypeError: scheme
                        });
                    }
                }
                return mimeTypes[scheme];
            };
        }(),
        compareVersionStrings: function(versionA, versionB) {
            var arrA, arrB, maxLength, aSection, bSection, i = 0, re = /^\d+(?:\.\d+)*$/;
            if (typeof versionA !== "string" || typeof versionB !== "string" || !re.test(versionA) || !re.test(versionB)) {
                throw new Error("args should be valid version strings (dot-separated integers)");
            }
            arrA = versionA.split(".");
            arrB = versionB.split(".");
            maxLength = Math.max(arrA.length, arrB.length);
            while (arrA.length < maxLength) {
                arrA.push(0);
            }
            while (arrB.length < maxLength) {
                arrB.push(0);
            }
            do {
                aSection = parseInt(arrA[i], 10);
                bSection = parseInt(arrB[i], 10);
                i += 1;
            } while (i < maxLength && aSection === bSection);
            return aSection > bSection ? 1 : aSection < bSection ? -1 : 0;
        },
        bindToObservable: function bindToObservable(elementID, observableValue, bindingFn) {
            var el = document.getElementById(elementID);
            if (!el) {
                throw new Error('launcher-util: Cannot bind observable to element with id="' + elementID + '" - Element not found');
            }
            bindingFn(el, observableValue());
            observableValue.subscribe(function(newValue) {
                bindingFn(el, newValue);
            });
        },
        bindHtmlToObservable: function bindHtmlToObservable(elementID, observableValue) {
            this.bindToObservable(elementID, observableValue, function(element, value) {
                element.innerHTML = value;
            });
        },
        bindVisibleToObservable: function bindVisibleToObservable(elementID, observableValue) {
            this.bindToObservable(elementID, observableValue, function(element, value) {
                element.style.display = value ? "" : "none";
            });
        }
    };
});
define("localstorage-access", ['require','launch-telemetry-data'],function(require) {
    "use strict";
    var telemetryData = require("launch-telemetry-data");
    return {
        getItemSafe: function(key) {
            try {
                if (window.localStorage) {
                    return window.localStorage.getItem(key);
                }
            } catch (e) {
                telemetryData.augment({
                    localStorageError: "getItem"
                });
            }
            return null;
        },
        setItemSafe: function(key, value) {
            try {
                if (window.localStorage) {
                    window.localStorage.setItem(key, value);
                    return true;
                }
            } catch (e) {
                telemetryData.augment({
                    localStorageError: "setItem"
                });
            }
            return false;
        },
        removeItemSafe: function(key) {
            try {
                if (window.localStorage) {
                    window.localStorage.removeItem(key);
                    return true;
                }
            } catch (e) {
                telemetryData.augment({
                    localStorageError: "removeItem"
                });
            }
            return false;
        }
    };
});
define("success-storage", ['require','safety','util','console','localstorage-access'],function(require) {
    "use strict";
    var safety = require("safety"), util = require("util"), console = require("console"), localStorageAccess = require("localstorage-access"), MAX_AGE = util.days_to_ms(60), LOCAL_STORAGE_KEY = "launcher:last-success";
    return safety.collect({
        hasSuccess: function() {
            var lastSuccess, ago, freshEnough;
            lastSuccess = parseInt(localStorageAccess.getItemSafe(LOCAL_STORAGE_KEY), 10);
            if (!lastSuccess) {
                return false;
            }
            ago = util.now() - lastSuccess;
            freshEnough = ago < MAX_AGE;
            console.log("launcher.js: success-storage.hasSuccess(): Found lastSuccess: ", lastSuccess, " which was ago: ", ago, " max-age is: ", MAX_AGE, " so it is fresh enough: ", freshEnough);
            return freshEnough;
        },
        getLastSuccess: function() {
            return localStorageAccess.getItemSafe(LOCAL_STORAGE_KEY);
        },
        storeSuccess: function() {
            var now = util.now();
            var setItemWorked = localStorageAccess.setItemSafe(LOCAL_STORAGE_KEY, now);
            console.log("launcher.js: success-storage.storeSuccess(): ", now, " setItem to localStorage worked: ", setItemWorked);
        },
        removeSuccess: function() {
            var lastSuccess = localStorageAccess.getItemSafe(LOCAL_STORAGE_KEY);
            localStorageAccess.removeItemSafe(LOCAL_STORAGE_KEY);
            console.log("launcher.js: success-storage.removeSuccess(): removed ", lastSuccess);
        }
    });
});
define("launch-telemetry", ['require','jquery','urls','launch-model','util','success-storage','launch-telemetry-data'],function(require) {
    "use strict";
    var $ = require("jquery"), urls = require("urls"), model = require("launch-model"), util = require("util"), successStorage = require("success-storage"), data = require("launch-telemetry-data"), lastLaunchFunctionCalledTime = 0;
    function launchTelemetry(scheme, augmentedData) {
        var now = util.now(), detector = model.detector() || {}, modelFlags = model.flags(), flagData = {}, key, lastSuccess = successStorage.getLastSuccess(), lastSuccessSeconds = lastSuccess ? Math.round((now - lastSuccess) / 1e3) : undefined, locale = model.locale();
        for (key in modelFlags) {
            if (modelFlags.hasOwnProperty(key)) {
                flagData["f_" + key] = modelFlags[key];
            }
        }
        return $.ajax(urls.launchTelemetry(), {
            type: "GET",
            dataType: "jsonp",
            jsonp: "jsonp_callback",
            data: $.extend({}, data.get(), flagData, augmentedData, {
                launchedScheme: scheme,
                apiVersion: model.apiVersion(),
                pluginBuild: detector.pluginBuild || 0,
                pluginClickToPlay: detector.clickToPlay,
                appBuilds: detector.endpointBuildsForScheme && detector.endpointBuildsForScheme("gotoopener") || undefined,
                iframe: window !== window.parent,
                launchFuncTime: lastLaunchFunctionCalledTime ? now - lastLaunchFunctionCalledTime : undefined,
                launcherPageLoadTime: window.launcherPageLoadStartTime ? now - window.launcherPageLoadStartTime : undefined,
                hasSuccess: successStorage.hasSuccess(),
                lastSuccess: lastSuccessSeconds,
                locale: locale,
                product: model.product(),
                appId: model.appId()
            })
        });
    }
    launchTelemetry.markLaunchFunctionCalled = function() {
        lastLaunchFunctionCalledTime = util.now();
    };
    launchTelemetry.sendJavaScriptStartingTelemetry = function() {
        $.ajax(urls.jsStartingTelemetry(), {
            type: "GET",
            dataType: "jsonp",
            jsonp: "jsonp_callback"
        });
    };
    return launchTelemetry;
});
(function(root) {
    function CrossStorageClient(url, opts) {
        opts = opts || {};
        this._id = CrossStorageClient._generateUUID();
        this._promise = opts.promise || Promise;
        this._frameId = opts.frameId || "CrossStorageClient-" + this._id;
        this._origin = CrossStorageClient._getOrigin(url);
        this._requests = {};
        this._connected = false;
        this._closed = false;
        this._count = 0;
        this._timeout = opts.timeout || 5e3;
        this._listener = null;
        this._installListener();
        var frame;
        if (opts.frameId) {
            frame = document.getElementById(opts.frameId);
        }
        if (frame) {
            this._poll();
        }
        frame = frame || this._createFrame(url);
        this._hub = frame.contentWindow;
    }
    CrossStorageClient.frameStyle = {
        display: "none",
        position: "absolute",
        top: "-999px",
        left: "-999px"
    };
    CrossStorageClient._getOrigin = function(url) {
        var uri, protocol, origin;
        uri = document.createElement("a");
        uri.href = url;
        if (!uri.host) {
            uri = window.location;
        }
        if (!uri.protocol || uri.protocol === ":") {
            protocol = window.location.protocol;
        } else {
            protocol = uri.protocol;
        }
        origin = protocol + "//" + uri.host;
        origin = origin.replace(/:80$|:443$/, "");
        return origin;
    };
    CrossStorageClient._generateUUID = function() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    };
    CrossStorageClient.prototype.onConnect = function() {
        var client = this;
        if (this._connected) {
            return this._promise.resolve();
        } else if (this._closed) {
            return this._promise.reject(new Error("CrossStorageClient has closed"));
        }
        if (!this._requests.connect) {
            this._requests.connect = [];
        }
        return new this._promise(function(resolve, reject) {
            var timeout = setTimeout(function() {
                reject(new Error("CrossStorageClient could not connect"));
            }, client._timeout);
            client._requests.connect.push(function(err) {
                clearTimeout(timeout);
                if (err) return reject(err);
                resolve();
            });
        });
    };
    CrossStorageClient.prototype.set = function(key, value) {
        return this._request("set", {
            key: key,
            value: value
        });
    };
    CrossStorageClient.prototype.get = function(key) {
        var args = Array.prototype.slice.call(arguments);
        return this._request("get", {
            keys: args
        });
    };
    CrossStorageClient.prototype.del = function() {
        var args = Array.prototype.slice.call(arguments);
        return this._request("del", {
            keys: args
        });
    };
    CrossStorageClient.prototype.clear = function() {
        return this._request("clear");
    };
    CrossStorageClient.prototype.getKeys = function() {
        return this._request("getKeys");
    };
    CrossStorageClient.prototype.close = function() {
        var frame = document.getElementById(this._frameId);
        if (frame) {
            frame.parentNode.removeChild(frame);
        }
        if (window.removeEventListener) {
            window.removeEventListener("message", this._listener, false);
        } else {
            window.detachEvent("onmessage", this._listener);
        }
        this._connected = false;
        this._closed = true;
    };
    CrossStorageClient.prototype._installListener = function() {
        var client = this;
        this._listener = function(message) {
            var i, origin, error, response;
            if (client._closed || !message.data || typeof message.data !== "string") {
                return;
            }
            origin = message.origin === "null" ? "file://" : message.origin;
            if (origin !== client._origin) return;
            if (message.data === "cross-storage:unavailable") {
                if (!client._closed) client.close();
                if (!client._requests.connect) return;
                error = new Error("Closing client. Could not access localStorage in hub.");
                for (i = 0; i < client._requests.connect.length; i++) {
                    client._requests.connect[i](error);
                }
                return;
            }
            if (message.data.indexOf("cross-storage:") !== -1 && !client._connected) {
                client._connected = true;
                if (!client._requests.connect) return;
                for (i = 0; i < client._requests.connect.length; i++) {
                    client._requests.connect[i](error);
                }
                delete client._requests.connect;
            }
            if (message.data === "cross-storage:ready") return;
            try {
                response = JSON.parse(message.data);
            } catch (e) {
                return;
            }
            if (!response.id) return;
            if (client._requests[response.id]) {
                client._requests[response.id](response.error, response.result);
            }
        };
        if (window.addEventListener) {
            window.addEventListener("message", this._listener, false);
        } else {
            window.attachEvent("onmessage", this._listener);
        }
    };
    CrossStorageClient.prototype._poll = function() {
        var client, interval, targetOrigin;
        client = this;
        targetOrigin = client._origin === "file://" ? "*" : client._origin;
        interval = setInterval(function() {
            if (client._connected) return clearInterval(interval);
            if (!client._hub) return;
            client._hub.postMessage("cross-storage:poll", targetOrigin);
        }, 1e3);
    };
    CrossStorageClient.prototype._createFrame = function(url) {
        var frame, key;
        frame = window.document.createElement("iframe");
        frame.id = this._frameId;
        for (key in CrossStorageClient.frameStyle) {
            if (CrossStorageClient.frameStyle.hasOwnProperty(key)) {
                frame.style[key] = CrossStorageClient.frameStyle[key];
            }
        }
        window.document.body.appendChild(frame);
        frame.src = url;
        return frame;
    };
    CrossStorageClient.prototype._request = function(method, params) {
        var req, client;
        if (this._closed) {
            return this._promise.reject(new Error("CrossStorageClient has closed"));
        }
        client = this;
        client._count++;
        req = {
            id: this._id + ":" + client._count,
            method: "cross-storage:" + method,
            params: params
        };
        return new this._promise(function(resolve, reject) {
            var timeout, originalToJSON, targetOrigin;
            timeout = setTimeout(function() {
                if (!client._requests[req.id]) return;
                delete client._requests[req.id];
                reject(new Error("Timeout: could not perform " + req.method));
            }, client._timeout);
            client._requests[req.id] = function(err, result) {
                clearTimeout(timeout);
                delete client._requests[req.id];
                if (err) return reject(new Error(err));
                resolve(result);
            };
            if (Array.prototype.toJSON) {
                originalToJSON = Array.prototype.toJSON;
                Array.prototype.toJSON = null;
            }
            targetOrigin = client._origin === "file://" ? "*" : client._origin;
            client._hub.postMessage(JSON.stringify(req), targetOrigin);
            if (originalToJSON) {
                Array.prototype.toJSON = originalToJSON;
            }
        });
    };
    if (typeof module !== "undefined" && module.exports) {
        module.exports = CrossStorageClient;
    } else if (typeof exports !== "undefined") {
        exports.CrossStorageClient = CrossStorageClient;
    } else if (typeof define === "function" && define.amd) {
        define("third-party/cross-storage-client", [],function() {
            return CrossStorageClient;
        });
    } else {
        root.CrossStorageClient = CrossStorageClient;
    }
})(this);
(function(definition) {
    "use strict";
    if (typeof bootstrap === "function") {
        bootstrap("promise", definition);
    } else if (typeof exports === "object" && typeof module === "object") {
        module.exports = definition();
    } else if (typeof define === "function" && define.amd) {
        define("third-party/q", definition);
    } else if (typeof ses !== "undefined") {
        if (!ses.ok()) {
            return;
        } else {
            ses.makeQ = definition;
        }
    } else if (typeof self !== "undefined") {
        self.Q = definition();
    } else {
        throw new Error("This environment was not anticiapted by Q. Please file a bug.");
    }
})(function() {
    "use strict";
    var hasStacks = false;
    try {
        throw new Error();
    } catch (e) {
        hasStacks = !!e.stack;
    }
    var qStartingLine = captureLine();
    var qFileName;
    var noop = function() {};
    var nextTick = function() {
        var head = {
            task: void 0,
            next: null
        };
        var tail = head;
        var flushing = false;
        var requestTick = void 0;
        var isNodeJS = false;
        function flush() {
            while (head.next) {
                head = head.next;
                var task = head.task;
                head.task = void 0;
                var domain = head.domain;
                if (domain) {
                    head.domain = void 0;
                    domain.enter();
                }
                try {
                    task();
                } catch (e) {
                    if (isNodeJS) {
                        if (domain) {
                            domain.exit();
                        }
                        setTimeout(flush, 0);
                        if (domain) {
                            domain.enter();
                        }
                        throw e;
                    } else {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
                if (domain) {
                    domain.exit();
                }
            }
            flushing = false;
        }
        nextTick = function(task) {
            tail = tail.next = {
                task: task,
                domain: isNodeJS && process.domain,
                next: null
            };
            if (!flushing) {
                flushing = true;
                requestTick();
            }
        };
        if (typeof process !== "undefined" && process.nextTick) {
            isNodeJS = true;
            requestTick = function() {
                process.nextTick(flush);
            };
        } else if (typeof setImmediate === "function") {
            if (typeof window !== "undefined") {
                requestTick = setImmediate.bind(window, flush);
            } else {
                requestTick = function() {
                    setImmediate(flush);
                };
            }
        } else if (typeof MessageChannel !== "undefined") {
            var channel = new MessageChannel();
            channel.port1.onmessage = function() {
                requestTick = requestPortTick;
                channel.port1.onmessage = flush;
                flush();
            };
            var requestPortTick = function() {
                channel.port2.postMessage(0);
            };
            requestTick = function() {
                setTimeout(flush, 0);
                requestPortTick();
            };
        } else {
            requestTick = function() {
                setTimeout(flush, 0);
            };
        }
        return nextTick;
    }();
    var call = Function.call;
    function uncurryThis(f) {
        return function() {
            return call.apply(f, arguments);
        };
    }
    var array_slice = uncurryThis(Array.prototype.slice);
    var array_reduce = uncurryThis(Array.prototype.reduce || function(callback, basis) {
        var index = 0, length = this.length;
        if (arguments.length === 1) {
            do {
                if (index in this) {
                    basis = this[index++];
                    break;
                }
                if (++index >= length) {
                    throw new TypeError();
                }
            } while (1);
        }
        for (;index < length; index++) {
            if (index in this) {
                basis = callback(basis, this[index], index);
            }
        }
        return basis;
    });
    var array_indexOf = uncurryThis(Array.prototype.indexOf || function(value) {
        for (var i = 0; i < this.length; i++) {
            if (this[i] === value) {
                return i;
            }
        }
        return -1;
    });
    var array_map = uncurryThis(Array.prototype.map || function(callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function(undefined, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    });
    var object_create = Object.create || function(prototype) {
        function Type() {}
        Type.prototype = prototype;
        return new Type();
    };
    var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
    var object_keys = Object.keys || function(object) {
        var keys = [];
        for (var key in object) {
            if (object_hasOwnProperty(object, key)) {
                keys.push(key);
            }
        }
        return keys;
    };
    var object_toString = uncurryThis(Object.prototype.toString);
    function isObject(value) {
        return value === Object(value);
    }
    function isStopIteration(exception) {
        return object_toString(exception) === "[object StopIteration]" || exception instanceof QReturnValue;
    }
    var QReturnValue;
    if (typeof ReturnValue !== "undefined") {
        QReturnValue = ReturnValue;
    } else {
        QReturnValue = function(value) {
            this.value = value;
        };
    }
    var STACK_JUMP_SEPARATOR = "From previous event:";
    function makeStackTraceLong(error, promise) {
        if (hasStacks && promise.stack && typeof error === "object" && error !== null && error.stack && error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1) {
            var stacks = [];
            for (var p = promise; !!p; p = p.source) {
                if (p.stack) {
                    stacks.unshift(p.stack);
                }
            }
            stacks.unshift(error.stack);
            var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
            error.stack = filterStackString(concatedStacks);
        }
    }
    function filterStackString(stackString) {
        var lines = stackString.split("\n");
        var desiredLines = [];
        for (var i = 0; i < lines.length; ++i) {
            var line = lines[i];
            if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
                desiredLines.push(line);
            }
        }
        return desiredLines.join("\n");
    }
    function isNodeFrame(stackLine) {
        return stackLine.indexOf("(module.js:") !== -1 || stackLine.indexOf("(node.js:") !== -1;
    }
    function getFileNameAndLineNumber(stackLine) {
        var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
        if (attempt1) {
            return [ attempt1[1], Number(attempt1[2]) ];
        }
        var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
        if (attempt2) {
            return [ attempt2[1], Number(attempt2[2]) ];
        }
        var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
        if (attempt3) {
            return [ attempt3[1], Number(attempt3[2]) ];
        }
    }
    function isInternalFrame(stackLine) {
        var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);
        if (!fileNameAndLineNumber) {
            return false;
        }
        var fileName = fileNameAndLineNumber[0];
        var lineNumber = fileNameAndLineNumber[1];
        return fileName === qFileName && lineNumber >= qStartingLine && lineNumber <= qEndingLine;
    }
    function captureLine() {
        if (!hasStacks) {
            return;
        }
        try {
            throw new Error();
        } catch (e) {
            var lines = e.stack.split("\n");
            var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
            var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
            if (!fileNameAndLineNumber) {
                return;
            }
            qFileName = fileNameAndLineNumber[0];
            return fileNameAndLineNumber[1];
        }
    }
    function deprecate(callback, name, alternative) {
        return function() {
            if (typeof console !== "undefined" && typeof console.warn === "function") {
                console.warn(name + " is deprecated, use " + alternative + " instead.", new Error("").stack);
            }
            return callback.apply(callback, arguments);
        };
    }
    function Q(value) {
        if (value instanceof Promise) {
            return value;
        }
        if (isPromiseAlike(value)) {
            return coerce(value);
        } else {
            return fulfill(value);
        }
    }
    Q.resolve = Q;
    Q.nextTick = nextTick;
    Q.longStackSupport = false;
    if (typeof process === "object" && process && process.env && process.env.Q_DEBUG) {
        Q.longStackSupport = true;
    }
    Q.defer = defer;
    function defer() {
        var messages = [], progressListeners = [], resolvedPromise;
        var deferred = object_create(defer.prototype);
        var promise = object_create(Promise.prototype);
        promise.promiseDispatch = function(resolve, op, operands) {
            var args = array_slice(arguments);
            if (messages) {
                messages.push(args);
                if (op === "when" && operands[1]) {
                    progressListeners.push(operands[1]);
                }
            } else {
                Q.nextTick(function() {
                    resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
                });
            }
        };
        promise.valueOf = function() {
            if (messages) {
                return promise;
            }
            var nearerValue = nearer(resolvedPromise);
            if (isPromise(nearerValue)) {
                resolvedPromise = nearerValue;
            }
            return nearerValue;
        };
        promise.inspect = function() {
            if (!resolvedPromise) {
                return {
                    state: "pending"
                };
            }
            return resolvedPromise.inspect();
        };
        if (Q.longStackSupport && hasStacks) {
            try {
                throw new Error();
            } catch (e) {
                promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
            }
        }
        function become(newPromise) {
            resolvedPromise = newPromise;
            promise.source = newPromise;
            array_reduce(messages, function(undefined, message) {
                Q.nextTick(function() {
                    newPromise.promiseDispatch.apply(newPromise, message);
                });
            }, void 0);
            messages = void 0;
            progressListeners = void 0;
        }
        deferred.promise = promise;
        deferred.resolve = function(value) {
            if (resolvedPromise) {
                return;
            }
            become(Q(value));
        };
        deferred.fulfill = function(value) {
            if (resolvedPromise) {
                return;
            }
            become(fulfill(value));
        };
        deferred.reject = function(reason) {
            if (resolvedPromise) {
                return;
            }
            become(reject(reason));
        };
        deferred.notify = function(progress) {
            if (resolvedPromise) {
                return;
            }
            array_reduce(progressListeners, function(undefined, progressListener) {
                Q.nextTick(function() {
                    progressListener(progress);
                });
            }, void 0);
        };
        return deferred;
    }
    defer.prototype.makeNodeResolver = function() {
        var self = this;
        return function(error, value) {
            if (error) {
                self.reject(error);
            } else if (arguments.length > 2) {
                self.resolve(array_slice(arguments, 1));
            } else {
                self.resolve(value);
            }
        };
    };
    Q.Promise = promise;
    Q.promise = promise;
    function promise(resolver) {
        if (typeof resolver !== "function") {
            throw new TypeError("resolver must be a function.");
        }
        var deferred = defer();
        try {
            resolver(deferred.resolve, deferred.reject, deferred.notify);
        } catch (reason) {
            deferred.reject(reason);
        }
        return deferred.promise;
    }
    promise.race = race;
    promise.all = all;
    promise.reject = reject;
    promise.resolve = Q;
    Q.passByCopy = function(object) {
        return object;
    };
    Promise.prototype.passByCopy = function() {
        return this;
    };
    Q.join = function(x, y) {
        return Q(x).join(y);
    };
    Promise.prototype.join = function(that) {
        return Q([ this, that ]).spread(function(x, y) {
            if (x === y) {
                return x;
            } else {
                throw new Error("Can't join: not the same: " + x + " " + y);
            }
        });
    };
    Q.race = race;
    function race(answerPs) {
        return promise(function(resolve, reject) {
            for (var i = 0, len = answerPs.length; i < len; i++) {
                Q(answerPs[i]).then(resolve, reject);
            }
        });
    }
    Promise.prototype.race = function() {
        return this.then(Q.race);
    };
    Q.makePromise = Promise;
    function Promise(descriptor, fallback, inspect) {
        if (fallback === void 0) {
            fallback = function(op) {
                return reject(new Error("Promise does not support operation: " + op));
            };
        }
        if (inspect === void 0) {
            inspect = function() {
                return {
                    state: "unknown"
                };
            };
        }
        var promise = object_create(Promise.prototype);
        promise.promiseDispatch = function(resolve, op, args) {
            var result;
            try {
                if (descriptor[op]) {
                    result = descriptor[op].apply(promise, args);
                } else {
                    result = fallback.call(promise, op, args);
                }
            } catch (exception) {
                result = reject(exception);
            }
            if (resolve) {
                resolve(result);
            }
        };
        promise.inspect = inspect;
        if (inspect) {
            var inspected = inspect();
            if (inspected.state === "rejected") {
                promise.exception = inspected.reason;
            }
            promise.valueOf = function() {
                var inspected = inspect();
                if (inspected.state === "pending" || inspected.state === "rejected") {
                    return promise;
                }
                return inspected.value;
            };
        }
        return promise;
    }
    Promise.prototype.toString = function() {
        return "[object Promise]";
    };
    Promise.prototype.then = function(fulfilled, rejected, progressed) {
        var self = this;
        var deferred = defer();
        var done = false;
        function _fulfilled(value) {
            try {
                return typeof fulfilled === "function" ? fulfilled(value) : value;
            } catch (exception) {
                return reject(exception);
            }
        }
        function _rejected(exception) {
            if (typeof rejected === "function") {
                makeStackTraceLong(exception, self);
                try {
                    return rejected(exception);
                } catch (newException) {
                    return reject(newException);
                }
            }
            return reject(exception);
        }
        function _progressed(value) {
            return typeof progressed === "function" ? progressed(value) : value;
        }
        Q.nextTick(function() {
            self.promiseDispatch(function(value) {
                if (done) {
                    return;
                }
                done = true;
                deferred.resolve(_fulfilled(value));
            }, "when", [ function(exception) {
                if (done) {
                    return;
                }
                done = true;
                deferred.resolve(_rejected(exception));
            } ]);
        });
        self.promiseDispatch(void 0, "when", [ void 0, function(value) {
            var newValue;
            var threw = false;
            try {
                newValue = _progressed(value);
            } catch (e) {
                threw = true;
                if (Q.onerror) {
                    Q.onerror(e);
                } else {
                    throw e;
                }
            }
            if (!threw) {
                deferred.notify(newValue);
            }
        } ]);
        return deferred.promise;
    };
    Q.tap = function(promise, callback) {
        return Q(promise).tap(callback);
    };
    Promise.prototype.tap = function(callback) {
        callback = Q(callback);
        return this.then(function(value) {
            return callback.fcall(value).thenResolve(value);
        });
    };
    Q.when = when;
    function when(value, fulfilled, rejected, progressed) {
        return Q(value).then(fulfilled, rejected, progressed);
    }
    Promise.prototype.thenResolve = function(value) {
        return this.then(function() {
            return value;
        });
    };
    Q.thenResolve = function(promise, value) {
        return Q(promise).thenResolve(value);
    };
    Promise.prototype.thenReject = function(reason) {
        return this.then(function() {
            throw reason;
        });
    };
    Q.thenReject = function(promise, reason) {
        return Q(promise).thenReject(reason);
    };
    Q.nearer = nearer;
    function nearer(value) {
        if (isPromise(value)) {
            var inspected = value.inspect();
            if (inspected.state === "fulfilled") {
                return inspected.value;
            }
        }
        return value;
    }
    Q.isPromise = isPromise;
    function isPromise(object) {
        return object instanceof Promise;
    }
    Q.isPromiseAlike = isPromiseAlike;
    function isPromiseAlike(object) {
        return isObject(object) && typeof object.then === "function";
    }
    Q.isPending = isPending;
    function isPending(object) {
        return isPromise(object) && object.inspect().state === "pending";
    }
    Promise.prototype.isPending = function() {
        return this.inspect().state === "pending";
    };
    Q.isFulfilled = isFulfilled;
    function isFulfilled(object) {
        return !isPromise(object) || object.inspect().state === "fulfilled";
    }
    Promise.prototype.isFulfilled = function() {
        return this.inspect().state === "fulfilled";
    };
    Q.isRejected = isRejected;
    function isRejected(object) {
        return isPromise(object) && object.inspect().state === "rejected";
    }
    Promise.prototype.isRejected = function() {
        return this.inspect().state === "rejected";
    };
    var unhandledReasons = [];
    var unhandledRejections = [];
    var trackUnhandledRejections = true;
    function resetUnhandledRejections() {
        unhandledReasons.length = 0;
        unhandledRejections.length = 0;
        if (!trackUnhandledRejections) {
            trackUnhandledRejections = true;
        }
    }
    function trackRejection(promise, reason) {
        if (!trackUnhandledRejections) {
            return;
        }
        unhandledRejections.push(promise);
        if (reason && typeof reason.stack !== "undefined") {
            unhandledReasons.push(reason.stack);
        } else {
            unhandledReasons.push("(no stack) " + reason);
        }
    }
    function untrackRejection(promise) {
        if (!trackUnhandledRejections) {
            return;
        }
        var at = array_indexOf(unhandledRejections, promise);
        if (at !== -1) {
            unhandledRejections.splice(at, 1);
            unhandledReasons.splice(at, 1);
        }
    }
    Q.resetUnhandledRejections = resetUnhandledRejections;
    Q.getUnhandledReasons = function() {
        return unhandledReasons.slice();
    };
    Q.stopUnhandledRejectionTracking = function() {
        resetUnhandledRejections();
        trackUnhandledRejections = false;
    };
    resetUnhandledRejections();
    Q.reject = reject;
    function reject(reason) {
        var rejection = Promise({
            when: function(rejected) {
                if (rejected) {
                    untrackRejection(this);
                }
                return rejected ? rejected(reason) : this;
            }
        }, function fallback() {
            return this;
        }, function inspect() {
            return {
                state: "rejected",
                reason: reason
            };
        });
        trackRejection(rejection, reason);
        return rejection;
    }
    Q.fulfill = fulfill;
    function fulfill(value) {
        return Promise({
            when: function() {
                return value;
            },
            get: function(name) {
                return value[name];
            },
            set: function(name, rhs) {
                value[name] = rhs;
            },
            "delete": function(name) {
                delete value[name];
            },
            post: function(name, args) {
                if (name === null || name === void 0) {
                    return value.apply(void 0, args);
                } else {
                    return value[name].apply(value, args);
                }
            },
            apply: function(thisp, args) {
                return value.apply(thisp, args);
            },
            keys: function() {
                return object_keys(value);
            }
        }, void 0, function inspect() {
            return {
                state: "fulfilled",
                value: value
            };
        });
    }
    function coerce(promise) {
        var deferred = defer();
        Q.nextTick(function() {
            try {
                promise.then(deferred.resolve, deferred.reject, deferred.notify);
            } catch (exception) {
                deferred.reject(exception);
            }
        });
        return deferred.promise;
    }
    Q.master = master;
    function master(object) {
        return Promise({
            isDef: function() {}
        }, function fallback(op, args) {
            return dispatch(object, op, args);
        }, function() {
            return Q(object).inspect();
        });
    }
    Q.spread = spread;
    function spread(value, fulfilled, rejected) {
        return Q(value).spread(fulfilled, rejected);
    }
    Promise.prototype.spread = function(fulfilled, rejected) {
        return this.all().then(function(array) {
            return fulfilled.apply(void 0, array);
        }, rejected);
    };
    Q.async = async;
    function async(makeGenerator) {
        return function() {
            function continuer(verb, arg) {
                var result;
                if (typeof StopIteration === "undefined") {
                    try {
                        result = generator[verb](arg);
                    } catch (exception) {
                        return reject(exception);
                    }
                    if (result.done) {
                        return Q(result.value);
                    } else {
                        return when(result.value, callback, errback);
                    }
                } else {
                    try {
                        result = generator[verb](arg);
                    } catch (exception) {
                        if (isStopIteration(exception)) {
                            return Q(exception.value);
                        } else {
                            return reject(exception);
                        }
                    }
                    return when(result, callback, errback);
                }
            }
            var generator = makeGenerator.apply(this, arguments);
            var callback = continuer.bind(continuer, "next");
            var errback = continuer.bind(continuer, "throw");
            return callback();
        };
    }
    Q.spawn = spawn;
    function spawn(makeGenerator) {
        Q.done(Q.async(makeGenerator)());
    }
    Q["return"] = _return;
    function _return(value) {
        throw new QReturnValue(value);
    }
    Q.promised = promised;
    function promised(callback) {
        return function() {
            return spread([ this, all(arguments) ], function(self, args) {
                return callback.apply(self, args);
            });
        };
    }
    Q.dispatch = dispatch;
    function dispatch(object, op, args) {
        return Q(object).dispatch(op, args);
    }
    Promise.prototype.dispatch = function(op, args) {
        var self = this;
        var deferred = defer();
        Q.nextTick(function() {
            self.promiseDispatch(deferred.resolve, op, args);
        });
        return deferred.promise;
    };
    Q.get = function(object, key) {
        return Q(object).dispatch("get", [ key ]);
    };
    Promise.prototype.get = function(key) {
        return this.dispatch("get", [ key ]);
    };
    Q.set = function(object, key, value) {
        return Q(object).dispatch("set", [ key, value ]);
    };
    Promise.prototype.set = function(key, value) {
        return this.dispatch("set", [ key, value ]);
    };
    Q.del = Q["delete"] = function(object, key) {
        return Q(object).dispatch("delete", [ key ]);
    };
    Promise.prototype.del = Promise.prototype["delete"] = function(key) {
        return this.dispatch("delete", [ key ]);
    };
    Q.mapply = Q.post = function(object, name, args) {
        return Q(object).dispatch("post", [ name, args ]);
    };
    Promise.prototype.mapply = Promise.prototype.post = function(name, args) {
        return this.dispatch("post", [ name, args ]);
    };
    Q.send = Q.mcall = Q.invoke = function(object, name) {
        return Q(object).dispatch("post", [ name, array_slice(arguments, 2) ]);
    };
    Promise.prototype.send = Promise.prototype.mcall = Promise.prototype.invoke = function(name) {
        return this.dispatch("post", [ name, array_slice(arguments, 1) ]);
    };
    Q.fapply = function(object, args) {
        return Q(object).dispatch("apply", [ void 0, args ]);
    };
    Promise.prototype.fapply = function(args) {
        return this.dispatch("apply", [ void 0, args ]);
    };
    Q["try"] = Q.fcall = function(object) {
        return Q(object).dispatch("apply", [ void 0, array_slice(arguments, 1) ]);
    };
    Promise.prototype.fcall = function() {
        return this.dispatch("apply", [ void 0, array_slice(arguments) ]);
    };
    Q.fbind = function(object) {
        var promise = Q(object);
        var args = array_slice(arguments, 1);
        return function fbound() {
            return promise.dispatch("apply", [ this, args.concat(array_slice(arguments)) ]);
        };
    };
    Promise.prototype.fbind = function() {
        var promise = this;
        var args = array_slice(arguments);
        return function fbound() {
            return promise.dispatch("apply", [ this, args.concat(array_slice(arguments)) ]);
        };
    };
    Q.keys = function(object) {
        return Q(object).dispatch("keys", []);
    };
    Promise.prototype.keys = function() {
        return this.dispatch("keys", []);
    };
    Q.all = all;
    function all(promises) {
        return when(promises, function(promises) {
            var countDown = 0;
            var deferred = defer();
            array_reduce(promises, function(undefined, promise, index) {
                var snapshot;
                if (isPromise(promise) && (snapshot = promise.inspect()).state === "fulfilled") {
                    promises[index] = snapshot.value;
                } else {
                    ++countDown;
                    when(promise, function(value) {
                        promises[index] = value;
                        if (--countDown === 0) {
                            deferred.resolve(promises);
                        }
                    }, deferred.reject, function(progress) {
                        deferred.notify({
                            index: index,
                            value: progress
                        });
                    });
                }
            }, void 0);
            if (countDown === 0) {
                deferred.resolve(promises);
            }
            return deferred.promise;
        });
    }
    Promise.prototype.all = function() {
        return all(this);
    };
    Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
    function allResolved(promises) {
        return when(promises, function(promises) {
            promises = array_map(promises, Q);
            return when(all(array_map(promises, function(promise) {
                return when(promise, noop, noop);
            })), function() {
                return promises;
            });
        });
    }
    Promise.prototype.allResolved = function() {
        return allResolved(this);
    };
    Q.allSettled = allSettled;
    function allSettled(promises) {
        return Q(promises).allSettled();
    }
    Promise.prototype.allSettled = function() {
        return this.then(function(promises) {
            return all(array_map(promises, function(promise) {
                promise = Q(promise);
                function regardless() {
                    return promise.inspect();
                }
                return promise.then(regardless, regardless);
            }));
        });
    };
    Q.fail = Q["catch"] = function(object, rejected) {
        return Q(object).then(void 0, rejected);
    };
    Promise.prototype.fail = Promise.prototype["catch"] = function(rejected) {
        return this.then(void 0, rejected);
    };
    Q.progress = progress;
    function progress(object, progressed) {
        return Q(object).then(void 0, void 0, progressed);
    }
    Promise.prototype.progress = function(progressed) {
        return this.then(void 0, void 0, progressed);
    };
    Q.fin = Q["finally"] = function(object, callback) {
        return Q(object)["finally"](callback);
    };
    Promise.prototype.fin = Promise.prototype["finally"] = function(callback) {
        callback = Q(callback);
        return this.then(function(value) {
            return callback.fcall().then(function() {
                return value;
            });
        }, function(reason) {
            return callback.fcall().then(function() {
                throw reason;
            });
        });
    };
    Q.done = function(object, fulfilled, rejected, progress) {
        return Q(object).done(fulfilled, rejected, progress);
    };
    Promise.prototype.done = function(fulfilled, rejected, progress) {
        var onUnhandledError = function(error) {
            Q.nextTick(function() {
                makeStackTraceLong(error, promise);
                if (Q.onerror) {
                    Q.onerror(error);
                } else {
                    throw error;
                }
            });
        };
        var promise = fulfilled || rejected || progress ? this.then(fulfilled, rejected, progress) : this;
        if (typeof process === "object" && process && process.domain) {
            onUnhandledError = process.domain.bind(onUnhandledError);
        }
        promise.then(void 0, onUnhandledError);
    };
    Q.timeout = function(object, ms, error) {
        return Q(object).timeout(ms, error);
    };
    Promise.prototype.timeout = function(ms, error) {
        var deferred = defer();
        var timeoutId = setTimeout(function() {
            if (!error || "string" === typeof error) {
                error = new Error(error || "Timed out after " + ms + " ms");
                error.code = "ETIMEDOUT";
            }
            deferred.reject(error);
        }, ms);
        this.then(function(value) {
            clearTimeout(timeoutId);
            deferred.resolve(value);
        }, function(exception) {
            clearTimeout(timeoutId);
            deferred.reject(exception);
        }, deferred.notify);
        return deferred.promise;
    };
    Q.delay = function(object, timeout) {
        if (timeout === void 0) {
            timeout = object;
            object = void 0;
        }
        return Q(object).delay(timeout);
    };
    Promise.prototype.delay = function(timeout) {
        return this.then(function(value) {
            var deferred = defer();
            setTimeout(function() {
                deferred.resolve(value);
            }, timeout);
            return deferred.promise;
        });
    };
    Q.nfapply = function(callback, args) {
        return Q(callback).nfapply(args);
    };
    Promise.prototype.nfapply = function(args) {
        var deferred = defer();
        var nodeArgs = array_slice(args);
        nodeArgs.push(deferred.makeNodeResolver());
        this.fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
    Q.nfcall = function(callback) {
        var args = array_slice(arguments, 1);
        return Q(callback).nfapply(args);
    };
    Promise.prototype.nfcall = function() {
        var nodeArgs = array_slice(arguments);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        this.fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
    Q.nfbind = Q.denodeify = function(callback) {
        var baseArgs = array_slice(arguments, 1);
        return function() {
            var nodeArgs = baseArgs.concat(array_slice(arguments));
            var deferred = defer();
            nodeArgs.push(deferred.makeNodeResolver());
            Q(callback).fapply(nodeArgs).fail(deferred.reject);
            return deferred.promise;
        };
    };
    Promise.prototype.nfbind = Promise.prototype.denodeify = function() {
        var args = array_slice(arguments);
        args.unshift(this);
        return Q.denodeify.apply(void 0, args);
    };
    Q.nbind = function(callback, thisp) {
        var baseArgs = array_slice(arguments, 2);
        return function() {
            var nodeArgs = baseArgs.concat(array_slice(arguments));
            var deferred = defer();
            nodeArgs.push(deferred.makeNodeResolver());
            function bound() {
                return callback.apply(thisp, arguments);
            }
            Q(bound).fapply(nodeArgs).fail(deferred.reject);
            return deferred.promise;
        };
    };
    Promise.prototype.nbind = function() {
        var args = array_slice(arguments, 0);
        args.unshift(this);
        return Q.nbind.apply(void 0, args);
    };
    Q.nmapply = Q.npost = function(object, name, args) {
        return Q(object).npost(name, args);
    };
    Promise.prototype.nmapply = Promise.prototype.npost = function(name, args) {
        var nodeArgs = array_slice(args || []);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        this.dispatch("post", [ name, nodeArgs ]).fail(deferred.reject);
        return deferred.promise;
    };
    Q.nsend = Q.nmcall = Q.ninvoke = function(object, name) {
        var nodeArgs = array_slice(arguments, 2);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        Q(object).dispatch("post", [ name, nodeArgs ]).fail(deferred.reject);
        return deferred.promise;
    };
    Promise.prototype.nsend = Promise.prototype.nmcall = Promise.prototype.ninvoke = function(name) {
        var nodeArgs = array_slice(arguments, 1);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        this.dispatch("post", [ name, nodeArgs ]).fail(deferred.reject);
        return deferred.promise;
    };
    Q.nodeify = nodeify;
    function nodeify(object, nodeback) {
        return Q(object).nodeify(nodeback);
    }
    Promise.prototype.nodeify = function(nodeback) {
        if (nodeback) {
            this.then(function(value) {
                Q.nextTick(function() {
                    nodeback(null, value);
                });
            }, function(error) {
                Q.nextTick(function() {
                    nodeback(error);
                });
            });
        } else {
            return this;
        }
    };
    var qEndingLine = captureLine();
    return Q;
});
define("crossdomain-localstorage-access", ['require','launch-telemetry-data','third-party/cross-storage-client','third-party/q','safety','console'],function(require) {
    "use strict";
    var telemetryData = require("launch-telemetry-data"), CrossStorageClient = require("third-party/cross-storage-client"), Q = require("third-party/q"), safety = require("safety"), console = require("console"), crossDomainStorage;
    var localStorageHtml = safety.launcherJsProtocol + "//" + safety.launcherJsHost + "/launcher2/static/cross-domain-local-storage/local-storage.html";
    var frameId = "CrossStorageClient-launcher-cross-storage-joiner";
    function addIFrame(url, iframeId) {
        var frame, key;
        frame = window.document.createElement("iframe");
        frame.id = iframeId;
        frame.setAttribute("sandbox", "allow-same-origin allow-scripts");
        for (key in CrossStorageClient.frameStyle) {
            if (CrossStorageClient.frameStyle.hasOwnProperty(key)) {
                frame.style[key] = CrossStorageClient.frameStyle[key];
            }
        }
        window.document.body.appendChild(frame);
        frame.src = url;
    }
    function initializeIframe() {
        try {
            addIFrame(localStorageHtml, frameId);
            crossDomainStorage = new CrossStorageClient(localStorageHtml, {
                promise: Q.Promise,
                frameId: frameId
            });
        } catch (e) {
            console.log("crossdomain-localstorage-access: Could not initialize:", e);
            crossDomainStorage = {
                onConnect: function() {
                    return Q.reject("Not Initialized");
                }
            };
        }
    }
    return {
        initializeIframe: initializeIframe,
        willGetItem: function(key) {
            if (!crossDomainStorage) {
                initializeIframe();
            }
            return crossDomainStorage.onConnect().then(function() {
                return crossDomainStorage.get(key).then(JSON.parse);
            }).catch(function(reason) {
                console.log("localStorageError getItem:", reason);
                telemetryData.augment({
                    localStorageError: "getItem"
                });
            });
        },
        willSetItem: function(key, value) {
            if (!crossDomainStorage) {
                initializeIframe();
            }
            return crossDomainStorage.onConnect().then(function() {
                return crossDomainStorage.set(key, JSON.stringify(value));
            }).catch(function(reason) {
                console.log("localStorageError setItem:", reason);
                telemetryData.augment({
                    localStorageError: "setItem"
                });
            });
        },
        willRemoveItem: function(key) {
            if (!crossDomainStorage) {
                initializeIframe();
            }
            return crossDomainStorage.onConnect().then(function() {
                return crossDomainStorage.del(key);
            }).catch(function(reason) {
                console.log("localStorageError removeItem:", reason);
                telemetryData.augment({
                    localStorageError: "removeItem"
                });
            });
        }
    };
});
define("crossdomain-success-storage", ['require','safety','crossdomain-localstorage-access','util','launch-model','third-party/q','console'],function(require) {
    "use strict";
    var safety = require("safety"), crossDomainLocalStorageAccess = require("crossdomain-localstorage-access"), util = require("util"), launchModel = require("launch-model"), Q = require("third-party/q"), console = require("console"), MAX_AGE = util.days_to_ms(60), LOCAL_STORAGE_KEY = "launcher:last-success";
    function isUsable() {
        var usable = !launchModel.userAgent().is.MSIE;
        if (!usable) {
            console.log("cross-domain-success-storage is not supported on IE");
        }
        return usable;
    }
    var defaultReject = function() {
        return Q.reject("disabled");
    };
    var disabledModule = {
        initializeIframe: function() {
            console.log("skipping cross-domain-success-storage");
        },
        hasSuccess: defaultReject,
        getLastSuccess: defaultReject,
        storeSuccess: defaultReject,
        removeSuccess: defaultReject
    };
    var enabledModule = safety.collect({
        initializeIframe: crossDomainLocalStorageAccess.initializeIframe,
        hasSuccess: function() {
            return crossDomainLocalStorageAccess.willGetItem(LOCAL_STORAGE_KEY).then(function(lastSuccessStored) {
                var lastSuccess, ago, freshEnough;
                lastSuccess = parseInt(lastSuccessStored, 10);
                if (!lastSuccess) {
                    return Q.reject("No last success found.");
                }
                ago = util.now() - lastSuccess;
                freshEnough = ago < MAX_AGE;
                console.log("launcher.js: cross-domain-success-storage.hasSuccess(): Found lastSuccess: ", lastSuccess, " which was ago: ", ago, " max-age is: ", MAX_AGE, " so it is fresh enough: ", freshEnough);
                if (!freshEnough) {
                    return Q.reject("Stored success is too old.");
                }
            });
        },
        getLastSuccess: function() {
            return crossDomainLocalStorageAccess.willGetItem(LOCAL_STORAGE_KEY);
        },
        storeSuccess: function() {
            var now = util.now();
            return crossDomainLocalStorageAccess.willSetItem(LOCAL_STORAGE_KEY, now).then(function() {
                console.log("launcher.js: cross-domain-success-storage.storeSuccess(): ", now, " setItem to localStorage worked: true");
            }, function(reason) {
                console.log("launcher.js: cross-domain-success-storage.storeSuccess(): ", now, " setItem to localStorage worked: false:", reason);
            });
        },
        removeSuccess: function() {
            var lastSuccess;
            return crossDomainLocalStorageAccess.willGetItem(LOCAL_STORAGE_KEY).then(function(lastSuccessResult) {
                lastSuccess = lastSuccessResult;
                return LOCAL_STORAGE_KEY;
            }).then(crossDomainLocalStorageAccess.willRemoveItem).then(function() {
                console.log("launcher.js: cross-domain-success-storage.removeSuccess(): removed ", lastSuccess);
            });
        }
    });
    return {
        init: function() {
            if (!isUsable()) {
                return disabledModule;
            }
            return enabledModule;
        }
    };
});
define("launch-status", ['require','safety','jquery','urls','launch-model','console','success-storage','crossdomain-success-storage'],function(require) {
    "use strict";
    var safety = require("safety"), $ = require("jquery"), urls = require("urls"), launchModel = require("launch-model"), console = require("console"), successStorage = require("success-storage"), crossDomainSuccessStorage = require("crossdomain-success-storage").init(), numTries = 0, launchStatusRequest, launchStatusTimer, lastReceivedLaunchStatus = "", lastReceivedStatusTimestamp = 0;
    function isStopped() {
        return numTries === 0;
    }
    function abortCurrentRequest() {
        if (launchStatusRequest) {
            launchStatusRequest.abort();
        }
    }
    function stopCurrentTimer() {
        if (launchStatusTimer) {
            clearTimeout(launchStatusTimer);
            launchStatusTimer = null;
        }
    }
    function stopCurrentRequestAndTimer() {
        if (launchStatusRequest) {
            console.log("launcher.js: abort pending request.");
            launchStatusRequest.abort();
            launchStatusRequest = null;
        }
        stopCurrentTimer();
    }
    function stop() {
        if (numTries) {
            console.log("launcher.js: Stopping launch-status");
            numTries = 0;
        }
        stopCurrentRequestAndTimer();
    }
    function pollLaunchStatus() {
        console.log("launcher.js: Checking if helper has started. Try number " + numTries);
        var requestTime = new Date();
        function retry() {
            stopCurrentRequestAndTimer();
            var maxNumTries = 60;
            numTries += 1;
            var timeout = Math.max(0, 5e3 + 5e3 * numTries / maxNumTries - (new Date() - requestTime));
            if (numTries <= maxNumTries) {
                launchStatusTimer = setTimeout(function() {
                    launchStatusTimer = null;
                    pollLaunchStatus();
                }, timeout);
            } else {
                console.log("launcher.js: Retried too many times. Giving up to get launch status.");
            }
        }
        launchStatusTimer = setTimeout(safety.collect(function watchdogTimer() {
            console.log("launcher.js: launchStatus watchdogTimer");
            launchStatusTimer = null;
            if (launchStatusRequest) {
                launchStatusRequest.abort();
            } else {
                console.log("launcher.js: launchStatus watchdogTimer: expected launchStatusRequest to be set");
            }
        }), 2e4);
        launchStatusRequest = $.ajax(urls.launchStatus(lastReceivedLaunchStatus, lastReceivedStatusTimestamp), {
            type: "GET",
            dataType: "jsonp",
            jsonp: "jsonp_callback",
            success: safety.collect(function(data) {
                if (data) {
                    if (!data.launchStatusTimestamp) {
                        data.launchStatusTimestamp = 0;
                    }
                    console.log("launcher.js: Received launchStatus " + data.launchStatus + " with timestamp " + data.launchStatusTimestamp, " persist=", data.persist);
                    launchStatusRequest = null;
                    if (launchModel.STATE.hasOwnProperty(data.launchStatus)) {
                        stop();
                        if (data.launchStatus === launchModel.STATE.SUCCESS) {
                            if (data.persist === false) {
                                console.log("launcher.js: NOT storing launch-success as persist=false");
                            } else {
                                successStorage.storeSuccess();
                                crossDomainSuccessStorage.storeSuccess();
                            }
                        }
                        launchModel.joinState(data.launchStatus);
                    } else if (launchModel.INSTRUCTION.hasOwnProperty(data.launchStatus)) {
                        launchModel.joinInstruction(data.launchStatus);
                    }
                    lastReceivedLaunchStatus = data.launchStatus;
                    lastReceivedStatusTimestamp = data.launchStatusTimestamp;
                }
            }),
            complete: safety.collect(function() {
                console.log("launcher.js: launch-status request complete");
                launchStatusRequest = null;
                stopCurrentTimer();
                if (!isStopped()) {
                    retry();
                }
            })
        });
    }
    function startPollingLaunchStatus() {
        if (isStopped()) {
            numTries = 1;
            console.log("launcher.js: Starting launch-status polling for abbreviatedToken ", launchModel.abbreviatedToken());
            setTimeout(function() {
                pollLaunchStatus();
            }, 100);
        } else {
            console.log("launcher.js: not starting polling of launch-status (already started)");
        }
    }
    startPollingLaunchStatus.stop = stop;
    startPollingLaunchStatus.abortCurrentRequest = abortCurrentRequest;
    return startPollingLaunchStatus;
});
define("detector-ie", [ "safety", "console", "launch-model", "util" ], function(safety, console, launchModel, util) {
    "use strict";
    return safety.collect({
        isUsable: function() {
            return !!launchModel.userAgent().is.MSIE && !!util.getMimeType("anystring");
        },
        getDetector: function() {
            return safety.collect({
                pluginBuild: "IE",
                endpointExistsForScheme: function(scheme) {
                    var mimeType = util.getMimeType(scheme);
                    return mimeType && mimeType.indexOf("Action") >= 0;
                },
                endpointBuildsForScheme: function(scheme) {
                    if (scheme !== "gotoopener") {
                        return "";
                    }
                    var mimeType = util.getMimeType(scheme);
                    if (!mimeType) {
                        return "";
                    }
                    var match = /^GoTo Opener Launch Action \(build (\d+)\)$/.exec(mimeType);
                    return match && match.length && match[1] || "";
                }
            });
        }
    });
});
define("detector-fake", [],function() {
    "use strict";
    function endpointExistsForScheme(scheme) {
        return scheme === "gotoopener";
    }
    function endpointBuildsForScheme(scheme) {
        if (scheme === "gotoopener") {
            return "105";
        }
        return "";
    }
    return {
        endpointExistsForScheme: endpointExistsForScheme,
        endpointBuildsForScheme: endpointBuildsForScheme,
        makeFakeDetector: function(pluginBuild, clickToPlay) {
            return {
                pluginBuild: pluginBuild,
                clickToPlay: clickToPlay || false,
                endpointExistsForScheme: endpointExistsForScheme,
                endpointBuildsForScheme: endpointBuildsForScheme
            };
        }
    };
});
define("detector-plugin", ['require','safety','jquery','console','launch-model','detector-fake'],function(require) {
    "use strict";
    var safety = require("safety"), $ = require("jquery"), console = require("console"), model = require("launch-model"), fakeDetector = require("detector-fake");
    var MIME_TYPE = "application/x-col-application-detector";
    function getActualPlugin() {
        var pluginElement = $("#launcher-plugin")[0];
        if (pluginElement && pluginElement.getAttribute("type") === MIME_TYPE) {
            console.log("Using plugin Element found in DOM");
            return pluginElement;
        }
        console.log("Creating plugin element");
        pluginElement = document.createElement("embed");
        pluginElement.setAttribute("type", MIME_TYPE);
        pluginElement.setAttribute("width", "0");
        pluginElement.setAttribute("height", "0");
        return document.body.appendChild(pluginElement);
    }
    function createExceptionWrapper(plugin, f1, f2) {
        return function() {
            try {
                return f1.apply(plugin, arguments);
            } catch (e) {
                console.log("Wrapper catched exception: ", e);
                safety.sendError(e, "wrappedPlugin");
                try {
                    return f2.apply(plugin, arguments);
                } catch (e2) {
                    console.log("Wrapper 2 catched exception: ", e2);
                    safety.sendError(e2, "wrappedPlugin2");
                    return undefined;
                }
            }
        };
    }
    function wrapPlugin(plugin) {
        var wrapped = {
            pluginBuild: 0
        };
        try {
            wrapped.pluginBuild = plugin.pluginBuild;
        } catch (e) {
            console.log("Error while trying to determine pluginBuild", e);
        }
        if (plugin.endpointExistsForScheme) {
            wrapped.endpointExistsForScheme = createExceptionWrapper(plugin, plugin.endpointExistsForScheme, fakeDetector.endpointBuildsForScheme);
        }
        if (plugin.endpointBuildsForScheme) {
            wrapped.endpointBuildsForScheme = createExceptionWrapper(plugin, plugin.endpointBuildsForScheme, fakeDetector.endpointBuildsForScheme);
        }
        return wrapped;
    }
    function detectIfPluginIsAllowed(plugin) {
        var intervalId = window.setInterval(function() {
            if (plugin.endpointExistsForScheme) {
                console.log("launcher.js: Plugin is no longer under click-to-play");
                model.detector(wrapPlugin(plugin));
                window.clearInterval(intervalId);
            }
        }, 700);
    }
    return safety.collect({
        isUsable: function pluginExists() {
            try {
                navigator.plugins.refresh(false);
            } catch (ignore) {}
            return !!navigator.mimeTypes["application/x-col-application-detector"];
        },
        getDetector: function getPluginDetector() {
            var assumeClickToPlay = model.userAgent().is.SAFARI;
            if (assumeClickToPlay || model.flags().assumeClickToPlay) {
                console.log("launcher.js: assuming clickToPlay", assumeClickToPlay, model.flags().assumeClickToPlay);
                return fakeDetector.makeFakeDetector("clickToPlay", true);
            }
            var plugin = getActualPlugin();
            if (plugin && plugin.endpointExistsForScheme) {
                return wrapPlugin(plugin);
            }
            if (plugin) {
                console.log("Plugin is under click-to-play or otherwise unusable. Assuming it to be under click-to-play");
                detectIfPluginIsAllowed(plugin);
                return fakeDetector.makeFakeDetector("clickToPlay", true);
            }
            return null;
        },
        wrapPlugin: wrapPlugin,
        createExceptionWrapper: createExceptionWrapper
    });
});
define("detector-success-storage", ['require','safety','success-storage','launch-model','detector-fake'],function(require) {
    "use strict";
    var safety = require("safety"), successStorage = require("success-storage"), launchModel = require("launch-model"), fakeDetector = require("detector-fake");
    return safety.collect({
        isUsable: function() {
            var userAgent = launchModel.userAgent(), browserApplies = userAgent.is.CHROME || userAgent.is.MSIE || userAgent.is.MSEDGE || userAgent.is.SAFARI || userAgent.is.FIREFOX;
            return !!(browserApplies && successStorage.hasSuccess());
        },
        getDetector: function() {
            return fakeDetector.makeFakeDetector("success-storage");
        }
    });
});
define("detector-user-agent", ['require','safety','detector-fake','launch-model'],function(require) {
    "use strict";
    var safety = require("safety"), fakeDetector = require("detector-fake"), launchModel = require("launch-model");
    return safety.collect({
        isUsable: function() {
            var userAgent = launchModel.userAgent().userAgent;
            return userAgent.indexOf("GetGoLauncher") >= 0;
        },
        getDetector: function() {
            return fakeDetector.makeFakeDetector("detector-app-user-agent");
        }
    });
});
define("detector", ['require','safety','launch-model','detector-ie','detector-plugin','detector-success-storage','detector-user-agent','console'],function(require) {
    "use strict";
    var safety = require("safety"), model = require("launch-model"), detectorIE = require("detector-ie"), detectorPlugin = require("detector-plugin"), detectorSuccessStorage = require("detector-success-storage"), detectorUserAgent = require("detector-user-agent"), console = require("console"), ranDetection = false;
    return safety.collect(function detect() {
        if (ranDetection) {
            return model.detector();
        }
        var possibleDetectors = [ detectorUserAgent, detectorPlugin, detectorSuccessStorage, detectorIE ], i, detector;
        for (i = 0; i < possibleDetectors.length; i += 1) {
            if (possibleDetectors[i].isUsable()) {
                detector = possibleDetectors[i].getDetector();
                break;
            }
        }
        if (detector) {
            model.detector(detector);
        }
        ranDetection = true;
        console.log("Detector pluginBuild: ", detector && detector.pluginBuild);
        return detector;
    });
});
define("join-clickonce", ['require','launch-model','launch-telemetry','console','launch-status','detector'],function(require) {
    "use strict";
    var launchModel = require("launch-model"), launchTelemetry = require("launch-telemetry"), console = require("console"), launchStatus = require("launch-status"), detect = require("detector");
    function shouldSkipClickOnce() {
        var detector = detect();
        return detector !== null && detector !== undefined && detector.endpointExistsForScheme("citrixonlinelauncherskipclickonce");
    }
    function joinClickOnce(next) {
        var ua = launchModel.userAgent(), hasDotNet2 = launchModel.userAgent().userAgent.indexOf(".NET CLR 2.0") !== -1, useClickOnce = hasDotNet2 && ua.is.MSIE && ua.browserVersion >= 6 && ua.browserVersion <= 8;
        if (useClickOnce && shouldSkipClickOnce()) {
            console.log("ClickOnce is available but must be skipped.");
            next();
        } else if (useClickOnce) {
            console.log("Launching via ClickOnce...");
            launchModel.joinInstruction(launchModel.INSTRUCTION.CLICKONCE);
            launchStatus();
            launchTelemetry("clickonce");
        } else {
            next();
        }
    }
    return joinClickOnce;
});
define("join-mslaunchuri", [ "launch-telemetry", "launch-model", "launch-status", "urls", "console" ], function(launchTelemetry, launchModel, launchStatus, urls, console) {
    "use strict";
    return function joinMsLaunchUri(next) {
        console.log("launcher.js: join-msLaunchUri exists: ", !!navigator.msLaunchUri);
        if (launchModel.userAgent().is.MSEDGE && launchModel.userAgent().browserVersion < 15) {
            next();
            return;
        }
        if (navigator.msLaunchUri) {
            console.log("launcher.js: Using join-msLaunchUri");
            launchStatus();
            launchModel.joinInstruction(launchModel.INSTRUCTION.LAUNCHING_APP);
            navigator.msLaunchUri(urls.appLaunch(), function msLaunchUriSuccess() {
                console.log("launcher.js: join-msLaunchUri success" + launchModel.INSTRUCTION.LAUNCHED_APP);
                launchModel.joinInstruction(launchModel.INSTRUCTION.LAUNCHED_APP);
                launchTelemetry("gotoopener", {
                    joiner: "launchUri"
                });
            }, function msLaunchNoHandler() {
                console.log("launcher.js: join-msLaunchUri failed or no handler registered");
                next();
            });
        } else {
            next();
        }
    };
});
define("launch-scheme", ['require','jquery','urls','console','launch-status','launch-model','util','safety','third-party/q'],function(require) {
    "use strict";
    var $ = require("jquery"), urls = require("urls"), console = require("console"), launchStatus = require("launch-status"), model = require("launch-model"), util = require("util"), safety = require("safety"), q = require("third-party/q"), launchTimeout;
    return safety.collect("launch", function launchScheme(scheme, trigger) {
        var url, shouldUseDocumentLocation;
        if (scheme === "gotoopener") {
            url = urls.appLaunch(trigger);
        } else {
            url = urls.endpointLaunchUrlForScheme(scheme, model.endpoint().launchUrl);
        }
        shouldUseDocumentLocation = util.isLaunchByIframeBroken();
        if (model.flags().disableRedirects) {
            console.log("If you hadn't asked me not to, I would have launched " + url);
            return q.Promise.resolve();
        }
        if (shouldUseDocumentLocation) {
            console.log("Launching URL via document.location: " + url);
            model.incrementSettingDocumentLocationCount();
            document.location = url;
            if (launchTimeout !== undefined) {
                window.clearTimeout(launchTimeout);
            }
            return new q.Promise(function(resolve) {
                launchTimeout = window.setTimeout(safety.collect("launch-afterLaunchScheme", function afterLaunchScheme() {
                    model.decrementSettingDocumentLocationCount();
                    launchStatus.abortCurrentRequest();
                    resolve();
                }), 150);
            });
        }
        console.log("Launching URL via iframe: " + url);
        $(".launchFrame").remove();
        window.setTimeout(safety.collect("launch-launchByIFrame", function launchByIFrame() {
            var iFrame = $("<iframe/>").attr("class", "launchFrame").attr("src", url);
            iFrame.hide();
            iFrame.appendTo($("body"));
        }), 0);
        return q.Promise.resolve();
    });
});
define("launch-by-click", ['require','safety','launch-scheme','launch-model','urls','console','util'],function(require) {
    "use strict";
    var safety = require("safety"), launchScheme = require("launch-scheme"), launchModel = require("launch-model"), urls = require("urls"), console = require("console"), util = require("util"), popupsOpenedForLaunchByClick = [];
    function closeAllPopupsOpenedForClickToLaunch() {
        var i, n = popupsOpenedForLaunchByClick.length;
        for (i = 0; i < n; i += 1) {
            popupsOpenedForLaunchByClick[i].close();
        }
        popupsOpenedForLaunchByClick = [];
    }
    launchModel.currentState.subscribe(safety.collect(function(currentState) {
        if (currentState.joinInstruction === launchModel.INSTRUCTION.LAUNCHED_APP || currentState.joinState) {
            closeAllPopupsOpenedForClickToLaunch();
        }
    }));
    function shouldOpenPopup() {
        var affectedBrowser = util.isLaunchByIframeBroken(), insideIframe = launchModel.apiVersion() >= 2 && util.insideIframe();
        return affectedBrowser && (launchModel.flags().dontSetDocumentLocation || insideIframe);
    }
    function launchByClick(trigger) {
        var url = urls.appLaunch(trigger), opened;
        if (shouldOpenPopup()) {
            opened = window.open(url, "", "width=500,height=500");
            console.log("launcher.js: launch by click: opened new window ", opened, " with URL ", url);
            if (opened) {
                popupsOpenedForLaunchByClick.push(opened);
            }
        } else {
            launchScheme("gotoopener", trigger);
        }
    }
    launchByClick.shouldLaunchByClick = shouldOpenPopup;
    return launchByClick;
});
define("join-cross-domain-success-storage", ['require','detector','launch-scheme','launch-telemetry','launch-telemetry-data','launch-model','launch-status','launch-by-click','crossdomain-success-storage','console','util'],function(require) {
    "use strict";
    var detect = require("detector"), launchScheme = require("launch-scheme"), launchTelemetry = require("launch-telemetry"), launchTelemetryData = require("launch-telemetry-data"), launchModel = require("launch-model"), launchStatus = require("launch-status"), launchByClick = require("launch-by-click"), crossdomainSuccessStorage = require("crossdomain-success-storage").init(), console = require("console"), util = require("util");
    var nextStatusByBrowser = {
        MSIE: launchModel.INSTRUCTION.LAUNCHED_APP,
        SAFARI: launchModel.INSTRUCTION.LAUNCHED_APP
    };
    var defaultNextStatus = launchModel.INSTRUCTION.LAUNCHING_APP;
    util.runWhenReady(crossdomainSuccessStorage.initializeIframe);
    return function(next) {
        var detector = detect(), scheme = "gotoopener";
        if (util.isLaunchingBroken()) {
            console.log("NOT launching app because buggy browser version was detected.");
            launchTelemetryData.augment({
                buggyBrowser: true
            });
            next();
            return;
        }
        if (!!detector) {
            console.log("skipped join-cross-domain-success-storage.");
            next();
            return;
        }
        console.log("Checking for cross domain success storage");
        crossdomainSuccessStorage.hasSuccess().then(function() {
            if (launchByClick.shouldLaunchByClick()) {
                launchTelemetry(scheme, {
                    joiner: "launchByClick"
                });
                launchStatus();
                launchModel.joinInstruction(launchModel.INSTRUCTION.LAUNCH_BY_CLICK);
            } else {
                var expectedInstruction = launchModel.joinInstruction();
                launchScheme(scheme).then(function() {
                    launchTelemetry(scheme, {
                        joiner: "crossdomain-local-storage"
                    });
                    launchStatus();
                    var nextStatus = nextStatusByBrowser[launchModel.userAgent().browser] || defaultNextStatus;
                    if (expectedInstruction === launchModel.joinInstruction()) {
                        launchModel.joinInstruction(nextStatus);
                    }
                });
            }
        }, function(reason) {
            console.log("No cross domain success storage found. Reason:", reason);
            next();
        });
    };
});
define("join-chrome", ['require','jquery','detector','launch-telemetry','launch-model','launch-status','launch-scheme','console','util'],function(require) {
    "use strict";
    var $ = require("jquery"), detect = require("detector"), launchTelemetry = require("launch-telemetry"), launchModel = require("launch-model"), launchStatus = require("launch-status"), launchScheme = require("launch-scheme"), console = require("console"), util = require("util"), appIsInstalled = false, focusElement = null;
    return function joinLaunchChrome(next) {
        var launchChrome;
        function onblur() {
            console.log("launcher.js: join-chrome: onblur");
            appIsInstalled = true;
        }
        function result() {
            focusElement.off("blur.launcher", onblur);
            focusElement.hide();
            if (appIsInstalled) {
                launchModel.joinInstruction(launchModel.INSTRUCTION.LAUNCHING_APP);
                launchStatus();
                launchTelemetry("gotoopener", {
                    joiner: "chrome"
                });
            } else {
                next();
            }
        }
        function retryWhenVisible() {
            console.log("launcher.js: join-chrome: retryWhenVisible: hidden: " + document.hidden);
            if (!document.hidden) {
                document.removeEventListener("visibilitychange", retryWhenVisible);
                launchChrome();
            }
        }
        launchChrome = function() {
            if (document.hidden) {
                console.log("launcher.js: join-chrome: Not launching: hidden");
                document.addEventListener("visibilitychange", retryWhenVisible);
            } else if (!document.hasFocus()) {
                console.log("launcher.js: join-chrome: Not launching: not focused. Skipping.");
                next();
            } else {
                console.log("launcher.js: join-chrome: launching...");
                focusElement.show();
                focusElement.focus();
                focusElement.on("blur.launcher", onblur);
                launchScheme("gotoopener");
                setTimeout(function() {
                    console.log("launcher.js: join-chrome: hidden: " + document.hidden + ", appIsInstalled: " + appIsInstalled);
                    if (document.hidden) {
                        document.addEventListener("visibilitychange", retryWhenVisible);
                    } else {
                        result();
                    }
                }, 350);
            }
        };
        var detector = detect(), userAgent = launchModel.userAgent(), wouldWork = !(util.insideIframe() && util.isLaunchByIframeBroken());
        if (userAgent.is.CHROME && userAgent.is.WINDOWS && userAgent.browserVersion === 57) {
            console.log("launcher.js: join-chrome: skipping for Chrome 57 on Windows");
            next();
        } else {
            if (wouldWork && userAgent.is.CHROME && !detector) {
                if (!focusElement) {
                    focusElement = $('<input id="launcher-focus" style="display: none; position: fixed; z-index: 9999; min-width: 1px; min-height: 1px; max-width: 1px; max-height: 1px; top: 0; left: 0;">');
                    focusElement.appendTo($("body"));
                }
                console.log("launcher.js: join-chrome: Chrome detected (without plugin)");
                window.setTimeout(launchChrome, 250);
            } else {
                console.log("launcher.js: join-chrome: skipping ", wouldWork, userAgent.is.CHROME, !!detector);
                next();
            }
        }
    };
});
define("join-app", ['require','jquery','detector','launch-scheme','launch-telemetry','launch-telemetry-data','launch-model','launch-status','launch-by-click','console','util'],function(require) {
    "use strict";
    var $ = require("jquery"), detect = require("detector"), launchScheme = require("launch-scheme"), launchTelemetry = require("launch-telemetry"), launchTelemetryData = require("launch-telemetry-data"), launchModel = require("launch-model"), launchStatus = require("launch-status"), launchByClick = require("launch-by-click"), console = require("console"), util = require("util");
    var nextStatusByBrowser = {
        MSIE: launchModel.INSTRUCTION.LAUNCHED_APP,
        SAFARI: launchModel.INSTRUCTION.LAUNCHED_APP
    };
    var defaultNextStatus = launchModel.INSTRUCTION.LAUNCHING_APP;
    function getHelperBuild(detector) {
        var sortedBuilds, highest, lowest, assumedBuild, helperBuilds = detector && detector.endpointBuildsForScheme && detector.endpointBuildsForScheme("gotoopener");
        console.log("Helper builds found: ", helperBuilds);
        if (!helperBuilds) {
            return helperBuilds;
        }
        sortedBuilds = $.map(helperBuilds.split(","), function(v) {
            return parseInt(v, 10);
        }).sort(function(a, b) {
            return a > b;
        });
        if (sortedBuilds.length === 0) {
            assumedBuild = null;
        } else if (sortedBuilds.length === 1) {
            assumedBuild = sortedBuilds[0];
        } else {
            highest = sortedBuilds[sortedBuilds.length - 1];
            lowest = sortedBuilds[0];
            assumedBuild = highest >= 105 ? highest : lowest;
        }
        console.log("Assuming helper build: " + assumedBuild);
        return assumedBuild;
    }
    function joinApp(next) {
        var detector = detect(), helperBuild = getHelperBuild(detector), scheme = "gotoopener", userAgent = launchModel.userAgent();
        if (util.isLaunchingBroken()) {
            console.log("NOT launching app because buggy browser version was detected.");
            launchTelemetryData.augment({
                buggyBrowser: true
            });
            next();
            return;
        }
        if (userAgent.is.FIREFOX && detector && detector.clickToPlay) {
            next();
            return;
        }
        if (helperBuild && helperBuild >= 96) {
            if (launchByClick.shouldLaunchByClick()) {
                launchTelemetry(scheme, {
                    joiner: "launchByClick"
                });
                launchStatus();
                launchModel.joinInstruction(launchModel.INSTRUCTION.LAUNCH_BY_CLICK);
            } else {
                var expectedInstruction = launchModel.joinInstruction();
                launchScheme(scheme).then(function afterLaunchingApp() {
                    launchTelemetry(scheme, {
                        joiner: "app"
                    });
                    launchStatus();
                    var nextStatus = nextStatusByBrowser[launchModel.userAgent().browser] || defaultNextStatus;
                    if (expectedInstruction === launchModel.joinInstruction()) {
                        launchModel.joinInstruction(nextStatus);
                    }
                });
            }
        } else {
            next();
        }
    }
    return joinApp;
});
define("join-direct-launch", ['require','jquery','launch-telemetry','launch-model','launch-status','urls','console'],function(require) {
    "use strict";
    var $ = require("jquery"), launchTelemetry = require("launch-telemetry"), launchModel = require("launch-model"), launchStatus = require("launch-status"), urls = require("urls"), console = require("console");
    function launch() {
        var iFrame = $("<iframe/>").attr("class", "launchFrame").attr("src", "about:blank");
        iFrame.appendTo($("body"));
        iFrame.hide();
        iFrame[0].contentWindow.location.href = urls.appLaunch();
    }
    function isApplicable() {
        var userAgent = launchModel.userAgent();
        if (launchModel.product() === "g2ax_expert") {
            return false;
        }
        return userAgent.is.FIREFOX && userAgent.browserVersion >= 13 || userAgent.is.SAFARI || userAgent.is.WINDOWS && userAgent.is.CHROME && userAgent.browserVersion === 57;
    }
    return function(next) {
        if (isApplicable()) {
            try {
                launch();
                console.log("join-direct-launch: tried launching");
                launchModel.joinInstruction(launchModel.INSTRUCTION.TRY_LAUNCHING_APP);
                launchStatus();
                launchTelemetry("gotoopener", {
                    joiner: "direct-launch"
                });
            } catch (e) {
                if (e.name === "NS_ERROR_UNKNOWN_PROTOCOL") {
                    console.log("join-direct-launch: failure NS_ERROR_UNKNOWN_PROTOCOL. App not detected in Firefox");
                    next();
                }
            }
        } else {
            console.log("join-direct-launch: skipping");
            next();
        }
    };
});
define("join-endpoint", [ "jquery", "detector", "launch-scheme", "launch-telemetry", "urls", "console", "launch-model", "util" ], function($, detect, launchScheme, launchTelemetry, urls, console, model, util) {
    "use strict";
    function launchBuildNumberIfExists(plugin, launchFunc, scheme, buildNumber) {
        scheme = scheme + (buildNumber !== undefined ? buildNumber : "");
        console.log("Checking for scheme " + scheme);
        if (plugin.endpointExistsForScheme(scheme)) {
            console.log("Handler exists for scheme " + scheme);
            launchFunc(scheme);
            return true;
        }
        return false;
    }
    function launchSequential(plugin, launchFunc, next) {
        var shouldTryWithoutBuildNumber = !model.endpoint().dontFallbackToBuildsBelow;
        function tryNextBuild() {
            var success;
            if (model.endpoint().builds.length) {
                success = launchBuildNumberIfExists(plugin, launchFunc, model.endpoint().scheme, model.endpoint().builds.shift());
            } else if (shouldTryWithoutBuildNumber) {
                shouldTryWithoutBuildNumber = false;
                success = launchBuildNumberIfExists(plugin, launchFunc, model.endpoint().scheme);
            } else {
                next();
                success = true;
            }
            if (!success) {
                setTimeout(tryNextBuild, 20);
            }
        }
        tryNextBuild();
    }
    function launchDirect(plugin, existingBuilds, launchFunc, next) {
        var i;
        existingBuilds = existingBuilds.split(",");
        function isInstalled(buildNumber) {
            return existingBuilds.indexOf(String(buildNumber)) >= 0;
        }
        function isSupported(buildNumber) {
            return buildNumber >= model.endpoint().dontFallbackToBuildsBelow;
        }
        var launched;
        $.each(model.endpoint().builds, function(i, buildNumber) {
            if (isInstalled(buildNumber)) {
                launched = true;
                launchFunc(model.endpoint().scheme + buildNumber);
                return false;
            }
            console.log("Not installed: desired build " + buildNumber);
        });
        if (launched) {
            return;
        }
        for (i = existingBuilds.length - 1; i >= 0; i -= 1) {
            if (isSupported(existingBuilds[i])) {
                launched = true;
                launchFunc(model.endpoint().scheme + existingBuilds[i]);
                break;
            }
            console.log("Not supported: installed build " + existingBuilds[i]);
        }
        if (launched) {
            return;
        }
        if (!model.endpoint().dontFallbackToBuildsBelow) {
            launched = launchBuildNumberIfExists(plugin, launchFunc, model.endpoint().scheme);
        }
        if (launched) {
            return;
        }
        next();
    }
    return function joinEndpoint(next) {
        var detector = detect();
        if (util.isLaunchingBroken()) {
            console.log("NOT launching endpoint because buggy browser version was detected");
            next();
            return;
        }
        function launch(scheme) {
            var expectedInstruction = model.joinInstruction();
            launchScheme(scheme).then(function afterLaunchingEndpoint() {
                launchTelemetry(scheme).complete(function() {
                    if (expectedInstruction === model.joinInstruction()) {
                        model.joinInstruction(model.INSTRUCTION.LAUNCHING_EP);
                    }
                });
                setTimeout(function() {
                    if (expectedInstruction === model.joinInstruction()) {
                        model.joinInstruction(model.INSTRUCTION.LAUNCHING_EP);
                    }
                }, 1e3);
            });
        }
        console.log("scheme: ", model.endpoint().scheme);
        if (detector && model.endpoint().scheme) {
            var existingBuilds = detector.endpointBuildsForScheme && detector.endpointBuildsForScheme(model.endpoint().scheme);
            console.log("Existing builds: " + existingBuilds);
            var launched = launchBuildNumberIfExists(detector, launch, model.endpoint().scheme, model.endpoint().builds.shift());
            if (!launched) {
                if (existingBuilds) {
                    launchDirect(detector, existingBuilds, launch, next);
                } else {
                    launchSequential(detector, launch, next);
                }
            }
        } else {
            next();
        }
    };
});
define("launch-stop", ['require','launch-model','launch-status'],function(require) {
    "use strict";
    var launchModel = require("launch-model"), launchStatus = require("launch-status");
    return function() {
        launchStatus.stop();
        launchModel.launchStarted(false);
        launchModel.joinInstruction(null);
        launchModel.joinState(null);
    };
});
define("join-allow-download", ['require','launch-telemetry','launch-model','console','launch-stop'],function(require) {
    "use strict";
    var launchTelemetry = require("launch-telemetry"), launchModel = require("launch-model"), console = require("console"), launchStop = require("launch-stop");
    function joinAllowDownload(next, injections) {
        injections = injections || {};
        launchStop = injections.launchStop || launchStop;
        console.log("launcher.js: join-allow-download");
        function allowDownload() {
            next();
        }
        function rejectDownload() {
            launchTelemetry("download-rejected");
            launchStop();
        }
        if (typeof launchModel.allowDownload === "function") {
            launchModel.allowDownload(allowDownload, rejectDownload);
        } else {
            next();
        }
    }
    return joinAllowDownload;
});
define("join-download", [ "jquery", "urls", "console", "launch-status", "launch-telemetry", "launch-model", "util" ], function($, urls, console, launchStatus, launchTelemetry, model, util) {
    "use strict";
    return function joinDownload() {
        model.joinInstruction(model.INSTRUCTION.DOWNLOADING);
        launchTelemetry("auto-download");
        setTimeout(function() {
            util.download("javascript");
            launchStatus();
        }, 1500);
    };
});
define("joiner", ['require','join-clickonce','join-mslaunchuri','join-cross-domain-success-storage','join-chrome','join-app','join-direct-launch','join-endpoint','join-allow-download','join-download'],function(require) {
    "use strict";
    var clickonce = require("join-clickonce"), mslaunchuri = require("join-mslaunchuri"), crossDomainSuccessStorage = require("join-cross-domain-success-storage"), chrome = require("join-chrome"), app = require("join-app"), directLaunch = require("join-direct-launch"), endpoint = require("join-endpoint"), allowdownload = require("join-allow-download"), download = require("join-download");
    return [ clickonce, chrome, directLaunch, crossDomainSuccessStorage, app, mslaunchuri, endpoint, allowdownload, download ];
});
var Handlebars = {};

(function(Handlebars, undefined) {
    Handlebars.VERSION = "1.0.0";
    Handlebars.COMPILER_REVISION = 4;
    Handlebars.REVISION_CHANGES = {
        1: "<= 1.0.rc.2",
        2: "== 1.0.0-rc.3",
        3: "== 1.0.0-rc.4",
        4: ">= 1.0.0"
    };
    Handlebars.helpers = {};
    Handlebars.partials = {};
    var toString = Object.prototype.toString, functionType = "[object Function]", objectType = "[object Object]";
    Handlebars.registerHelper = function(name, fn, inverse) {
        if (toString.call(name) === objectType) {
            if (inverse || fn) {
                throw new Handlebars.Exception("Arg not supported with multiple helpers");
            }
            Handlebars.Utils.extend(this.helpers, name);
        } else {
            if (inverse) {
                fn.not = inverse;
            }
            this.helpers[name] = fn;
        }
    };
    Handlebars.registerPartial = function(name, str) {
        if (toString.call(name) === objectType) {
            Handlebars.Utils.extend(this.partials, name);
        } else {
            this.partials[name] = str;
        }
    };
    Handlebars.registerHelper("helperMissing", function(arg) {
        if (arguments.length === 2) {
            return undefined;
        } else {
            throw new Error("Missing helper: '" + arg + "'");
        }
    });
    Handlebars.registerHelper("blockHelperMissing", function(context, options) {
        var inverse = options.inverse || function() {}, fn = options.fn;
        var type = toString.call(context);
        if (type === functionType) {
            context = context.call(this);
        }
        if (context === true) {
            return fn(this);
        } else if (context === false || context == null) {
            return inverse(this);
        } else if (type === "[object Array]") {
            if (context.length > 0) {
                return Handlebars.helpers.each(context, options);
            } else {
                return inverse(this);
            }
        } else {
            return fn(context);
        }
    });
    Handlebars.K = function() {};
    Handlebars.createFrame = Object.create || function(object) {
        Handlebars.K.prototype = object;
        var obj = new Handlebars.K();
        Handlebars.K.prototype = null;
        return obj;
    };
    Handlebars.logger = {
        DEBUG: 0,
        INFO: 1,
        WARN: 2,
        ERROR: 3,
        level: 3,
        methodMap: {
            0: "debug",
            1: "info",
            2: "warn",
            3: "error"
        },
        log: function(level, obj) {
            if (Handlebars.logger.level <= level) {
                var method = Handlebars.logger.methodMap[level];
                if (typeof console !== "undefined" && console[method]) {
                    console[method].call(console, obj);
                }
            }
        }
    };
    Handlebars.log = function(level, obj) {
        Handlebars.logger.log(level, obj);
    };
    Handlebars.registerHelper("each", function(context, options) {
        var fn = options.fn, inverse = options.inverse;
        var i = 0, ret = "", data;
        var type = toString.call(context);
        if (type === functionType) {
            context = context.call(this);
        }
        if (options.data) {
            data = Handlebars.createFrame(options.data);
        }
        if (context && typeof context === "object") {
            if (context instanceof Array) {
                for (var j = context.length; i < j; i++) {
                    if (data) {
                        data.index = i;
                    }
                    ret = ret + fn(context[i], {
                        data: data
                    });
                }
            } else {
                for (var key in context) {
                    if (context.hasOwnProperty(key)) {
                        if (data) {
                            data.key = key;
                        }
                        ret = ret + fn(context[key], {
                            data: data
                        });
                        i++;
                    }
                }
            }
        }
        if (i === 0) {
            ret = inverse(this);
        }
        return ret;
    });
    Handlebars.registerHelper("if", function(conditional, options) {
        var type = toString.call(conditional);
        if (type === functionType) {
            conditional = conditional.call(this);
        }
        if (!conditional || Handlebars.Utils.isEmpty(conditional)) {
            return options.inverse(this);
        } else {
            return options.fn(this);
        }
    });
    Handlebars.registerHelper("unless", function(conditional, options) {
        return Handlebars.helpers["if"].call(this, conditional, {
            fn: options.inverse,
            inverse: options.fn
        });
    });
    Handlebars.registerHelper("with", function(context, options) {
        var type = toString.call(context);
        if (type === functionType) {
            context = context.call(this);
        }
        if (!Handlebars.Utils.isEmpty(context)) return options.fn(context);
    });
    Handlebars.registerHelper("log", function(context, options) {
        var level = options.data && options.data.level != null ? parseInt(options.data.level, 10) : 1;
        Handlebars.log(level, context);
    });
    var errorProps = [ "description", "fileName", "lineNumber", "message", "name", "number", "stack" ];
    Handlebars.Exception = function(message) {
        var tmp = Error.prototype.constructor.apply(this, arguments);
        for (var idx = 0; idx < errorProps.length; idx++) {
            this[errorProps[idx]] = tmp[errorProps[idx]];
        }
    };
    Handlebars.Exception.prototype = new Error();
    Handlebars.SafeString = function(string) {
        this.string = string;
    };
    Handlebars.SafeString.prototype.toString = function() {
        return this.string.toString();
    };
    var escape = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "`": "&#x60;"
    };
    var badChars = /[&<>"'`]/g;
    var possible = /[&<>"'`]/;
    var escapeChar = function(chr) {
        return escape[chr] || "&amp;";
    };
    Handlebars.Utils = {
        extend: function(obj, value) {
            for (var key in value) {
                if (value.hasOwnProperty(key)) {
                    obj[key] = value[key];
                }
            }
        },
        escapeExpression: function(string) {
            if (string instanceof Handlebars.SafeString) {
                return string.toString();
            } else if (string == null || string === false) {
                return "";
            }
            string = string.toString();
            if (!possible.test(string)) {
                return string;
            }
            return string.replace(badChars, escapeChar);
        },
        isEmpty: function(value) {
            if (!value && value !== 0) {
                return true;
            } else if (toString.call(value) === "[object Array]" && value.length === 0) {
                return true;
            } else {
                return false;
            }
        }
    };
    Handlebars.VM = {
        template: function(templateSpec) {
            var container = {
                escapeExpression: Handlebars.Utils.escapeExpression,
                invokePartial: Handlebars.VM.invokePartial,
                programs: [],
                program: function(i, fn, data) {
                    var programWrapper = this.programs[i];
                    if (data) {
                        programWrapper = Handlebars.VM.program(i, fn, data);
                    } else if (!programWrapper) {
                        programWrapper = this.programs[i] = Handlebars.VM.program(i, fn);
                    }
                    return programWrapper;
                },
                merge: function(param, common) {
                    var ret = param || common;
                    if (param && common) {
                        ret = {};
                        Handlebars.Utils.extend(ret, common);
                        Handlebars.Utils.extend(ret, param);
                    }
                    return ret;
                },
                programWithDepth: Handlebars.VM.programWithDepth,
                noop: Handlebars.VM.noop,
                compilerInfo: null
            };
            return function(context, options) {
                options = options || {};
                var result = templateSpec.call(container, Handlebars, context, options.helpers, options.partials, options.data);
                var compilerInfo = container.compilerInfo || [], compilerRevision = compilerInfo[0] || 1, currentRevision = Handlebars.COMPILER_REVISION;
                if (compilerRevision !== currentRevision) {
                    if (compilerRevision < currentRevision) {
                        var runtimeVersions = Handlebars.REVISION_CHANGES[currentRevision], compilerVersions = Handlebars.REVISION_CHANGES[compilerRevision];
                        throw "Template was precompiled with an older version of Handlebars than the current runtime. " + "Please update your precompiler to a newer version (" + runtimeVersions + ") or downgrade your runtime to an older version (" + compilerVersions + ").";
                    } else {
                        throw "Template was precompiled with a newer version of Handlebars than the current runtime. " + "Please update your runtime to a newer version (" + compilerInfo[1] + ").";
                    }
                }
                return result;
            };
        },
        programWithDepth: function(i, fn, data) {
            var args = Array.prototype.slice.call(arguments, 3);
            var program = function(context, options) {
                options = options || {};
                return fn.apply(this, [ context, options.data || data ].concat(args));
            };
            program.program = i;
            program.depth = args.length;
            return program;
        },
        program: function(i, fn, data) {
            var program = function(context, options) {
                options = options || {};
                return fn(context, options.data || data);
            };
            program.program = i;
            program.depth = 0;
            return program;
        },
        noop: function() {
            return "";
        },
        invokePartial: function(partial, name, context, helpers, partials, data) {
            var options = {
                helpers: helpers,
                partials: partials,
                data: data
            };
            if (partial === undefined) {
                throw new Handlebars.Exception("The partial " + name + " could not be found");
            } else if (partial instanceof Function) {
                return partial(context, options);
            } else if (!Handlebars.compile) {
                throw new Handlebars.Exception("The partial " + name + " could not be compiled when running in runtime-only mode");
            } else {
                partials[name] = Handlebars.compile(partial, {
                    data: data !== undefined
                });
                return partials[name](context, options);
            }
        }
    };
    Handlebars.template = Handlebars.VM.template;
})(Handlebars);

define("handlebars", Handlebars);
define("templates", [ "handlebars" ], function(Handlebars) {
    var template = Handlebars.template;
    return {
        "banners.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
            this.compilerInfo = [ 4, ">= 1.0.0" ];
            helpers = this.merge(helpers, Handlebars.helpers);
            data = data || {};
            var buffer = "", stack1, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
            function program1(depth0, data) {
                var buffer = "", stack1, stack2, options;
                buffer += "\n            ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(2, program2, data),
                    data: data
                };
                stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSIE", options) : helperMissing.call(depth0, "browser", "MSIE", options));
                if (stack2 || stack2 === 0) {
                    buffer += stack2;
                }
                buffer += "\n            ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(2, program2, data),
                    data: data
                };
                stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSEDGE", 15, options) : helperMissing.call(depth0, "browser", "MSEDGE", 15, options));
                if (stack2 || stack2 === 0) {
                    buffer += stack2;
                }
                buffer += "\n            ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(4, program4, data),
                    data: data
                };
                stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSEDGE", 14, options) : helperMissing.call(depth0, "browser", "MSEDGE", 14, options));
                if (stack2 || stack2 === 0) {
                    buffer += stack2;
                }
                buffer += "\n            ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(2, program2, data),
                    data: data
                };
                stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSEDGE", options) : helperMissing.call(depth0, "browser", "MSEDGE", options));
                if (stack2 || stack2 === 0) {
                    buffer += stack2;
                }
                buffer += "\n            ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(6, program6, data),
                    data: data
                };
                stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                if (stack2 || stack2 === 0) {
                    buffer += stack2;
                }
                buffer += "\n            ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(12, program12, data),
                    data: data
                };
                stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                if (stack2 || stack2 === 0) {
                    buffer += stack2;
                }
                buffer += "\n            ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(14, program14, data),
                    data: data
                };
                stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "SAFARI", options) : helperMissing.call(depth0, "browser", "SAFARI", options));
                if (stack2 || stack2 === 0) {
                    buffer += stack2;
                }
                buffer += "\n        ";
                return buffer;
            }
            function program2(depth0, data) {
                var buffer = "", stack1, options;
                buffer += "\n                <div class='launcher-banner-content'>\n                    <p>";
                options = {
                    hash: {
                        "0": depth0.appFileNameBase,
                        "1": "<strong>",
                        "2": "</strong>"
                    },
                    data: data
                };
                buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.ie", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.ie", options))) + "</p>\n                    " + "\n                    <span></span>\n                </div>\n            ";
                return buffer;
            }
            function program4(depth0, data) {
                var buffer = "", stack1, options;
                buffer += "\n                <div class='launcher-banner-content'>\n                    <p>";
                options = {
                    hash: {
                        "0": depth0.appFileNameBase,
                        "1": "<strong>",
                        "2": "</strong>",
                        "3": "<strong>",
                        "4": "</strong>"
                    },
                    data: data
                };
                buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.edge", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.edge", options))) + "</p>\n                    " + "\n                    <span></span>\n                </div>\n            ";
                return buffer;
            }
            function program6(depth0, data) {
                var buffer = "", stack1, options;
                buffer += "\n                ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(7, program7, data),
                    data: data
                };
                if (stack1 = helpers["switch"]) {
                    stack1 = stack1.call(depth0, options);
                } else {
                    stack1 = depth0["switch"];
                    stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                }
                if (!helpers["switch"]) {
                    stack1 = blockHelperMissing.call(depth0, stack1, options);
                }
                if (stack1 || stack1 === 0) {
                    buffer += stack1;
                }
                buffer += "\n            ";
                return buffer;
            }
            function program7(depth0, data) {
                var buffer = "", stack1, stack2, options;
                buffer += "\n                    ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(8, program8, data),
                    data: data
                };
                stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "WINDOWS", options) : helperMissing.call(depth0, "platform", "WINDOWS", options));
                if (stack2 || stack2 === 0) {
                    buffer += stack2;
                }
                buffer += "\n                    ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(10, program10, data),
                    data: data
                };
                stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "MACOS", options) : helperMissing.call(depth0, "platform", "MACOS", options));
                if (stack2 || stack2 === 0) {
                    buffer += stack2;
                }
                buffer += "\n                ";
                return buffer;
            }
            function program8(depth0, data) {
                var buffer = "", stack1, options;
                buffer += "\n                        <div class='launcher-banner-content-chrome'>\n                            <p>";
                options = {
                    hash: {
                        "0": depth0.appFileNameBase,
                        "1": "<strong>",
                        "2": "</strong>"
                    },
                    data: data
                };
                buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.chromewin", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.chromewin", options))) + "</p>\n                            " + "\n                            <span></span>\n                        </div>\n                    ";
                return buffer;
            }
            function program10(depth0, data) {
                var buffer = "", stack1, options;
                buffer += "\n                        <div class='launcher-banner-content-chromemac'>\n                            <p class=\"step1\">";
                options = {
                    hash: {
                        "0": "<strong>",
                        "1": "</strong>"
                    },
                    data: data
                };
                buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.chromemac1", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.chromemac1", options))) + '</p>\n                            <p class="step2">';
                options = {
                    hash: {
                        "0": depth0.appFileNameBase,
                        "1": "<strong>",
                        "2": "</strong>"
                    },
                    data: data
                };
                buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.run.dmg.mac", options) : helperMissing.call(depth0, "fmt", "download.instructions.run.dmg.mac", options))) + "</p>\n                            " + "\n                            <span></span>\n                        </div>\n                    ";
                return buffer;
            }
            function program12(depth0, data) {
                var buffer = "", stack1, options;
                buffer += "\n                <div class='launcher-banner-content-firefox'>\n                    <p class=\"step1\">";
                options = {
                    hash: {
                        "0": "<strong>",
                        "1": "</strong>"
                    },
                    data: data
                };
                buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.firefoxwin1", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.firefoxwin1", options))) + '</p>\n                    <p class="step2">';
                options = {
                    hash: {
                        "0": depth0.appFileNameBase,
                        "1": "<strong>",
                        "2": "</strong>",
                        "3": depth0.imgFirefoxUpArrow
                    },
                    data: data
                };
                buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.firefoxwin2", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.firefoxwin2", options))) + "</p>\n                    " + "\n                    <span></span>\n                </div>\n            ";
                return buffer;
            }
            function program14(depth0, data) {
                var buffer = "", stack1, options;
                buffer += "\n                <div class='launcher-banner-content-safari'>\n                    <p class=\"step1\">";
                options = {
                    hash: {
                        "0": "<strong>",
                        "1": "</strong>",
                        "2": depth0.imgSafariUpArrow
                    },
                    data: data
                };
                buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.safari1", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.safari1", options))) + '</p>\n                    <p class="step2">';
                options = {
                    hash: {
                        "0": depth0.appFileNameBase,
                        "1": "<strong>",
                        "2": "</strong>"
                    },
                    data: data
                };
                buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.run.dmg.mac", options) : helperMissing.call(depth0, "fmt", "download.instructions.run.dmg.mac", options))) + "</p>\n                    " + "\n                    <span></span>\n                </div>\n            ";
                return buffer;
            }
            buffer += "\n<div id='animated-instructions' class=\"launcher-animated-instructions\">\n    <div class='launcher-message-banner launcher-instructions-banner'>\n        ";
            options = {
                hash: {},
                inverse: self.noop,
                fn: self.program(1, program1, data),
                data: data
            };
            if (stack1 = helpers["switch"]) {
                stack1 = stack1.call(depth0, options);
            } else {
                stack1 = depth0["switch"];
                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
            }
            if (!helpers["switch"]) {
                stack1 = blockHelperMissing.call(depth0, stack1, options);
            }
            if (stack1 || stack1 === 0) {
                buffer += stack1;
            }
            buffer += "\n    </div>\n</div>\n\n";
            return buffer;
        }),
        joinState: {
            head: {
                "HOST_NOT_SUPPORTED.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression;
                    buffer += '\n<h1 class="instructions-head-title">';
                    options = {
                        hash: {},
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.unsupported.h", options) : helperMissing.call(depth0, "fmt", "download.unsupported.h", options))) + "</h1>";
                    return buffer;
                }),
                "SUCCESS.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this;
                    function program1(depth0, data) {
                        var buffer = "", stack1, stack2;
                        buffer += "\n    ";
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isSilent), {
                            hash: {},
                            inverse: self.program(4, program4, data),
                            fn: self.program(2, program2, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n";
                        return buffer;
                    }
                    function program2(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += '\n        <h1 class="instructions-head-title">';
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.started.silent.h", options) : helperMissing.call(depth0, "fmt", "installer.plugin.started.silent.h", options))) + "</h1>\n    ";
                        return buffer;
                    }
                    function program4(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += '\n        <h1 class="instructions-head-title">';
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.started.h", options) : helperMissing.call(depth0, "fmt", "installer.plugin.started.h", options))) + "</h1>\n    ";
                        return buffer;
                    }
                    function program6(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += '\n    <h1 class="instructions-head-title">';
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.connected.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.connected.h", options))) + "</h1>\n";
                        return buffer;
                    }
                    buffer += "\n";
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(6, program6, data),
                        fn: self.program(1, program1, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    return buffer;
                }),
                "ERROR.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this;
                    function program1(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.error.header", options) : helperMissing.call(depth0, "fmt", "installer.error.header", options))) + "\n    ";
                        return buffer;
                    }
                    function program3(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.error.header", options) : helperMissing.call(depth0, "fmt", "launch.error.header", options))) + "\n    ";
                        return buffer;
                    }
                    function program5(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": "<strong>",
                                "2": "</strong>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.error.ingress", options) : helperMissing.call(depth0, "fmt", "installer.error.ingress", options))) + "\n    ";
                        return buffer;
                    }
                    function program7(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": "<strong>",
                                "2": "</strong>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.error.ingress", options) : helperMissing.call(depth0, "fmt", "launch.error.ingress", options))) + "\n    ";
                        return buffer;
                    }
                    buffer += '\n<h1 class="instructions-head-title">\n    ';
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(3, program3, data),
                        fn: self.program(1, program1, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += '\n</h1>\n<p class="instructions-head-description">\n    ';
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(7, program7, data),
                        fn: self.program(5, program5, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += '\n</p>\n<a href="#" class="launcher-restart-join-flow-hook colorglow dark-blue large">\n    <div class="btn-bg">\n        <span>\n            ';
                    options = {
                        hash: {
                            "0": depth0.productName
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.button.onerror.text", options) : helperMissing.call(depth0, "fmt", "launch.button.onerror.text", options))) + "\n        </span>\n    </div>\n</a>\n<p/>\n";
                    return buffer;
                })
            },
            main: {
                "SUCCESS.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this;
                    function program1(depth0, data) {
                        var buffer = "", stack1, stack2;
                        buffer += "\n    ";
                        stack2 = helpers.unless.call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isSilent), {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(2, program2, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n";
                        return buffer;
                    }
                    function program2(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.download.plugin.launch.app", options) : helperMissing.call(depth0, "fmt", "installer.download.plugin.launch.app", options))) + "\n    ";
                        return buffer;
                    }
                    function program4(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n    ";
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.launch.app", options) : helperMissing.call(depth0, "fmt", "download.plugin.launch.app", options))) + "\n";
                        return buffer;
                    }
                    buffer += '\n<p class="instructions-head-description">\n';
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(4, program4, data),
                        fn: self.program(1, program1, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += '\n\n    <span class="msg-close-window">';
                    options = {
                        hash: {},
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.launch.app.closewindow", options) : helperMissing.call(depth0, "fmt", "download.plugin.launch.app.closewindow", options))) + "</span>\n</p>\n";
                    return buffer;
                })
            }
        },
        templates: {
            "banners.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                this.compilerInfo = [ 4, ">= 1.0.0" ];
                helpers = this.merge(helpers, Handlebars.helpers);
                data = data || {};
                var buffer = "", stack1, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
                function program1(depth0, data) {
                    var buffer = "", stack1, stack2, options;
                    buffer += "\n            ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(2, program2, data),
                        data: data
                    };
                    stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSIE", options) : helperMissing.call(depth0, "browser", "MSIE", options));
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n            ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(2, program2, data),
                        data: data
                    };
                    stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSEDGE", 15, options) : helperMissing.call(depth0, "browser", "MSEDGE", 15, options));
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n            ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(4, program4, data),
                        data: data
                    };
                    stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSEDGE", 14, options) : helperMissing.call(depth0, "browser", "MSEDGE", 14, options));
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n            ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(2, program2, data),
                        data: data
                    };
                    stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSEDGE", options) : helperMissing.call(depth0, "browser", "MSEDGE", options));
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n            ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(6, program6, data),
                        data: data
                    };
                    stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n            ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(12, program12, data),
                        data: data
                    };
                    stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n            ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(14, program14, data),
                        data: data
                    };
                    stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "SAFARI", options) : helperMissing.call(depth0, "browser", "SAFARI", options));
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n        ";
                    return buffer;
                }
                function program2(depth0, data) {
                    var buffer = "", stack1, options;
                    buffer += "\n                <div class='launcher-banner-content'>\n                    <p>";
                    options = {
                        hash: {
                            "0": depth0.appFileNameBase,
                            "1": "<strong>",
                            "2": "</strong>"
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.ie", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.ie", options))) + "</p>\n                    " + "\n                    <span></span>\n                </div>\n            ";
                    return buffer;
                }
                function program4(depth0, data) {
                    var buffer = "", stack1, options;
                    buffer += "\n                <div class='launcher-banner-content'>\n                    <p>";
                    options = {
                        hash: {
                            "0": depth0.appFileNameBase,
                            "1": "<strong>",
                            "2": "</strong>",
                            "3": "<strong>",
                            "4": "</strong>"
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.edge", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.edge", options))) + "</p>\n                    " + "\n                    <span></span>\n                </div>\n            ";
                    return buffer;
                }
                function program6(depth0, data) {
                    var buffer = "", stack1, options;
                    buffer += "\n                ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(7, program7, data),
                        data: data
                    };
                    if (stack1 = helpers["switch"]) {
                        stack1 = stack1.call(depth0, options);
                    } else {
                        stack1 = depth0["switch"];
                        stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                    }
                    if (!helpers["switch"]) {
                        stack1 = blockHelperMissing.call(depth0, stack1, options);
                    }
                    if (stack1 || stack1 === 0) {
                        buffer += stack1;
                    }
                    buffer += "\n            ";
                    return buffer;
                }
                function program7(depth0, data) {
                    var buffer = "", stack1, stack2, options;
                    buffer += "\n                    ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(8, program8, data),
                        data: data
                    };
                    stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "WINDOWS", options) : helperMissing.call(depth0, "platform", "WINDOWS", options));
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n                    ";
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(10, program10, data),
                        data: data
                    };
                    stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "MACOS", options) : helperMissing.call(depth0, "platform", "MACOS", options));
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n                ";
                    return buffer;
                }
                function program8(depth0, data) {
                    var buffer = "", stack1, options;
                    buffer += "\n                        <div class='launcher-banner-content-chrome'>\n                            <p>";
                    options = {
                        hash: {
                            "0": depth0.appFileNameBase,
                            "1": "<strong>",
                            "2": "</strong>"
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.chromewin", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.chromewin", options))) + "</p>\n                            " + "\n                            <span></span>\n                        </div>\n                    ";
                    return buffer;
                }
                function program10(depth0, data) {
                    var buffer = "", stack1, options;
                    buffer += "\n                        <div class='launcher-banner-content-chromemac'>\n                            <p class=\"step1\">";
                    options = {
                        hash: {
                            "0": "<strong>",
                            "1": "</strong>"
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.chromemac1", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.chromemac1", options))) + '</p>\n                            <p class="step2">';
                    options = {
                        hash: {
                            "0": depth0.appFileNameBase,
                            "1": "<strong>",
                            "2": "</strong>"
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.run.dmg.mac", options) : helperMissing.call(depth0, "fmt", "download.instructions.run.dmg.mac", options))) + "</p>\n                            " + "\n                            <span></span>\n                        </div>\n                    ";
                    return buffer;
                }
                function program12(depth0, data) {
                    var buffer = "", stack1, options;
                    buffer += "\n                <div class='launcher-banner-content-firefox'>\n                    <p class=\"step1\">";
                    options = {
                        hash: {
                            "0": "<strong>",
                            "1": "</strong>"
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.firefoxwin1", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.firefoxwin1", options))) + '</p>\n                    <p class="step2">';
                    options = {
                        hash: {
                            "0": depth0.appFileNameBase,
                            "1": "<strong>",
                            "2": "</strong>",
                            "3": depth0.imgFirefoxUpArrow
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.firefoxwin2", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.firefoxwin2", options))) + "</p>\n                    " + "\n                    <span></span>\n                </div>\n            ";
                    return buffer;
                }
                function program14(depth0, data) {
                    var buffer = "", stack1, options;
                    buffer += "\n                <div class='launcher-banner-content-safari'>\n                    <p class=\"step1\">";
                    options = {
                        hash: {
                            "0": "<strong>",
                            "1": "</strong>",
                            "2": depth0.imgSafariUpArrow
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.animated.safari1", options) : helperMissing.call(depth0, "fmt", "download.instructions.animated.safari1", options))) + '</p>\n                    <p class="step2">';
                    options = {
                        hash: {
                            "0": depth0.appFileNameBase,
                            "1": "<strong>",
                            "2": "</strong>"
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.run.dmg.mac", options) : helperMissing.call(depth0, "fmt", "download.instructions.run.dmg.mac", options))) + "</p>\n                    " + "\n                    <span></span>\n                </div>\n            ";
                    return buffer;
                }
                buffer += "\n<div id='animated-instructions' class=\"launcher-animated-instructions\">\n    <div class='launcher-message-banner launcher-instructions-banner'>\n        ";
                options = {
                    hash: {},
                    inverse: self.noop,
                    fn: self.program(1, program1, data),
                    data: data
                };
                if (stack1 = helpers["switch"]) {
                    stack1 = stack1.call(depth0, options);
                } else {
                    stack1 = depth0["switch"];
                    stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                }
                if (!helpers["switch"]) {
                    stack1 = blockHelperMissing.call(depth0, stack1, options);
                }
                if (stack1 || stack1 === 0) {
                    buffer += stack1;
                }
                buffer += "\n    </div>\n</div>\n\n";
                return buffer;
            }),
            joinState: {
                head: {
                    "HOST_NOT_SUPPORTED.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression;
                        buffer += '\n<h1 class="instructions-head-title">';
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.unsupported.h", options) : helperMissing.call(depth0, "fmt", "download.unsupported.h", options))) + "</h1>";
                        return buffer;
                    }),
                    "SUCCESS.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this;
                        function program1(depth0, data) {
                            var buffer = "", stack1, stack2;
                            buffer += "\n    ";
                            stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isSilent), {
                                hash: {},
                                inverse: self.program(4, program4, data),
                                fn: self.program(2, program2, data),
                                data: data
                            });
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n";
                            return buffer;
                        }
                        function program2(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += '\n        <h1 class="instructions-head-title">';
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.started.silent.h", options) : helperMissing.call(depth0, "fmt", "installer.plugin.started.silent.h", options))) + "</h1>\n    ";
                            return buffer;
                        }
                        function program4(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += '\n        <h1 class="instructions-head-title">';
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.started.h", options) : helperMissing.call(depth0, "fmt", "installer.plugin.started.h", options))) + "</h1>\n    ";
                            return buffer;
                        }
                        function program6(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += '\n    <h1 class="instructions-head-title">';
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.connected.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.connected.h", options))) + "</h1>\n";
                            return buffer;
                        }
                        buffer += "\n";
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(6, program6, data),
                            fn: self.program(1, program1, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        return buffer;
                    }),
                    "ERROR.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this;
                        function program1(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.error.header", options) : helperMissing.call(depth0, "fmt", "installer.error.header", options))) + "\n    ";
                            return buffer;
                        }
                        function program3(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.error.header", options) : helperMissing.call(depth0, "fmt", "launch.error.header", options))) + "\n    ";
                            return buffer;
                        }
                        function program5(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": "<strong>",
                                    "2": "</strong>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.error.ingress", options) : helperMissing.call(depth0, "fmt", "installer.error.ingress", options))) + "\n    ";
                            return buffer;
                        }
                        function program7(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": "<strong>",
                                    "2": "</strong>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.error.ingress", options) : helperMissing.call(depth0, "fmt", "launch.error.ingress", options))) + "\n    ";
                            return buffer;
                        }
                        buffer += '\n<h1 class="instructions-head-title">\n    ';
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(3, program3, data),
                            fn: self.program(1, program1, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += '\n</h1>\n<p class="instructions-head-description">\n    ';
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(7, program7, data),
                            fn: self.program(5, program5, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += '\n</p>\n<a href="#" class="launcher-restart-join-flow-hook colorglow dark-blue large">\n    <div class="btn-bg">\n        <span>\n            ';
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.button.onerror.text", options) : helperMissing.call(depth0, "fmt", "launch.button.onerror.text", options))) + "\n        </span>\n    </div>\n</a>\n<p/>\n";
                        return buffer;
                    })
                },
                main: {
                    "SUCCESS.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this;
                        function program1(depth0, data) {
                            var buffer = "", stack1, stack2;
                            buffer += "\n    ";
                            stack2 = helpers.unless.call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isSilent), {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(2, program2, data),
                                data: data
                            });
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n";
                            return buffer;
                        }
                        function program2(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.download.plugin.launch.app", options) : helperMissing.call(depth0, "fmt", "installer.download.plugin.launch.app", options))) + "\n    ";
                            return buffer;
                        }
                        function program4(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n    ";
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.launch.app", options) : helperMissing.call(depth0, "fmt", "download.plugin.launch.app", options))) + "\n";
                            return buffer;
                        }
                        buffer += '\n<p class="instructions-head-description">\n';
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(4, program4, data),
                            fn: self.program(1, program1, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += '\n\n    <span class="msg-close-window">';
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.launch.app.closewindow", options) : helperMissing.call(depth0, "fmt", "download.plugin.launch.app.closewindow", options))) + "</span>\n</p>\n";
                        return buffer;
                    })
                }
            },
            joinInstruction: {
                head: {
                    "LAUNCHING_APP.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
                        function program1(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += '\n    <h1 class="instructions-head-title">';
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.installer.h", options) : helperMissing.call(depth0, "fmt", "launching.installer.h", options))) + "</h1>\n";
                            return buffer;
                        }
                        function program3(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += '\n    <h1 class="instructions-head-title">';
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.h", options) : helperMissing.call(depth0, "fmt", "launching.app.h", options))) + "</h1>\n";
                            return buffer;
                        }
                        function program5(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n    ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(6, program6, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n    ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(10, program10, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n";
                            return buffer;
                        }
                        function program6(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": "<strong>",
                                    "1": "</strong>",
                                    "2": "launching.app.ingress.chrome"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n        ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(7, program7, data),
                                data: data
                            };
                            if (stack2 = helpers["switch"]) {
                                stack2 = stack2.call(depth0, options);
                            } else {
                                stack2 = depth0["switch"];
                                stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                            }
                            if (!helpers["switch"]) {
                                stack2 = blockHelperMissing.call(depth0, stack2, options);
                            }
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n    ";
                            return buffer;
                        }
                        function program7(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n            ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(8, program8, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.product || depth0.product, stack1 ? stack1.call(depth0, "g2ac_customer", options) : helperMissing.call(depth0, "product", "g2ac_customer", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n        ";
                            return buffer;
                        }
                        function program8(depth0, data) {
                            return "\n                 <br/>\n            ";
                        }
                        function program10(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": "<strong>",
                                    "1": "</strong>",
                                    "2": "launching.app.ingress.firefox"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n    ";
                            return buffer;
                        }
                        function program12(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": depth0.manualRestartDownloadLinkStart,
                                    "2": depth0.linkEnd,
                                    "3": depth0.appLaunchLinkStart,
                                    "4": depth0.linkEnd
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.fallback.tryagain", options) : helperMissing.call(depth0, "fmt", "installer.fallback.tryagain", options))) + "\n    ";
                            return buffer;
                        }
                        function program14(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": depth0.manualRestartDownloadLinkStart,
                                    "2": depth0.linkEnd,
                                    "3": depth0.appLaunchLinkStart,
                                    "4": depth0.linkEnd
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.fallback.tryagain", options) : helperMissing.call(depth0, "fmt", "launching.app.fallback.tryagain", options))) + "\n    ";
                            return buffer;
                        }
                        buffer += "\n";
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(3, program3, data),
                            fn: self.program(1, program1, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += '\n<p class="instructions-head-description">\n';
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(5, program5, data),
                            data: data
                        };
                        if (stack2 = helpers["switch"]) {
                            stack2 = stack2.call(depth0, options);
                        } else {
                            stack2 = depth0["switch"];
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        if (!helpers["switch"]) {
                            stack2 = blockHelperMissing.call(depth0, stack2, options);
                        }
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n<span>\n    ";
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(14, program14, data),
                            fn: self.program(12, program12, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n</span>\n</p>\n";
                        return buffer;
                    }),
                    "DOWNLOADING.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
                        function program1(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(2, program2, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.apiVersion || depth0.apiVersion, stack1 ? stack1.call(depth0, 2, options) : helperMissing.call(depth0, "apiVersion", 2, options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(7, program7, data),
                                data: data
                            };
                            if (stack2 = helpers["default"]) {
                                stack2 = stack2.call(depth0, options);
                            } else {
                                stack2 = depth0["default"];
                                stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                            }
                            if (!helpers["default"]) {
                                stack2 = blockHelperMissing.call(depth0, stack2, options);
                            }
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n    ";
                            return buffer;
                        }
                        function program2(depth0, data) {
                            var buffer = "", stack1, stack2;
                            buffer += "\n            ";
                            stack2 = helpers["if"].call(depth0, (stack1 = (stack1 = depth0.userAgent, stack1 == null || stack1 === false ? stack1 : stack1.is), 
                            stack1 == null || stack1 === false ? stack1 : stack1.WINDOWS), {
                                hash: {},
                                inverse: self.program(5, program5, data),
                                fn: self.program(3, program3, data),
                                data: data
                            });
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n        ";
                            return buffer;
                        }
                        function program3(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n                " + "\n                ";
                            options = {
                                hash: {
                                    "0": depth0.appFileNameBase
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.run.product.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.run.product.h", options))) + "\n            ";
                            return buffer;
                        }
                        function program5(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n                ";
                            options = {
                                hash: {
                                    "0": depth0.appFileNameBase
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.open.product.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.open.product.h", options))) + "\n            ";
                            return buffer;
                        }
                        function program7(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n            " + "\n            ";
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.h", options))) + "\n        ";
                            return buffer;
                        }
                        function program9(depth0, data) {
                            var stack1, stack2, options;
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(10, program10, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSIE", options) : helperMissing.call(depth0, "browser", "MSIE", options));
                            if (stack2 || stack2 === 0) {
                                return stack2;
                            } else {
                                return "";
                            }
                        }
                        function program10(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "<br />";
                            options = {
                                hash: {
                                    "0": depth0.appLaunchLinkStart,
                                    "1": depth0.linkEnd
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.ingress.trylaunch", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.ingress.trylaunch", options)));
                            return buffer;
                        }
                        buffer += '\n<h1 class="instructions-head-title">\n    ';
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(1, program1, data),
                            data: data
                        };
                        if (stack1 = helpers["switch"]) {
                            stack1 = stack1.call(depth0, options);
                        } else {
                            stack1 = depth0["switch"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        if (!helpers["switch"]) {
                            stack1 = blockHelperMissing.call(depth0, stack1, options);
                        }
                        if (stack1 || stack1 === 0) {
                            buffer += stack1;
                        }
                        buffer += '\n</h1>\n<p class="instructions-head-description">';
                        options = {
                            hash: {
                                "0": depth0.manualRestartDownloadLinkStart,
                                "1": depth0.linkEnd
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.ingress.restart", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.ingress.restart", options)));
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(9, program9, data),
                            data: data
                        };
                        if (stack2 = helpers["switch"]) {
                            stack2 = stack2.call(depth0, options);
                        } else {
                            stack2 = depth0["switch"];
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        if (!helpers["switch"]) {
                            stack2 = blockHelperMissing.call(depth0, stack2, options);
                        }
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "</p>";
                        return buffer;
                    }),
                    "CLICKONCE.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function";
                        function program1(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": "<strong>",
                                    "2": "</strong>",
                                    "3": "<strong>",
                                    "4": "</strong>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.clickonce.ingress", options) : helperMissing.call(depth0, "fmt", "installer.plugin.clickonce.ingress", options))) + "\n    ";
                            return buffer;
                        }
                        function program3(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": "<strong>",
                                    "2": "</strong>",
                                    "3": "<strong>",
                                    "4": "</strong>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.clickonce.ingress", options) : helperMissing.call(depth0, "fmt", "download.plugin.clickonce.ingress", options))) + "\n    ";
                            return buffer;
                        }
                        function program5(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n                    ";
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.clickonce.h", options) : helperMissing.call(depth0, "fmt", "installer.plugin.clickonce.h", options))) + "\n                ";
                            return buffer;
                        }
                        function program7(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n                    ";
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.clickonce.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.clickonce.h", options))) + "\n                ";
                            return buffer;
                        }
                        function program9(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n                ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": depth0.manualRestartDownloadLinkStart,
                                    "2": "</a>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.app.fallback", options) : helperMissing.call(depth0, "fmt", "installer.app.fallback", options))) + "\n            ";
                            return buffer;
                        }
                        function program11(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n                ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": depth0.manualRestartDownloadLinkStart,
                                    "2": "</a>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.fallback", options) : helperMissing.call(depth0, "fmt", "launching.app.fallback", options))) + "\n            ";
                            return buffer;
                        }
                        buffer += '\n\n<p class="launcher-instructions-head-first">\n    ';
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(3, program3, data),
                            fn: self.program(1, program1, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += '\n</p>\n<a id="launcher-clickonce-button" href="';
                        if (stack2 = helpers.clickOnceUrl) {
                            stack2 = stack2.call(depth0, {
                                hash: {},
                                data: data
                            });
                        } else {
                            stack2 = depth0.clickOnceUrl;
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        buffer += escapeExpression(stack2) + '" class="colorglow dark-blue large">\n    <div class="btn-bg">\n            <span>\n                ';
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(7, program7, data),
                            fn: self.program(5, program5, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += '\n            </span>\n    </div>\n</a>\n<p class="instructions-head-description clickonce-launch-info">\n        <span>\n            ';
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(11, program11, data),
                            fn: self.program(9, program9, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n        </span>\n</p>\n\n";
                        return buffer;
                    }),
                    "LAUNCHED_APP.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function";
                        function program1(depth0, data) {
                            var buffer = "", stack1, stack2;
                            buffer += "\n        ";
                            stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isSilent), {
                                hash: {},
                                inverse: self.program(4, program4, data),
                                fn: self.program(2, program2, data),
                                data: data
                            });
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n    ";
                            return buffer;
                        }
                        function program2(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n            ";
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.installer.app.silent.h", options) : helperMissing.call(depth0, "fmt", "download.installer.app.silent.h", options))) + "\n        ";
                            return buffer;
                        }
                        function program4(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n            ";
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.installer.app.h", options) : helperMissing.call(depth0, "fmt", "download.installer.app.h", options))) + "\n        ";
                            return buffer;
                        }
                        function program6(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launched.app.h", options) : helperMissing.call(depth0, "fmt", "launched.app.h", options))) + "\n    ";
                            return buffer;
                        }
                        function program8(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.launched.app.ingress", options) : helperMissing.call(depth0, "fmt", "installer.launched.app.ingress", options))) + "\n    ";
                            return buffer;
                        }
                        function program10(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launched.app.ingress", options) : helperMissing.call(depth0, "fmt", "launched.app.ingress", options))) + "\n    ";
                            return buffer;
                        }
                        function program12(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n            ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": depth0.manualRestartDownloadLinkStart,
                                    "2": depth0.linkEnd
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.app.fallback", options) : helperMissing.call(depth0, "fmt", "installer.app.fallback", options))) + "\n        ";
                            return buffer;
                        }
                        function program14(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n            ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": depth0.manualRestartDownloadLinkStart,
                                    "2": depth0.linkEnd
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.fallback", options) : helperMissing.call(depth0, "fmt", "launching.app.fallback", options))) + "\n        ";
                            return buffer;
                        }
                        buffer += '\n\n<h1 class="instructions-head-title">\n    ';
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(6, program6, data),
                            fn: self.program(1, program1, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += '\n    <img src="';
                        if (stack2 = helpers.throbberUrl) {
                            stack2 = stack2.call(depth0, {
                                hash: {},
                                data: data
                            });
                        } else {
                            stack2 = depth0.throbberUrl;
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        buffer += escapeExpression(stack2) + '" alt="" width=16 height=16>\n</h1>\n\n<p class="instructions-head-description">\n    ';
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(10, program10, data),
                            fn: self.program(8, program8, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    <span>\n        ";
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(14, program14, data),
                            fn: self.program(12, program12, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n\n    </span>\n</p>";
                        return buffer;
                    }),
                    "TRY_LAUNCHING_APP.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
                        function program1(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n            ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(2, program2, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n            ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(4, program4, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "SAFARI", options) : helperMissing.call(depth0, "browser", "SAFARI", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n            ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(6, program6, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n        ";
                            return buffer;
                        }
                        function program2(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n                ";
                            options = {
                                hash: {
                                    "0": "<strong>",
                                    "1": "</strong>",
                                    "2": "launching.app.ingress.firefox"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n            ";
                            return buffer;
                        }
                        function program4(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n                ";
                            options = {
                                hash: {
                                    "0": "<strong>",
                                    "1": "</strong>",
                                    "2": "launching.app.ingress.safari"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n            ";
                            return buffer;
                        }
                        function program6(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n                ";
                            options = {
                                hash: {
                                    "0": "<strong>",
                                    "1": "</strong>",
                                    "2": "launching.app.ingress.chrome"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n            ";
                            return buffer;
                        }
                        buffer += '\n\n<h1 class="instructions-head-title">\n    ';
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "trylaunching.app.h", options) : helperMissing.call(depth0, "fmt", "trylaunching.app.h", options))) + '\n</h1>\n\n<div class="instructions-head-description">\n    <p>\n        ';
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(1, program1, data),
                            data: data
                        };
                        if (stack2 = helpers["switch"]) {
                            stack2 = stack2.call(depth0, options);
                        } else {
                            stack2 = depth0["switch"];
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        if (!helpers["switch"]) {
                            stack2 = blockHelperMissing.call(depth0, stack2, options);
                        }
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    </p>\n    <br />\n    <p>\n        <strong>\n            ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": depth0.manualDownloadLinkStart,
                                "2": depth0.linkEnd
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "trylaunching.app.fallback", options) : helperMissing.call(depth0, "fmt", "trylaunching.app.fallback", options))) + "\n        </strong>\n    </p>\n</div>\n";
                        return buffer;
                    }),
                    "LAUNCH_BY_CLICK.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
                        function program1(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        <span>";
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.clickonce.h", options) : helperMissing.call(depth0, "fmt", "installer.plugin.clickonce.h", options))) + "</span>\n    ";
                            return buffer;
                        }
                        function program3(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        <span>";
                            options = {
                                hash: {
                                    "0": depth0.productName
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.clickonce.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.clickonce.h", options))) + "</span>\n    ";
                            return buffer;
                        }
                        function program5(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(6, program6, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(6, program6, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "OPERA", options) : helperMissing.call(depth0, "browser", "OPERA", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(8, program8, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n    ";
                            return buffer;
                        }
                        function program6(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n            ";
                            options = {
                                hash: {
                                    "0": "<strong>",
                                    "1": "</strong>",
                                    "2": "launching.app.ingress.chrome"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n        ";
                            return buffer;
                        }
                        function program8(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n            ";
                            options = {
                                hash: {
                                    "0": "<strong>",
                                    "1": "</strong>",
                                    "2": "launching.app.ingress.firefox"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n        ";
                            return buffer;
                        }
                        function program10(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": depth0.manualRestartDownloadLinkStart,
                                    "2": "</a>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.app.fallback", options) : helperMissing.call(depth0, "fmt", "installer.app.fallback", options))) + "\n    ";
                            return buffer;
                        }
                        function program12(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n        ";
                            options = {
                                hash: {
                                    "0": depth0.productName,
                                    "1": depth0.manualRestartDownloadLinkStart,
                                    "2": "</a>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.fallback", options) : helperMissing.call(depth0, "fmt", "launching.app.fallback", options))) + "\n    ";
                            return buffer;
                        }
                        buffer += '\n<div class="launcher-launch-by-click-button">\n<a class="launcher-launch-hook launcher-colorglow dark-blue large" href="';
                        if (stack1 = helpers.appLaunchUrl) {
                            stack1 = stack1.call(depth0, {
                                hash: {},
                                data: data
                            });
                        } else {
                            stack1 = depth0.appLaunchUrl;
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        if (stack1 || stack1 === 0) {
                            buffer += stack1;
                        }
                        buffer += '">\n    <div class="btn-bg">\n    ';
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(3, program3, data),
                            fn: self.program(1, program1, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += '\n    </div>\n</a>\n</div>\n<p class="instructions-head-description clickonce-launch-info">\n    ';
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(5, program5, data),
                            data: data
                        };
                        if (stack2 = helpers["switch"]) {
                            stack2 = stack2.call(depth0, options);
                        } else {
                            stack2 = depth0["switch"];
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        if (!helpers["switch"]) {
                            stack2 = blockHelperMissing.call(depth0, stack2, options);
                        }
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    ";
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.program(12, program12, data),
                            fn: self.program(10, program10, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n</p>\n\n";
                        return buffer;
                    })
                },
                main: {
                    "LAUNCHING_APP.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, stack2, functionType = "function", escapeExpression = this.escapeExpression, self = this, helperMissing = helpers.helperMissing, blockHelperMissing = helpers.blockHelperMissing;
                        function program1(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n    ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(2, program2, data),
                                data: data
                            };
                            if (stack1 = helpers["switch"]) {
                                stack1 = stack1.call(depth0, options);
                            } else {
                                stack1 = depth0["switch"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            if (!helpers["switch"]) {
                                stack1 = blockHelperMissing.call(depth0, stack1, options);
                            }
                            if (stack1 || stack1 === 0) {
                                buffer += stack1;
                            }
                            buffer += "\n";
                            return buffer;
                        }
                        function program2(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(3, program3, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(9, program9, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n    ";
                            return buffer;
                        }
                        function program3(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += '\n            <div id="launch-instructions" class="instructions-main-container clearfix">\n                ';
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(4, program4, data),
                                data: data
                            };
                            if (stack1 = helpers["switch"]) {
                                stack1 = stack1.call(depth0, options);
                            } else {
                                stack1 = depth0["switch"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            if (!helpers["switch"]) {
                                stack1 = blockHelperMissing.call(depth0, stack1, options);
                            }
                            if (stack1 || stack1 === 0) {
                                buffer += stack1;
                            }
                            buffer += '\n\n                <div class="instructions-main-panel">\n                    <h3 class="instructions-main-title">';
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.instructions.h", options) : helperMissing.call(depth0, "fmt", "launch.instructions.h", options))) + '</h3>\n\n                    <p class="instructions-main-description">\n                        <span>';
                            options = {
                                hash: {
                                    "0": "<strong>",
                                    "1": "</strong>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.instructions.checkBoxToSkipMessageHint", options) : helperMissing.call(depth0, "fmt", "launch.instructions.checkBoxToSkipMessageHint", options))) + "</span>\n                    </p>\n                </div>\n\n            </div>\n        ";
                            return buffer;
                        }
                        function program4(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n                    ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(5, program5, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "MACOS", options) : helperMissing.call(depth0, "platform", "MACOS", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n                    ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(7, program7, data),
                                data: data
                            };
                            if (stack2 = helpers["default"]) {
                                stack2 = stack2.call(depth0, options);
                            } else {
                                stack2 = depth0["default"];
                                stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                            }
                            if (!helpers["default"]) {
                                stack2 = blockHelperMissing.call(depth0, stack2, options);
                            }
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n                ";
                            return buffer;
                        }
                        function program5(depth0, data) {
                            var buffer = "", stack1;
                            buffer += '\n                        <img class="instructions-main-image launcher-launch-hook"\n                             src="';
                            if (stack1 = helpers["static"]) {
                                stack1 = stack1.call(depth0, {
                                    hash: {},
                                    data: data
                                });
                            } else {
                                stack1 = depth0["static"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            buffer += escapeExpression(stack1) + '/images/launch-instructions/firefox-osx.png" alt="">\n                    ';
                            return buffer;
                        }
                        function program7(depth0, data) {
                            var buffer = "", stack1;
                            buffer += '\n                        <img class="instructions-main-image launcher-launch-hook"\n                             src="';
                            if (stack1 = helpers["static"]) {
                                stack1 = stack1.call(depth0, {
                                    hash: {},
                                    data: data
                                });
                            } else {
                                stack1 = depth0["static"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            buffer += escapeExpression(stack1) + '/images/launch-instructions/firefox-win.png" alt="">\n                    ';
                            return buffer;
                        }
                        function program9(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += '\n            <div id="launch-instructions" class="instructions-main-container clearfix">\n                ';
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(10, program10, data),
                                data: data
                            };
                            if (stack1 = helpers["switch"]) {
                                stack1 = stack1.call(depth0, options);
                            } else {
                                stack1 = depth0["switch"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            if (!helpers["switch"]) {
                                stack1 = blockHelperMissing.call(depth0, stack1, options);
                            }
                            if (stack1 || stack1 === 0) {
                                buffer += stack1;
                            }
                            buffer += '\n\n                <div class="instructions-main-panel">\n                    <h3 class="instructions-main-title">';
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.instructions.h", options) : helperMissing.call(depth0, "fmt", "launch.instructions.h", options))) + '</h3>\n\n                    <p class="instructions-main-description">\n                        <span>';
                            options = {
                                hash: {
                                    "0": "<strong>",
                                    "1": "</strong>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.instructions.checkBoxToSkipMessageHint", options) : helperMissing.call(depth0, "fmt", "launch.instructions.checkBoxToSkipMessageHint", options))) + "</span>\n                    </p>\n                </div>\n\n            </div>\n        ";
                            return buffer;
                        }
                        function program10(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n                    ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(11, program11, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "MACOS", options) : helperMissing.call(depth0, "platform", "MACOS", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n                    ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(13, program13, data),
                                data: data
                            };
                            if (stack2 = helpers["default"]) {
                                stack2 = stack2.call(depth0, options);
                            } else {
                                stack2 = depth0["default"];
                                stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                            }
                            if (!helpers["default"]) {
                                stack2 = blockHelperMissing.call(depth0, stack2, options);
                            }
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n                ";
                            return buffer;
                        }
                        function program11(depth0, data) {
                            var buffer = "", stack1;
                            buffer += '\n                        <img class="instructions-main-image launcher-launch-hook"\n                             src="';
                            if (stack1 = helpers["static"]) {
                                stack1 = stack1.call(depth0, {
                                    hash: {},
                                    data: data
                                });
                            } else {
                                stack1 = depth0["static"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            buffer += escapeExpression(stack1) + '/images/launch-instructions/chrome-osx.png" alt="">\n                    ';
                            return buffer;
                        }
                        function program13(depth0, data) {
                            var buffer = "", stack1;
                            buffer += '\n                        <img class="instructions-main-image launcher-launch-hook"\n                             src="';
                            if (stack1 = helpers["static"]) {
                                stack1 = stack1.call(depth0, {
                                    hash: {},
                                    data: data
                                });
                            } else {
                                stack1 = depth0["static"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            buffer += escapeExpression(stack1) + '/images/launch-instructions/chrome-win.png" alt="">\n                    ';
                            return buffer;
                        }
                        buffer += "\n";
                        stack2 = helpers.unless.call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(1, program1, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        return buffer;
                    }),
                    "DOWNLOADING.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                        this.compilerInfo = [ 4, ">= 1.0.0" ];
                        helpers = this.merge(helpers, Handlebars.helpers);
                        data = data || {};
                        var buffer = "", stack1, functionType = "function", escapeExpression = this.escapeExpression, helperMissing = helpers.helperMissing, self = this, blockHelperMissing = helpers.blockHelperMissing;
                        function program1(depth0, data) {
                            var buffer = "", stack1;
                            buffer += " " + "\n";
                            stack1 = helpers.unless.call(depth0, depth0.renameFile, {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(2, program2, data),
                                data: data
                            });
                            if (stack1 || stack1 === 0) {
                                buffer += stack1;
                            }
                            buffer += "\n";
                            return buffer;
                        }
                        function program2(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += " " + "\n    ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(3, program3, data),
                                data: data
                            };
                            if (stack1 = helpers["switch"]) {
                                stack1 = stack1.call(depth0, options);
                            } else {
                                stack1 = depth0["switch"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            if (!helpers["switch"]) {
                                stack1 = blockHelperMissing.call(depth0, stack1, options);
                            }
                            if (stack1 || stack1 === 0) {
                                buffer += stack1;
                            }
                            buffer += "\n";
                            return buffer;
                        }
                        function program3(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n        ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(4, program4, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "MACOS", options) : helperMissing.call(depth0, "platform", "MACOS", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n    ";
                            return buffer;
                        }
                        function program4(depth0, data) {
                            var buffer = "", stack1, options;
                            buffer += "\n            ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(5, program5, data),
                                data: data
                            };
                            if (stack1 = helpers["switch"]) {
                                stack1 = stack1.call(depth0, options);
                            } else {
                                stack1 = depth0["switch"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            if (!helpers["switch"]) {
                                stack1 = blockHelperMissing.call(depth0, stack1, options);
                            }
                            if (stack1 || stack1 === 0) {
                                buffer += stack1;
                            }
                            buffer += "\n        ";
                            return buffer;
                        }
                        function program5(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += "\n                ";
                            options = {
                                hash: {},
                                inverse: self.noop,
                                fn: self.program(6, program6, data),
                                data: data
                            };
                            stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                            if (stack2 || stack2 === 0) {
                                buffer += stack2;
                            }
                            buffer += "\n            ";
                            return buffer;
                        }
                        function program6(depth0, data) {
                            var buffer = "", stack1, stack2, options;
                            buffer += '\n                    <div class="launcher-instructions-two-columns launcher-instructions-first-column">\n                        <img src="';
                            if (stack1 = helpers["static"]) {
                                stack1 = stack1.call(depth0, {
                                    hash: {},
                                    data: data
                                });
                            } else {
                                stack1 = depth0["static"];
                                stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                            }
                            buffer += escapeExpression(stack1) + '/images/download-steps/ff-dmg-1.png" alt="">\n                        <div class="launcher-instructions-two-columns-text">\n                            <h2>';
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.open.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.open.h", options))) + "</h2>\n                            <p>";
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.open.firefoxmac", options) : helperMissing.call(depth0, "fmt", "download.instructions.open.firefoxmac", options))) + '</p>\n                        </div>\n                    </div>\n                    <div class="launcher-instructions-two-columns launcher-instructions-second-column">\n                        <img src="';
                            if (stack2 = helpers["static"]) {
                                stack2 = stack2.call(depth0, {
                                    hash: {},
                                    data: data
                                });
                            } else {
                                stack2 = depth0["static"];
                                stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                            }
                            buffer += escapeExpression(stack2) + '/images/download-steps/ff-dmg-2.png" alt="">\n                        <div class="launcher-instructions-two-columns-text">\n                            <h2>';
                            options = {
                                hash: {},
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.run.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.run.h", options))) + "</h2>\n                            <p>";
                            options = {
                                hash: {
                                    "0": "GoTo Opener",
                                    "1": "<strong>",
                                    "2": "</strong>"
                                },
                                data: data
                            };
                            buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.run.dmg.mac", options) : helperMissing.call(depth0, "fmt", "download.instructions.run.dmg.mac", options))) + "</p>\n                        </div>\n                    </div>\n                ";
                            return buffer;
                        }
                        buffer += "\n";
                        stack1 = helpers.unless.call(depth0, depth0.hasBanner, {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(1, program1, data),
                            data: data
                        });
                        if (stack1 || stack1 === 0) {
                            buffer += stack1;
                        }
                        buffer += "\n\n";
                        return buffer;
                    })
                }
            }
        },
        joinInstruction: {
            head: {
                "LAUNCHING_APP.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
                    function program1(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += '\n    <h1 class="instructions-head-title">';
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.installer.h", options) : helperMissing.call(depth0, "fmt", "launching.installer.h", options))) + "</h1>\n";
                        return buffer;
                    }
                    function program3(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += '\n    <h1 class="instructions-head-title">';
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.h", options) : helperMissing.call(depth0, "fmt", "launching.app.h", options))) + "</h1>\n";
                        return buffer;
                    }
                    function program5(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n    ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(6, program6, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(10, program10, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n";
                        return buffer;
                    }
                    function program6(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": "<strong>",
                                "1": "</strong>",
                                "2": "launching.app.ingress.chrome"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n        ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(7, program7, data),
                            data: data
                        };
                        if (stack2 = helpers["switch"]) {
                            stack2 = stack2.call(depth0, options);
                        } else {
                            stack2 = depth0["switch"];
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        if (!helpers["switch"]) {
                            stack2 = blockHelperMissing.call(depth0, stack2, options);
                        }
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    ";
                        return buffer;
                    }
                    function program7(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n            ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(8, program8, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.product || depth0.product, stack1 ? stack1.call(depth0, "g2ac_customer", options) : helperMissing.call(depth0, "product", "g2ac_customer", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n        ";
                        return buffer;
                    }
                    function program8(depth0, data) {
                        return "\n                 <br/>\n            ";
                    }
                    function program10(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": "<strong>",
                                "1": "</strong>",
                                "2": "launching.app.ingress.firefox"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n    ";
                        return buffer;
                    }
                    function program12(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": depth0.manualRestartDownloadLinkStart,
                                "2": depth0.linkEnd,
                                "3": depth0.appLaunchLinkStart,
                                "4": depth0.linkEnd
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.fallback.tryagain", options) : helperMissing.call(depth0, "fmt", "installer.fallback.tryagain", options))) + "\n    ";
                        return buffer;
                    }
                    function program14(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": depth0.manualRestartDownloadLinkStart,
                                "2": depth0.linkEnd,
                                "3": depth0.appLaunchLinkStart,
                                "4": depth0.linkEnd
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.fallback.tryagain", options) : helperMissing.call(depth0, "fmt", "launching.app.fallback.tryagain", options))) + "\n    ";
                        return buffer;
                    }
                    buffer += "\n";
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(3, program3, data),
                        fn: self.program(1, program1, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += '\n<p class="instructions-head-description">\n';
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(5, program5, data),
                        data: data
                    };
                    if (stack2 = helpers["switch"]) {
                        stack2 = stack2.call(depth0, options);
                    } else {
                        stack2 = depth0["switch"];
                        stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                    }
                    if (!helpers["switch"]) {
                        stack2 = blockHelperMissing.call(depth0, stack2, options);
                    }
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n<span>\n    ";
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(14, program14, data),
                        fn: self.program(12, program12, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n</span>\n</p>\n";
                    return buffer;
                }),
                "DOWNLOADING.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
                    function program1(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(2, program2, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.apiVersion || depth0.apiVersion, stack1 ? stack1.call(depth0, 2, options) : helperMissing.call(depth0, "apiVersion", 2, options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(7, program7, data),
                            data: data
                        };
                        if (stack2 = helpers["default"]) {
                            stack2 = stack2.call(depth0, options);
                        } else {
                            stack2 = depth0["default"];
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        if (!helpers["default"]) {
                            stack2 = blockHelperMissing.call(depth0, stack2, options);
                        }
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    ";
                        return buffer;
                    }
                    function program2(depth0, data) {
                        var buffer = "", stack1, stack2;
                        buffer += "\n            ";
                        stack2 = helpers["if"].call(depth0, (stack1 = (stack1 = depth0.userAgent, stack1 == null || stack1 === false ? stack1 : stack1.is), 
                        stack1 == null || stack1 === false ? stack1 : stack1.WINDOWS), {
                            hash: {},
                            inverse: self.program(5, program5, data),
                            fn: self.program(3, program3, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n        ";
                        return buffer;
                    }
                    function program3(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n                " + "\n                ";
                        options = {
                            hash: {
                                "0": depth0.appFileNameBase
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.run.product.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.run.product.h", options))) + "\n            ";
                        return buffer;
                    }
                    function program5(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n                ";
                        options = {
                            hash: {
                                "0": depth0.appFileNameBase
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.open.product.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.open.product.h", options))) + "\n            ";
                        return buffer;
                    }
                    function program7(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n            " + "\n            ";
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.h", options))) + "\n        ";
                        return buffer;
                    }
                    function program9(depth0, data) {
                        var stack1, stack2, options;
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(10, program10, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "MSIE", options) : helperMissing.call(depth0, "browser", "MSIE", options));
                        if (stack2 || stack2 === 0) {
                            return stack2;
                        } else {
                            return "";
                        }
                    }
                    function program10(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "<br />";
                        options = {
                            hash: {
                                "0": depth0.appLaunchLinkStart,
                                "1": depth0.linkEnd
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.ingress.trylaunch", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.ingress.trylaunch", options)));
                        return buffer;
                    }
                    buffer += '\n<h1 class="instructions-head-title">\n    ';
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(1, program1, data),
                        data: data
                    };
                    if (stack1 = helpers["switch"]) {
                        stack1 = stack1.call(depth0, options);
                    } else {
                        stack1 = depth0["switch"];
                        stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                    }
                    if (!helpers["switch"]) {
                        stack1 = blockHelperMissing.call(depth0, stack1, options);
                    }
                    if (stack1 || stack1 === 0) {
                        buffer += stack1;
                    }
                    buffer += '\n</h1>\n<p class="instructions-head-description">';
                    options = {
                        hash: {
                            "0": depth0.manualRestartDownloadLinkStart,
                            "1": depth0.linkEnd
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.ingress.restart", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.ingress.restart", options)));
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(9, program9, data),
                        data: data
                    };
                    if (stack2 = helpers["switch"]) {
                        stack2 = stack2.call(depth0, options);
                    } else {
                        stack2 = depth0["switch"];
                        stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                    }
                    if (!helpers["switch"]) {
                        stack2 = blockHelperMissing.call(depth0, stack2, options);
                    }
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "</p>";
                    return buffer;
                }),
                "CLICKONCE.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function";
                    function program1(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": "<strong>",
                                "2": "</strong>",
                                "3": "<strong>",
                                "4": "</strong>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.clickonce.ingress", options) : helperMissing.call(depth0, "fmt", "installer.plugin.clickonce.ingress", options))) + "\n    ";
                        return buffer;
                    }
                    function program3(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": "<strong>",
                                "2": "</strong>",
                                "3": "<strong>",
                                "4": "</strong>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.clickonce.ingress", options) : helperMissing.call(depth0, "fmt", "download.plugin.clickonce.ingress", options))) + "\n    ";
                        return buffer;
                    }
                    function program5(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n                    ";
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.clickonce.h", options) : helperMissing.call(depth0, "fmt", "installer.plugin.clickonce.h", options))) + "\n                ";
                        return buffer;
                    }
                    function program7(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n                    ";
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.clickonce.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.clickonce.h", options))) + "\n                ";
                        return buffer;
                    }
                    function program9(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n                ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": depth0.manualRestartDownloadLinkStart,
                                "2": "</a>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.app.fallback", options) : helperMissing.call(depth0, "fmt", "installer.app.fallback", options))) + "\n            ";
                        return buffer;
                    }
                    function program11(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n                ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": depth0.manualRestartDownloadLinkStart,
                                "2": "</a>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.fallback", options) : helperMissing.call(depth0, "fmt", "launching.app.fallback", options))) + "\n            ";
                        return buffer;
                    }
                    buffer += '\n\n<p class="launcher-instructions-head-first">\n    ';
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(3, program3, data),
                        fn: self.program(1, program1, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += '\n</p>\n<a id="launcher-clickonce-button" href="';
                    if (stack2 = helpers.clickOnceUrl) {
                        stack2 = stack2.call(depth0, {
                            hash: {},
                            data: data
                        });
                    } else {
                        stack2 = depth0.clickOnceUrl;
                        stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                    }
                    buffer += escapeExpression(stack2) + '" class="colorglow dark-blue large">\n    <div class="btn-bg">\n            <span>\n                ';
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(7, program7, data),
                        fn: self.program(5, program5, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += '\n            </span>\n    </div>\n</a>\n<p class="instructions-head-description clickonce-launch-info">\n        <span>\n            ';
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(11, program11, data),
                        fn: self.program(9, program9, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n        </span>\n</p>\n\n";
                    return buffer;
                }),
                "LAUNCHED_APP.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function";
                    function program1(depth0, data) {
                        var buffer = "", stack1, stack2;
                        buffer += "\n        ";
                        stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isSilent), {
                            hash: {},
                            inverse: self.program(4, program4, data),
                            fn: self.program(2, program2, data),
                            data: data
                        });
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    ";
                        return buffer;
                    }
                    function program2(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n            ";
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.installer.app.silent.h", options) : helperMissing.call(depth0, "fmt", "download.installer.app.silent.h", options))) + "\n        ";
                        return buffer;
                    }
                    function program4(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n            ";
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.installer.app.h", options) : helperMissing.call(depth0, "fmt", "download.installer.app.h", options))) + "\n        ";
                        return buffer;
                    }
                    function program6(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launched.app.h", options) : helperMissing.call(depth0, "fmt", "launched.app.h", options))) + "\n    ";
                        return buffer;
                    }
                    function program8(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.launched.app.ingress", options) : helperMissing.call(depth0, "fmt", "installer.launched.app.ingress", options))) + "\n    ";
                        return buffer;
                    }
                    function program10(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launched.app.ingress", options) : helperMissing.call(depth0, "fmt", "launched.app.ingress", options))) + "\n    ";
                        return buffer;
                    }
                    function program12(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n            ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": depth0.manualRestartDownloadLinkStart,
                                "2": depth0.linkEnd
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.app.fallback", options) : helperMissing.call(depth0, "fmt", "installer.app.fallback", options))) + "\n        ";
                        return buffer;
                    }
                    function program14(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n            ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": depth0.manualRestartDownloadLinkStart,
                                "2": depth0.linkEnd
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.fallback", options) : helperMissing.call(depth0, "fmt", "launching.app.fallback", options))) + "\n        ";
                        return buffer;
                    }
                    buffer += '\n\n<h1 class="instructions-head-title">\n    ';
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(6, program6, data),
                        fn: self.program(1, program1, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += '\n    <img src="';
                    if (stack2 = helpers.throbberUrl) {
                        stack2 = stack2.call(depth0, {
                            hash: {},
                            data: data
                        });
                    } else {
                        stack2 = depth0.throbberUrl;
                        stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                    }
                    buffer += escapeExpression(stack2) + '" alt="" width=16 height=16>\n</h1>\n\n<p class="instructions-head-description">\n    ';
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(10, program10, data),
                        fn: self.program(8, program8, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n    <span>\n        ";
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(14, program14, data),
                        fn: self.program(12, program12, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n\n    </span>\n</p>";
                    return buffer;
                }),
                "TRY_LAUNCHING_APP.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
                    function program1(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n            ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(2, program2, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n            ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(4, program4, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "SAFARI", options) : helperMissing.call(depth0, "browser", "SAFARI", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n            ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(6, program6, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n        ";
                        return buffer;
                    }
                    function program2(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n                ";
                        options = {
                            hash: {
                                "0": "<strong>",
                                "1": "</strong>",
                                "2": "launching.app.ingress.firefox"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n            ";
                        return buffer;
                    }
                    function program4(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n                ";
                        options = {
                            hash: {
                                "0": "<strong>",
                                "1": "</strong>",
                                "2": "launching.app.ingress.safari"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n            ";
                        return buffer;
                    }
                    function program6(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n                ";
                        options = {
                            hash: {
                                "0": "<strong>",
                                "1": "</strong>",
                                "2": "launching.app.ingress.chrome"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n            ";
                        return buffer;
                    }
                    buffer += '\n\n<h1 class="instructions-head-title">\n    ';
                    options = {
                        hash: {
                            "0": depth0.productName
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "trylaunching.app.h", options) : helperMissing.call(depth0, "fmt", "trylaunching.app.h", options))) + '\n</h1>\n\n<div class="instructions-head-description">\n    <p>\n        ';
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(1, program1, data),
                        data: data
                    };
                    if (stack2 = helpers["switch"]) {
                        stack2 = stack2.call(depth0, options);
                    } else {
                        stack2 = depth0["switch"];
                        stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                    }
                    if (!helpers["switch"]) {
                        stack2 = blockHelperMissing.call(depth0, stack2, options);
                    }
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n    </p>\n    <br />\n    <p>\n        <strong>\n            ";
                    options = {
                        hash: {
                            "0": depth0.productName,
                            "1": depth0.manualDownloadLinkStart,
                            "2": depth0.linkEnd
                        },
                        data: data
                    };
                    buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "trylaunching.app.fallback", options) : helperMissing.call(depth0, "fmt", "trylaunching.app.fallback", options))) + "\n        </strong>\n    </p>\n</div>\n";
                    return buffer;
                }),
                "LAUNCH_BY_CLICK.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, options, helperMissing = helpers.helperMissing, escapeExpression = this.escapeExpression, self = this, functionType = "function", blockHelperMissing = helpers.blockHelperMissing;
                    function program1(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        <span>";
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.plugin.clickonce.h", options) : helperMissing.call(depth0, "fmt", "installer.plugin.clickonce.h", options))) + "</span>\n    ";
                        return buffer;
                    }
                    function program3(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        <span>";
                        options = {
                            hash: {
                                "0": depth0.productName
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.clickonce.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.clickonce.h", options))) + "</span>\n    ";
                        return buffer;
                    }
                    function program5(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(6, program6, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(6, program6, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "OPERA", options) : helperMissing.call(depth0, "browser", "OPERA", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(8, program8, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    ";
                        return buffer;
                    }
                    function program6(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n            ";
                        options = {
                            hash: {
                                "0": "<strong>",
                                "1": "</strong>",
                                "2": "launching.app.ingress.chrome"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n        ";
                        return buffer;
                    }
                    function program8(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n            ";
                        options = {
                            hash: {
                                "0": "<strong>",
                                "1": "</strong>",
                                "2": "launching.app.ingress.firefox"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.ingress", options) : helperMissing.call(depth0, "fmt", "launching.app.ingress", options))) + "\n        ";
                        return buffer;
                    }
                    function program10(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": depth0.manualRestartDownloadLinkStart,
                                "2": "</a>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "installer.app.fallback", options) : helperMissing.call(depth0, "fmt", "installer.app.fallback", options))) + "\n    ";
                        return buffer;
                    }
                    function program12(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n        ";
                        options = {
                            hash: {
                                "0": depth0.productName,
                                "1": depth0.manualRestartDownloadLinkStart,
                                "2": "</a>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launching.app.fallback", options) : helperMissing.call(depth0, "fmt", "launching.app.fallback", options))) + "\n    ";
                        return buffer;
                    }
                    buffer += '\n<div class="launcher-launch-by-click-button">\n<a class="launcher-launch-hook launcher-colorglow dark-blue large" href="';
                    if (stack1 = helpers.appLaunchUrl) {
                        stack1 = stack1.call(depth0, {
                            hash: {},
                            data: data
                        });
                    } else {
                        stack1 = depth0.appLaunchUrl;
                        stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                    }
                    if (stack1 || stack1 === 0) {
                        buffer += stack1;
                    }
                    buffer += '">\n    <div class="btn-bg">\n    ';
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(3, program3, data),
                        fn: self.program(1, program1, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += '\n    </div>\n</a>\n</div>\n<p class="instructions-head-description clickonce-launch-info">\n    ';
                    options = {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(5, program5, data),
                        data: data
                    };
                    if (stack2 = helpers["switch"]) {
                        stack2 = stack2.call(depth0, options);
                    } else {
                        stack2 = depth0["switch"];
                        stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                    }
                    if (!helpers["switch"]) {
                        stack2 = blockHelperMissing.call(depth0, stack2, options);
                    }
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n    ";
                    stack2 = helpers["if"].call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.program(12, program12, data),
                        fn: self.program(10, program10, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    buffer += "\n</p>\n\n";
                    return buffer;
                })
            },
            main: {
                "LAUNCHING_APP.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, stack2, functionType = "function", escapeExpression = this.escapeExpression, self = this, helperMissing = helpers.helperMissing, blockHelperMissing = helpers.blockHelperMissing;
                    function program1(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n    ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(2, program2, data),
                            data: data
                        };
                        if (stack1 = helpers["switch"]) {
                            stack1 = stack1.call(depth0, options);
                        } else {
                            stack1 = depth0["switch"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        if (!helpers["switch"]) {
                            stack1 = blockHelperMissing.call(depth0, stack1, options);
                        }
                        if (stack1 || stack1 === 0) {
                            buffer += stack1;
                        }
                        buffer += "\n";
                        return buffer;
                    }
                    function program2(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(3, program3, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(9, program9, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "CHROME", options) : helperMissing.call(depth0, "browser", "CHROME", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    ";
                        return buffer;
                    }
                    function program3(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += '\n            <div id="launch-instructions" class="instructions-main-container clearfix">\n                ';
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(4, program4, data),
                            data: data
                        };
                        if (stack1 = helpers["switch"]) {
                            stack1 = stack1.call(depth0, options);
                        } else {
                            stack1 = depth0["switch"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        if (!helpers["switch"]) {
                            stack1 = blockHelperMissing.call(depth0, stack1, options);
                        }
                        if (stack1 || stack1 === 0) {
                            buffer += stack1;
                        }
                        buffer += '\n\n                <div class="instructions-main-panel">\n                    <h3 class="instructions-main-title">';
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.instructions.h", options) : helperMissing.call(depth0, "fmt", "launch.instructions.h", options))) + '</h3>\n\n                    <p class="instructions-main-description">\n                        <span>';
                        options = {
                            hash: {
                                "0": "<strong>",
                                "1": "</strong>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.instructions.checkBoxToSkipMessageHint", options) : helperMissing.call(depth0, "fmt", "launch.instructions.checkBoxToSkipMessageHint", options))) + "</span>\n                    </p>\n                </div>\n\n            </div>\n        ";
                        return buffer;
                    }
                    function program4(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n                    ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(5, program5, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "MACOS", options) : helperMissing.call(depth0, "platform", "MACOS", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n                    ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(7, program7, data),
                            data: data
                        };
                        if (stack2 = helpers["default"]) {
                            stack2 = stack2.call(depth0, options);
                        } else {
                            stack2 = depth0["default"];
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        if (!helpers["default"]) {
                            stack2 = blockHelperMissing.call(depth0, stack2, options);
                        }
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n                ";
                        return buffer;
                    }
                    function program5(depth0, data) {
                        var buffer = "", stack1;
                        buffer += '\n                        <img class="instructions-main-image launcher-launch-hook"\n                             src="';
                        if (stack1 = helpers["static"]) {
                            stack1 = stack1.call(depth0, {
                                hash: {},
                                data: data
                            });
                        } else {
                            stack1 = depth0["static"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        buffer += escapeExpression(stack1) + '/images/launch-instructions/firefox-osx.png" alt="">\n                    ';
                        return buffer;
                    }
                    function program7(depth0, data) {
                        var buffer = "", stack1;
                        buffer += '\n                        <img class="instructions-main-image launcher-launch-hook"\n                             src="';
                        if (stack1 = helpers["static"]) {
                            stack1 = stack1.call(depth0, {
                                hash: {},
                                data: data
                            });
                        } else {
                            stack1 = depth0["static"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        buffer += escapeExpression(stack1) + '/images/launch-instructions/firefox-win.png" alt="">\n                    ';
                        return buffer;
                    }
                    function program9(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += '\n            <div id="launch-instructions" class="instructions-main-container clearfix">\n                ';
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(10, program10, data),
                            data: data
                        };
                        if (stack1 = helpers["switch"]) {
                            stack1 = stack1.call(depth0, options);
                        } else {
                            stack1 = depth0["switch"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        if (!helpers["switch"]) {
                            stack1 = blockHelperMissing.call(depth0, stack1, options);
                        }
                        if (stack1 || stack1 === 0) {
                            buffer += stack1;
                        }
                        buffer += '\n\n                <div class="instructions-main-panel">\n                    <h3 class="instructions-main-title">';
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.instructions.h", options) : helperMissing.call(depth0, "fmt", "launch.instructions.h", options))) + '</h3>\n\n                    <p class="instructions-main-description">\n                        <span>';
                        options = {
                            hash: {
                                "0": "<strong>",
                                "1": "</strong>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "launch.instructions.checkBoxToSkipMessageHint", options) : helperMissing.call(depth0, "fmt", "launch.instructions.checkBoxToSkipMessageHint", options))) + "</span>\n                    </p>\n                </div>\n\n            </div>\n        ";
                        return buffer;
                    }
                    function program10(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n                    ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(11, program11, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "MACOS", options) : helperMissing.call(depth0, "platform", "MACOS", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n                    ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(13, program13, data),
                            data: data
                        };
                        if (stack2 = helpers["default"]) {
                            stack2 = stack2.call(depth0, options);
                        } else {
                            stack2 = depth0["default"];
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        if (!helpers["default"]) {
                            stack2 = blockHelperMissing.call(depth0, stack2, options);
                        }
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n                ";
                        return buffer;
                    }
                    function program11(depth0, data) {
                        var buffer = "", stack1;
                        buffer += '\n                        <img class="instructions-main-image launcher-launch-hook"\n                             src="';
                        if (stack1 = helpers["static"]) {
                            stack1 = stack1.call(depth0, {
                                hash: {},
                                data: data
                            });
                        } else {
                            stack1 = depth0["static"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        buffer += escapeExpression(stack1) + '/images/launch-instructions/chrome-osx.png" alt="">\n                    ';
                        return buffer;
                    }
                    function program13(depth0, data) {
                        var buffer = "", stack1;
                        buffer += '\n                        <img class="instructions-main-image launcher-launch-hook"\n                             src="';
                        if (stack1 = helpers["static"]) {
                            stack1 = stack1.call(depth0, {
                                hash: {},
                                data: data
                            });
                        } else {
                            stack1 = depth0["static"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        buffer += escapeExpression(stack1) + '/images/launch-instructions/chrome-win.png" alt="">\n                    ';
                        return buffer;
                    }
                    buffer += "\n";
                    stack2 = helpers.unless.call(depth0, (stack1 = depth0.textScheme, stack1 == null || stack1 === false ? stack1 : stack1.isInstaller), {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(1, program1, data),
                        data: data
                    });
                    if (stack2 || stack2 === 0) {
                        buffer += stack2;
                    }
                    return buffer;
                }),
                "DOWNLOADING.hbs": template(function(Handlebars, depth0, helpers, partials, data) {
                    this.compilerInfo = [ 4, ">= 1.0.0" ];
                    helpers = this.merge(helpers, Handlebars.helpers);
                    data = data || {};
                    var buffer = "", stack1, functionType = "function", escapeExpression = this.escapeExpression, helperMissing = helpers.helperMissing, self = this, blockHelperMissing = helpers.blockHelperMissing;
                    function program1(depth0, data) {
                        var buffer = "", stack1;
                        buffer += " " + "\n";
                        stack1 = helpers.unless.call(depth0, depth0.renameFile, {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(2, program2, data),
                            data: data
                        });
                        if (stack1 || stack1 === 0) {
                            buffer += stack1;
                        }
                        buffer += "\n";
                        return buffer;
                    }
                    function program2(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += " " + "\n    ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(3, program3, data),
                            data: data
                        };
                        if (stack1 = helpers["switch"]) {
                            stack1 = stack1.call(depth0, options);
                        } else {
                            stack1 = depth0["switch"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        if (!helpers["switch"]) {
                            stack1 = blockHelperMissing.call(depth0, stack1, options);
                        }
                        if (stack1 || stack1 === 0) {
                            buffer += stack1;
                        }
                        buffer += "\n";
                        return buffer;
                    }
                    function program3(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n        ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(4, program4, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.platform || depth0.platform, stack1 ? stack1.call(depth0, "MACOS", options) : helperMissing.call(depth0, "platform", "MACOS", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n    ";
                        return buffer;
                    }
                    function program4(depth0, data) {
                        var buffer = "", stack1, options;
                        buffer += "\n            ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(5, program5, data),
                            data: data
                        };
                        if (stack1 = helpers["switch"]) {
                            stack1 = stack1.call(depth0, options);
                        } else {
                            stack1 = depth0["switch"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        if (!helpers["switch"]) {
                            stack1 = blockHelperMissing.call(depth0, stack1, options);
                        }
                        if (stack1 || stack1 === 0) {
                            buffer += stack1;
                        }
                        buffer += "\n        ";
                        return buffer;
                    }
                    function program5(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += "\n                ";
                        options = {
                            hash: {},
                            inverse: self.noop,
                            fn: self.program(6, program6, data),
                            data: data
                        };
                        stack2 = (stack1 = helpers.browser || depth0.browser, stack1 ? stack1.call(depth0, "FIREFOX", options) : helperMissing.call(depth0, "browser", "FIREFOX", options));
                        if (stack2 || stack2 === 0) {
                            buffer += stack2;
                        }
                        buffer += "\n            ";
                        return buffer;
                    }
                    function program6(depth0, data) {
                        var buffer = "", stack1, stack2, options;
                        buffer += '\n                    <div class="launcher-instructions-two-columns launcher-instructions-first-column">\n                        <img src="';
                        if (stack1 = helpers["static"]) {
                            stack1 = stack1.call(depth0, {
                                hash: {},
                                data: data
                            });
                        } else {
                            stack1 = depth0["static"];
                            stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1;
                        }
                        buffer += escapeExpression(stack1) + '/images/download-steps/ff-dmg-1.png" alt="">\n                        <div class="launcher-instructions-two-columns-text">\n                            <h2>';
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.open.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.open.h", options))) + "</h2>\n                            <p>";
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.open.firefoxmac", options) : helperMissing.call(depth0, "fmt", "download.instructions.open.firefoxmac", options))) + '</p>\n                        </div>\n                    </div>\n                    <div class="launcher-instructions-two-columns launcher-instructions-second-column">\n                        <img src="';
                        if (stack2 = helpers["static"]) {
                            stack2 = stack2.call(depth0, {
                                hash: {},
                                data: data
                            });
                        } else {
                            stack2 = depth0["static"];
                            stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
                        }
                        buffer += escapeExpression(stack2) + '/images/download-steps/ff-dmg-2.png" alt="">\n                        <div class="launcher-instructions-two-columns-text">\n                            <h2>';
                        options = {
                            hash: {},
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.plugin.download.run.h", options) : helperMissing.call(depth0, "fmt", "download.plugin.download.run.h", options))) + "</h2>\n                            <p>";
                        options = {
                            hash: {
                                "0": "GoTo Opener",
                                "1": "<strong>",
                                "2": "</strong>"
                            },
                            data: data
                        };
                        buffer += escapeExpression((stack1 = helpers.fmt || depth0.fmt, stack1 ? stack1.call(depth0, "download.instructions.run.dmg.mac", options) : helperMissing.call(depth0, "fmt", "download.instructions.run.dmg.mac", options))) + "</p>\n                        </div>\n                    </div>\n                ";
                        return buffer;
                    }
                    buffer += "\n";
                    stack1 = helpers.unless.call(depth0, depth0.hasBanner, {
                        hash: {},
                        inverse: self.noop,
                        fn: self.program(1, program1, data),
                        data: data
                    });
                    if (stack1 || stack1 === 0) {
                        buffer += stack1;
                    }
                    buffer += "\n\n";
                    return buffer;
                })
            }
        }
    };
});
define("handlebars-switch-helpers", [ "assert", "launch-model" ], function(assert, model) {
    "use strict";
    return function makeSwitchHelper() {
        var contextStack = [];
        function assertCase(calledName, correctNumberOfArguments) {
            assert("launcher.js handlebars-switch-helpers: Expected context for " + calledName + ". Did you forget a switch statment?", contextStack[0]);
            assert("launcher.js handlebars-switch-helpers: Already used default branch for " + calledName + ". Please move the branch before the default.", !contextStack[0].defaulted);
            assert("launcher.js handlebars-switch-helpers: Wrong number of arguments for " + calledName, correctNumberOfArguments);
        }
        return {
            "switch": function switchHelper(hb_opts) {
                contextStack.unshift({
                    defaulted: false,
                    branched: false
                });
                var result = hb_opts.fn(this);
                contextStack.shift();
                return result;
            },
            "default": function defaultCase(hb_opts) {
                assertCase("default", arguments.length === 1);
                contextStack[0].defaulted = true;
                if (contextStack[0].branched) {
                    return hb_opts.inverse(this);
                } else {
                    contextStack[0].branched = true;
                    return hb_opts.fn(this);
                }
            },
            browser: function browserCase(name, majorVersion, hb_opts) {
                assertCase("browserCase", arguments.length === 2 || arguments.length === 3);
                if (!hb_opts) {
                    hb_opts = majorVersion;
                    majorVersion = 0;
                }
                if (!contextStack[0].branched && model.userAgent().browser === name && (!majorVersion || model.userAgent().browserVersion >= majorVersion)) {
                    contextStack[0].branched = true;
                    return hb_opts.fn(this);
                } else {
                    return hb_opts.inverse(this);
                }
            },
            platform: function platformCase(name, hb_opts) {
                assertCase("platform", arguments.length === 2);
                if (!contextStack[0].branched && model.userAgent().platform === name) {
                    contextStack[0].branched = true;
                    return hb_opts.fn(this);
                } else {
                    return hb_opts.inverse(this);
                }
            },
            apiVersion: function apiVersionCase(version, hb_opts) {
                assertCase("apiVersion", arguments.length === 2);
                version = parseInt(version, 10);
                assert("launcher.js handlebars-switch-helpers: Expected apiVersion to be a number > 0", version > 0);
                if (!contextStack[0].branched && model.apiVersion() >= version) {
                    contextStack[0].branched = true;
                    return hb_opts.fn(this);
                } else {
                    return hb_opts.inverse(this);
                }
            },
            abTest: function abTestCase(abTestSet, abTestCandidate, hb_opts) {
                assertCase("abTest", arguments.length === 3);
                if (!contextStack[0].branched && model.abTest() && model.abTest()[abTestSet] === abTestCandidate) {
                    contextStack[0].branched = true;
                    return hb_opts.fn(this);
                } else {
                    return hb_opts.inverse(this);
                }
            },
            product: function productCase(product, hb_opts) {
                assertCase("product", arguments.length === 2);
                if (!contextStack[0].branched && model.product() && model.product() === product) {
                    contextStack[0].branched = true;
                    return hb_opts.fn(this);
                } else {
                    return hb_opts.inverse(this);
                }
            }
        };
    };
});
define("ui-qa", ['require','jquery','safety','util','launch-model','console','user-agent-parser'],function(require) {
    "use strict";
    var $ = require("jquery"), safety = require("safety"), util = require("util"), model = require("launch-model"), console = require("console"), userAgentParser = require("user-agent-parser");
    var variants = {
        DOWNLOADING: [ {
            browser: "FIREFOX",
            platform: "WINDOWS"
        }, {
            browser: "CHROME",
            platform: "WINDOWS"
        }, {
            browser: "MSIE",
            platform: "WINDOWS",
            browserVersion: 9
        }, {
            browser: "MSIE",
            platform: "WINDOWS",
            browserVersion: 8
        }, {
            browser: "SAFARI",
            platform: "MACOS"
        }, {
            browser: "SAFARI",
            platform: "MACOS",
            browserVersion: 6
        }, {
            browser: "FIREFOX",
            platform: "MACOS"
        }, {
            browser: "CHROME",
            platform: "MACOS"
        }, {
            browser: "UNKNOWN",
            platform: "MACOS"
        } ],
        LAUNCHING_APP: [ {
            browser: "CHROME",
            platform: "WINDOWS"
        }, {
            browser: "CHROME",
            platform: "MACOS"
        }, {
            browser: "UNKNOWN"
        } ],
        TRY_LAUNCHING_APP: [ {
            browser: "FIREFOX",
            platform: "WINDOWS"
        }, {
            browser: "FIREFOX",
            platform: "MACOS"
        } ],
        LAUNCH_BY_CLICK: [ {
            browser: "CHROME",
            platform: "WINDOWS"
        }, {
            browser: "CHROME",
            platform: "MACOS"
        } ]
    }, instructions = util.keys(model.INSTRUCTION).concat(util.keys(model.STATE)), instructionCounter = -1, variantCounter = 0;
    function setInstruction(instruction) {
        model.joinInstruction(null);
        model.joinState(null);
        if (model.INSTRUCTION[instruction]) {
            model.joinInstruction(instruction);
        } else if (model.STATE[instruction]) {
            model.joinState(instruction);
        }
    }
    function qa(options) {
        model.options = $.extend({
            token: "g2m",
            product: "g2m",
            apiVersion: 1,
            locale: "en",
            host: safety.launcherJsHost || window.location.host,
            protocol: safety.launcherJsProtocol || window.location.protocol,
            userAgent: {
                is: {}
            }
        }, model.options, options);
        var currentInstruction = instructions[instructionCounter], currentVariants = variants[currentInstruction], currentVariant;
        if (currentVariants && variantCounter + 1 < currentVariants.length) {
            variantCounter += 1;
        } else {
            instructionCounter += 1;
            variantCounter = 0;
        }
        if (instructionCounter >= instructions.length) {
            instructionCounter = -1;
        }
        currentInstruction = instructions[instructionCounter];
        currentVariants = variants[currentInstruction];
        currentVariant = currentVariants && currentVariants[variantCounter];
        if (currentVariant) {
            console.log("launcher.js: ui-qa: Setting variant to ", currentVariant.platform, currentVariant.browser, currentVariant.browserVersion, "for", currentInstruction);
            model.userAgent().platform = currentVariant.platform;
            model.userAgent().browser = currentVariant.browser;
            model.userAgent().browserVersion = currentVariant.browserVersion;
            model.userAgent(userAgentParser.augment(model.userAgent()));
        } else {
            console.log("launcher.js: ui-qa: No Variants defined for", currentInstruction);
        }
        if (currentInstruction === model.INSTRUCTION.LAUNCHING_EP) {
            qa();
        } else {
            setInstruction(currentInstruction);
        }
    }
    qa.reset = function() {
        instructionCounter = -1;
        variantCounter = 0;
        model.joinInstruction(null);
        model.joinState(null);
    };
    qa.variants = variants;
    return qa;
});
define("ui", ['require','jquery','third-party/observable','handlebars','launch-model','urls','templates','strings','assert','handlebars-switch-helpers','ui-qa','util','third-party/q'],function(require) {
    "use strict";
    var $ = require("jquery"), obs = require("third-party/observable"), Handlebars = require("handlebars"), model = require("launch-model"), urls = require("urls"), templates = require("templates"), localizedStrings = require("strings"), assert = require("assert"), makeSwitchHelpers = require("handlebars-switch-helpers"), uiQa = require("ui-qa"), util = require("util"), q = require("third-party/q"), textScheme = {
        LAUNCH: {
            isInstaller: false,
            isSilent: false
        },
        WIZARD_INSTALL: {
            isInstaller: true,
            isSilent: false
        },
        SILENT_INSTALL: {
            isInstaller: true,
            isSilent: true
        }
    }, products = {
        col: {
            name: "GoTo",
            textScheme: textScheme.LAUNCH
        },
        g2m: {
            name: "GoTo Meeting",
            textScheme: textScheme.LAUNCH
        },
        g2m_install: {
            name: "GoTo Meeting",
            textScheme: textScheme.SILENT_INSTALL
        },
        g2mv9: {
            name: "GoTo Meeting",
            textScheme: textScheme.LAUNCH
        },
        g2t: {
            name: "GoTo Training",
            textScheme: textScheme.LAUNCH
        },
        g2w: {
            name: "GoTo Webinar",
            textScheme: textScheme.LAUNCH
        },
        g2p_host: {
            name: "GoTo MyPC",
            textScheme: textScheme.WIZARD_INSTALL
        },
        g2p_viewer: {
            name: "GoTo MyPC",
            textScheme: textScheme.LAUNCH
        },
        g2ac_customer: {
            name: "GoTo Assist Corporate",
            textScheme: textScheme.LAUNCH
        },
        g2ac_replayapp: {
            name: "GoTo Assist Replay",
            textScheme: textScheme.LAUNCH
        },
        g2ax_customer: {
            name: "GoTo Assist",
            textScheme: textScheme.LAUNCH
        },
        g2ars_customer: {
            name: "GoTo Assist",
            textScheme: textScheme.LAUNCH
        },
        g2a_seeit: {
            name: "GoTo Assist Seeit",
            textScheme: textScheme.LAUNCH
        },
        g2ax_expert: {
            name: "GoTo Assist",
            textScheme: textScheme.LAUNCH
        }
    }, usedStrings = {};
    function renderTemplate(template) {
        var locale = model.locale(), userAgent = model.userAgent(), renameFile = urls.shouldRenameFile(), appFileNameBase, staticBase = urls.staticResource(""), imgArrowAltText = Handlebars.SafeString(localizedStrings[locale]["download.instructions.animated.alttext"]);
        var product = products[model.product()] || products.col;
        if (urls.isMacDMG() === true) {
            appFileNameBase = "GoTo Opener";
        } else {
            var fileProductTextPart = "GoTo";
            if (renameFile) {
                fileProductTextPart = product.name;
            }
            var fileActionTextPart = "Opener";
            if (product.textScheme.isInstaller) {
                fileActionTextPart = "Installer";
            }
            appFileNameBase = fileProductTextPart + " " + fileActionTextPart;
        }
        return template({
            userAgent: userAgent,
            renameFile: renameFile,
            productName: product.name,
            textScheme: product.textScheme,
            manualRestartDownloadLinkStart: '<a class="launcher-manual-download-hook" href="' + urls.appDownload("restart") + '">',
            manualDownloadLinkStart: '<a class="launcher-manual-download-hook" href="' + urls.appDownload("manual-download") + '">',
            appLaunchUrl: urls.appLaunch("click"),
            appLaunchLinkStart: '<a class="launcher-launch-hook" href="' + urls.appLaunch("click") + '">',
            linkEnd: "</a>",
            clickOnceUrl: urls.clickOnce(),
            throbberUrl: urls.staticResource("/images/throbber.gif"),
            "static": staticBase,
            appFileNameBase: appFileNameBase,
            hasBanner: util.hasBanner(),
            imgFirefoxUpArrow: '<img src="' + staticBase + '/images/download-icons.svg" alt="' + imgArrowAltText + '" width="22"/>',
            imgSafariUpArrow: '<img src="' + staticBase + '/images/safariDwArrow.png" alt="' + imgArrowAltText + '" width=38 height=23/>'
        }, {
            helpers: $.extend(makeSwitchHelpers(userAgent), {
                fmt: function format(msgKey, hb_opts) {
                    var msg = localizedStrings[locale][msgKey];
                    if (!msg && msg !== "") {
                        throw "fmt: unknown message for locale " + locale + ": " + msgKey;
                    }
                    usedStrings[msgKey] = true;
                    return new Handlebars.SafeString(Handlebars.Utils.escapeExpression(msg).replace(/__(\d+)__/g, function(match, key) {
                        if (!hb_opts.hash.hasOwnProperty(key)) {
                            throw "fmt: key not provided: __" + key + "__ in: " + msg;
                        }
                        var text = hb_opts.hash[key];
                        var submsg = localizedStrings[locale][text];
                        if (!submsg && submsg !== "") {
                            return text;
                        }
                        return submsg;
                    }));
                },
                ifHasText: function ifHasText(msgKey, hb_opts) {
                    if (localizedStrings[locale][msgKey]) {
                        return hb_opts.fn(this);
                    }
                    return hb_opts.inverse(this);
                }
            })
        });
    }
    function renderTemplateByPosition(position, propertyName, propertyValue) {
        assert("launcher.js: renderTemplateByPosition: Expected position", position);
        assert("launcher.js: renderTemplateByPosition: Expected propertyName", propertyName);
        if (!propertyValue) {
            propertyValue = model[propertyName]();
        }
        if ("joinInstruction" === propertyName && propertyValue === "LAUNCHING_EP") {
            propertyValue = "DOWNLOADING";
        } else if (position === "main" && "joinInstruction" === propertyName && propertyValue === "LAUNCH_BY_CLICK") {
            propertyValue = "LAUNCHING_APP";
        }
        var templateFilename = propertyValue + ".hbs";
        var template = templates[propertyName] && templates[propertyName][position] && templates[propertyName][position][templateFilename];
        if (!template) {
            return "";
        }
        return renderTemplate(template);
    }
    function renderTemplateByName(templateName) {
        var template = templates[templateName + ".hbs"];
        assert("launch.js: renderTemplateByName: Expected template to exist: " + templateName, template);
        return renderTemplate(template);
    }
    function makeRenderFunc(position, propertyName) {
        return function(propertyValue) {
            return renderTemplateByPosition(position, propertyName, propertyValue);
        };
    }
    function makeComputed(position) {
        return obs.computed(function() {
            var state = model.joinState(), instruction = model.joinInstruction();
            if (state) {
                return renderTemplateByPosition(position, "joinState", state);
            }
            if (instruction) {
                return renderTemplateByPosition(position, "joinInstruction", instruction);
            }
            return "";
        });
    }
    function ajaxLoad(baseurl) {
        function keys(o) {
            return $.map(o, function(i) {
                return i;
            });
        }
        return q.Promise(function(resolve) {
            var count = 0, expected = 0, toFetch = {
                joinInstruction: keys(model.INSTRUCTION),
                joinState: keys(model.STATE)
            };
            function onAjaxComplete() {
                count += 1;
                if (expected === count) {
                    resolve();
                }
            }
            $.each(toFetch, function(category, values) {
                templates[category] = {};
                $.each([ "head", "main" ], function(placeIdx, place) {
                    templates[category][place] = {};
                    $.each(values, function(valueIdx, value) {
                        var templateFilename = value + ".hbs";
                        expected += 1;
                        $.ajax([ baseurl, category, place, templateFilename ].join("/"), {
                            dataType: "text",
                            success: function(text) {
                                templates[category][place][templateFilename] = Handlebars.compile(text);
                            },
                            complete: onAjaxComplete
                        });
                    });
                });
            });
        });
    }
    var ui = {
        instructions: {
            head: makeRenderFunc("head", "joinInstruction"),
            main: makeRenderFunc("main", "joinInstruction")
        },
        states: {
            head: makeRenderFunc("head", "joinState"),
            main: makeRenderFunc("main", "joinState")
        },
        head: makeComputed("head"),
        main: makeComputed("main"),
        renderTemplateByName: renderTemplateByName,
        ajaxLoad: ajaxLoad,
        products: products,
        usedStrings: usedStrings,
        qa: uiQa
    };
    model.ui = {
        head: ui.head,
        main: ui.main
    };
    return ui;
});
define("launch", ['require','safety','jquery','joiner','launch-model','ui','user-agent-parser','launch-status','launch-telemetry','urls','detector','console','assert','util','third-party/q'],function(require) {
    "use strict";
    var safety = require("safety"), $ = require("jquery"), joiner = require("joiner"), launchModel = require("launch-model"), ui = require("ui"), userAgentParser = require("user-agent-parser"), launchStatus = require("launch-status"), launchTelemetry = require("launch-telemetry"), urls = require("urls"), detector = require("detector"), console = require("console"), assert = require("assert"), util = require("util"), q = require("third-party/q");
    function launchStop() {
        launchStatus.stop();
        launchModel.launchStarted(false);
        launchModel.joinInstruction(null);
        launchModel.joinState(null);
    }
    var launch = safety.collect(function(options) {
        launchTelemetry.markLaunchFunctionCalled();
        launchStop();
        assert("Expected options to be truthy", !!options);
        assert("expected options.token", options.token);
        var joinerIndex = 0, userAgent = options.userAgent;
        if (!options.host) {
            launchModel.host(safety.launcherJsHost);
            assert("Expected host to be given in options; or include launcher.js including the hostname", launchModel.host());
        } else {
            launchModel.host(options.host);
        }
        launchTelemetry.sendJavaScriptStartingTelemetry();
        launchModel.appId(options.appId || null);
        userAgent = $.extend(userAgentParser(navigator.userAgent), userAgent);
        userAgentParser.augment(userAgent);
        console.log("Assuming platform, platformVersion, browser, browserMajorVersion", userAgent.platform, userAgent.platformVersion, userAgent.browser, userAgent.browserVersion);
        launchModel.userAgent(userAgent);
        launchModel.locale(options.locale);
        launchModel.product(options.product);
        launchModel.apiVersion(options.apiVersion);
        launchModel.token(options.token);
        launchModel.endpoint({
            builds: options.builds,
            scheme: options.scheme,
            launchUrl: options.endpointLaunchUrl,
            dontFallbackToBuildsBelow: options.dontFallbackToBuildsBelow
        });
        launchModel.flags({
            disableRedirects: options.disableRedirects ? true : false,
            renameFile: options.renameFile ? true : false,
            dontSetDocumentLocation: options.dontSetDocumentLocation ? true : false,
            assumeClickToPlay: options.assumeClickToPlay ? true : false,
            forceLauncherAppUpdate: options.forceLauncherAppUpdate ? true : false
        });
        launchModel.abTest(options.abTest || {});
        launchModel.allowDownload = options.allowDownload;
        safety.setAugmentedData({
            abbreviatedToken: launchModel.abbreviatedToken(),
            apiVersion: launchModel.apiVersion(),
            locale: launchModel.locale(),
            product: launchModel.product()
        });
        if (options.crash) {
            throw new Error("QA: Crashing in launch() as requested (options.crash is truthy)");
        }
        launchModel.launchStarted(true);
        function invokeJoiner(nextJoiner) {
            try {
                joiner[joinerIndex](nextJoiner);
            } catch (e) {
                console.error("launch.js: Caught error in joiner ", joinerIndex, " ", e);
                safety.sendError(e, "joiner" + joinerIndex);
                nextJoiner();
            }
        }
        function nextJoiner() {
            if (joinerIndex + 1 >= joiner.length) {
                console.error("Already at last joiner. Ignoring. This is a bug: The last joiner must not call next()");
                safety.sendError(null, "afterLastJoiner");
            } else {
                joinerIndex += 1;
                invokeJoiner(nextJoiner);
            }
        }
        if ("g2m_install" === launchModel.product()) {
            console.log("In G2M Install flow. Directly going to auto-download.");
            joinerIndex = joiner.length - 1;
        }
        invokeJoiner(nextJoiner);
    });
    function launchWhenReady(launchOptions) {
        util.runWhenReady(function() {
            launch(launchOptions);
        });
    }
    launchWhenReady.model = launchModel;
    launchWhenReady.urls = urls;
    launchWhenReady.detector = detector;
    launchWhenReady.ui = ui;
    launchWhenReady.stop = launchStop;
    launchWhenReady.q = q;
    launchWhenReady.launchNow = launch;
    return launchWhenReady;
});
define("animated-banners", [ "jquery", "ui", "util", "launch-model", "third-party/q" ], function($, ui, util, launchModel, q) {
    "use strict";
    var lastCloseBannerFunc;
    function move(el, prop, amount, duration, unit) {
        if (!el.style || !window.getComputedStyle) {
            return q.Promise.resolve();
        }
        unit = unit || "";
        var interval = 17, initialValue = window.getComputedStyle(el)[prop], numSteps = Math.ceil(Math.abs(duration / interval)), steps = 0;
        if (initialValue === "auto") {
            initialValue = parseFloat(el.getBoundingClientRect()[prop]) || 0;
        } else {
            initialValue = parseFloat(initialValue) || 0;
        }
        return new q.Promise(function(resolve) {
            var intervalId = window.setInterval(function() {
                steps += 1;
                if (steps >= numSteps) {
                    el.style[prop] = initialValue + amount + unit;
                    window.clearInterval(intervalId);
                    resolve();
                } else {
                    var p = .5 - .5 * Math.cos(steps / numSteps * Math.PI);
                    el.style[prop] = initialValue + p * amount + unit;
                }
            }, interval);
        });
    }
    function makeCloseBannerFunc(div) {
        var el = div[0];
        return function() {
            return move(el, "opacity", -1, 800).then(function() {
                el.parentNode.removeChild(el);
            });
        };
    }
    function closeLastBanner() {
        if (lastCloseBannerFunc) {
            lastCloseBannerFunc();
            lastCloseBannerFunc = null;
        }
    }
    function makeMove(el, prop, amount, duration, unit) {
        return function() {
            return move(el, prop, amount, duration, unit);
        };
    }
    function bounceEffect(div, distance, duration) {
        distance = distance || 60;
        duration = duration || 333;
        div = div[0];
        return move(div, "top", -distance, duration, "px").then(makeMove(div, "top", distance, duration, "px")).then(makeMove(div, "top", -distance / 2, duration, "px")).then(makeMove(div, "top", distance / 2, duration, "px")).then(makeMove(div, "top", -distance / 4, duration, "px")).then(makeMove(div, "top", distance / 4, duration, "px"));
    }
    function appendInstructions(parent, qaMode) {
        if (!util.hasBanner()) {
            return;
        }
        parent = parent || $(".launcher-banner");
        if (!parent.length) {
            return;
        }
        var userAgent = launchModel.userAgent();
        function renderBanner() {
            var width = $(document).width(), div;
            closeLastBanner();
            var divHtml = $.trim(ui.renderTemplateByName("banners"));
            if ($.parseHTML) {
                div = $($.parseHTML(divHtml));
            } else {
                div = $(divHtml);
            }
            parent.append(div);
            if (userAgent.is.MSIE && userAgent.browserVersion >= 9) {
                if (width < 1600) {
                    div.css("right", "26%");
                } else {
                    div.css("right", "32%");
                }
                div.show();
                bounceEffect(div);
            } else if (userAgent.is.MSEDGE) {
                div.css("right", "41%");
                div.show();
                bounceEffect(div);
            } else if (userAgent.is.CHROME) {
                if (userAgent.is.MACOS) {
                    div.css({
                        right: "50px",
                        top: "2%",
                        width: "720px",
                        bottom: "100%"
                    });
                    div.find(".launcher-message-banner").css("height", "100px");
                } else {
                    div.css({
                        right: "50px",
                        top: "2%",
                        bottom: "100%"
                    });
                    div.find(".launcher-message-banner").css("height", "100px");
                }
                div.show();
                bounceEffect(div);
            } else if (userAgent.is.FIREFOX) {
                div.css({
                    right: "50px",
                    top: "2%",
                    width: "720px",
                    bottom: "100%"
                });
                div.find(".launcher-message-banner").css("height", "100px");
                div.show();
                bounceEffect(div, -60);
            } else if (userAgent.is.MACOS && userAgent.is.SAFARI) {
                div.css({
                    right: "97px",
                    top: "2%",
                    width: "800px",
                    bottom: "100%"
                });
                div.find(".launcher-message-banner").css("height", "100px");
                div.show();
                bounceEffect(div, -60);
            }
            lastCloseBannerFunc = makeCloseBannerFunc(div);
            if (qaMode) {
                div.find(".launcher-instructions-banner").click(lastCloseBannerFunc);
            }
        }
        if (qaMode) {
            renderBanner();
        } else {
            setTimeout(renderBanner, 1500);
        }
    }
    return {
        appendInstructions: appendInstructions,
        closeLastBanner: closeLastBanner,
        bounceEffect: bounceEffect
    };
});
define("hooks", ['require','safety','jquery','launch-model','launch-by-click','launch-status','util','launch','urls','console','animated-banners'],function(require) {
    "use strict";
    var safety = require("safety"), $ = require("jquery"), launchModel = require("launch-model"), launchByClick = require("launch-by-click"), launchStatus = require("launch-status"), util = require("util"), launch = require("launch"), urls = require("urls"), console = require("console"), banner = require("animated-banners"), hideBannerAfterJoinInstructionChangesSubscription;
    function showBanner(currentState) {
        banner.closeLastBanner();
        if (currentState.joinInstruction === launchModel.INSTRUCTION.DOWNLOADING && !currentState.joinState && util.hasBanner()) {
            banner.appendInstructions();
            $(".launcher-manual-download-hook").click(function() {
                banner.appendInstructions();
            });
        }
    }
    hideBannerAfterJoinInstructionChangesSubscription = launchModel.currentState.subscribe(safety.collect(showBanner));
    launchModel.launching.subscribe(safety.collect(function(launching) {
        var selector = $(".launcher-head,.launcher-main,.launcher-hooks");
        if (selector.on && selector.off) {
            selector.off("click.launcher", ".launcher-manual-download-hook").off("click.launcher", ".launcher-launch-hook").off("click.launcher", ".launcher-restart-join-flow-hook");
            selector.on("click.launcher", ".launcher-manual-download-hook", function(event) {
                launchModel.joinState(null);
                launchModel.joinInstruction(launchModel.INSTRUCTION.DOWNLOADING);
                launchStatus();
                util.download("restart");
                showBanner(launchModel.currentState());
                event.stopPropagation();
                event.preventDefault();
            }).on("click.launcher", ".launcher-launch-hook", function(event) {
                var trigger = "restart";
                if (event && event.currentTarget && event.currentTarget.tagName) {
                    trigger += "-" + event.currentTarget.tagName;
                }
                launchByClick(trigger);
                event.stopPropagation();
                event.preventDefault();
            }).on("click.launcher", ".launcher-restart-join-flow-hook", function(event) {
                $.ajax(urls.restart(), {
                    type: "GET",
                    dataType: "jsonp",
                    jsonp: "jsonp_callback",
                    success: function(data, status, jqXHR) {
                        launchModel.token(data.token);
                        launch(launchModel.options());
                    }
                });
                event.stopPropagation();
                event.preventDefault();
            }).on("click.launch", "#launcher-clickonce-button", function(event) {
                launchModel.incrementSettingDocumentLocationCount();
                window.setTimeout(function() {
                    launchModel.decrementSettingDocumentLocationCount();
                }, 550);
            });
        } else {
            console.warn("launcher.js: hooks: Can't use $.on, restart and fallback links wont work. Please upgrade to jQuery 1.7+");
        }
    }));
    return {
        cancelHideBannerAfterJoinInstructionChangesSubscription: function() {
            hideBannerAfterJoinInstructionChangesSubscription.dispose();
        }
    };
});
define("launcher", [ "safety", "umd-define", "launch", "hooks" ], function(unused, umdDefine, launch) {
    "use strict";
    umdDefine("launch", launch);
});

(function() {
    "use strict";
    var safety = require("safety");
    safety.reportMissing([ "jQuery", "jQuery", "jQuery.fn.on", "jQuery.isNumeric" ]);
    try {
        require("launcher");
    } catch (e) {
        if (window.console && window.console.error) {
            window.console.error("Launcher: Error requiring embedded launcher: ", e);
        }
        safety.sendError(e, "require-embedded");
    }
})();
}();